//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
  shareReplay,
  map,
} from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { EnvironmentService } from '@abp/ng.core';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
  providedIn: 'root',
})
export class AbpApiDefinitionClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param includeTypes (optional)
   * @return Success
   */
  apiDefinition(includeTypes: boolean | undefined): Observable<ApplicationApiDescriptionModel> {
    let url_ = this.baseUrl + '/api/abp/api-definition?';
    if (includeTypes === null) throw new Error("The parameter 'includeTypes' cannot be null.");
    else if (includeTypes !== undefined)
      url_ += 'IncludeTypes=' + encodeURIComponent('' + includeTypes) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApiDefinition(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApiDefinition(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApplicationApiDescriptionModel>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ApplicationApiDescriptionModel>;
        })
      );
  }

  protected processApiDefinition(
    response: HttpResponseBase
  ): Observable<ApplicationApiDescriptionModel> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationApiDescriptionModel.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ApplicationApiDescriptionModel>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AbpApplicationConfigurationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  applicationConfiguration(): Observable<ApplicationConfigurationDto> {
    let url_ = this.baseUrl + '/api/abp/application-configuration';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApplicationConfiguration(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApplicationConfiguration(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ApplicationConfigurationDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ApplicationConfigurationDto>;
        })
      );
  }

  protected processApplicationConfiguration(
    response: HttpResponseBase
  ): Observable<ApplicationConfigurationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ApplicationConfigurationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ApplicationConfigurationDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AbpTenantClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  byName(name: string): Observable<FindTenantResultDto> {
    let url_ = this.baseUrl + '/api/abp/multi-tenancy/tenants/by-name/{name}';
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace('{name}', encodeURIComponent('' + name));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByName(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByName(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FindTenantResultDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FindTenantResultDto>;
        })
      );
  }

  protected processByName(response: HttpResponseBase): Observable<FindTenantResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FindTenantResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<FindTenantResultDto>(null as any);
  }

  /**
   * @return Success
   */
  byId(id: string): Observable<FindTenantResultDto> {
    let url_ = this.baseUrl + '/api/abp/multi-tenancy/tenants/by-id/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FindTenantResultDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FindTenantResultDto>;
        })
      );
  }

  protected processById(response: HttpResponseBase): Observable<FindTenantResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FindTenantResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<FindTenantResultDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AccountClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  register(body: RegisterDto2 | undefined): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/account/register';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRegister(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRegister(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processRegister(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sendPasswordResetCode(body: SendPasswordResetCodeDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/account/send-password-reset-code';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendPasswordResetCode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendPasswordResetCode(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendPasswordResetCode(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetPassword(body: ResetPasswordDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/account/reset-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppPageClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appPagePost(body: PageCreateUpdateDto | undefined): Observable<PageDto> {
    let url_ = this.baseUrl + '/api/app/app-page';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppPagePost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppPagePost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PageDto>;
        })
      );
  }

  protected processAppPagePost(response: HttpResponseBase): Observable<PageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PageDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  appPageGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-page?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppPageGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppPageGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAppPageGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  appPageDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-page/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppPageDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppPageDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppPageDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appPageGetById(id: string): Observable<PageDto> {
    let url_ = this.baseUrl + '/api/app/app-page/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppPageGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppPageGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PageDto>;
        })
      );
  }

  protected processAppPageGetById(response: HttpResponseBase): Observable<PageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PageDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appPagePut(id: string, body: PageCreateUpdateDto | undefined): Observable<PageDto> {
    let url_ = this.baseUrl + '/api/app/app-page/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppPagePut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppPagePut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PageDto>;
        })
      );
  }

  protected processAppPagePut(response: HttpResponseBase): Observable<PageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PageDto>(null as any);
  }

  /**
   * @param type (optional)
   * @return Success
   */
  byType(type: PageType | undefined): Observable<PageDto> {
    let url_ = this.baseUrl + '/api/app/app-page/by-type?';
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<PageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<PageDto>;
        })
      );
  }

  protected processByType(response: HttpResponseBase): Observable<PageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = PageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PageDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppTemplateClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appTemplatePost(body: TemplateCreateUpdateDto | undefined): Observable<TemplateDto> {
    let url_ = this.baseUrl + '/api/app/app-template';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppTemplatePost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppTemplatePost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateDto>;
        })
      );
  }

  protected processAppTemplatePost(response: HttpResponseBase): Observable<TemplateDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TemplateDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  appTemplateGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-template?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppTemplateGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppTemplateGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAppTemplateGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  appTemplateDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-template/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppTemplateDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppTemplateDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppTemplateDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appTemplateGetById(id: string): Observable<TemplateDto> {
    let url_ = this.baseUrl + '/api/app/app-template/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppTemplateGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppTemplateGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateDto>;
        })
      );
  }

  protected processAppTemplateGetById(response: HttpResponseBase): Observable<TemplateDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TemplateDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appTemplatePut(id: string, body: TemplateCreateUpdateDto | undefined): Observable<TemplateDto> {
    let url_ = this.baseUrl + '/api/app/app-template/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppTemplatePut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppTemplatePut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateDto>;
        })
      );
  }

  protected processAppTemplatePut(response: HttpResponseBase): Observable<TemplateDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TemplateDto>(null as any);
  }

  /**
   * @param type (optional)
   * @return Success
   */
  parameters(type: TemplateType | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/app/app-template/parameters?';
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processParameters(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processParameters(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processParameters(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @param type (optional)
   * @return Success
   */
  byType(type: TemplateType | undefined): Observable<TemplateDto> {
    let url_ = this.baseUrl + '/api/app/app-template/by-type?';
    if (type === null) throw new Error("The parameter 'type' cannot be null.");
    else if (type !== undefined) url_ += 'type=' + encodeURIComponent('' + type) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByType(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByType(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TemplateDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TemplateDto>;
        })
      );
  }

  protected processByType(response: HttpResponseBase): Observable<TemplateDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TemplateDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TemplateDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserContactUsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contactUs(body: ContactUsDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/contact-us';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContactUs(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContactUs(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContactUs(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserEducationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserEducationPost(body: AppUserEducationCreateUpdateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-education';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserEducationPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserEducationPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserEducationPost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appUserEducationGet(): Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-user-education';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserEducationGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserEducationGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAppUserEducationGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  appUserEducationDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-education/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserEducationDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserEducationDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserEducationDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appUserEducationGetById(id: string): Observable<AppUserEducationDto> {
    let url_ = this.baseUrl + '/api/app/app-user-education/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserEducationGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserEducationGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserEducationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserEducationDto>;
        })
      );
  }

  protected processAppUserEducationGetById(
    response: HttpResponseBase
  ): Observable<AppUserEducationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserEducationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserEducationDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserEducationPut(
    id: string,
    body: AppUserEducationCreateUpdateDto | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-education/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserEducationPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserEducationPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserEducationPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  byUsername(
    userName: string
  ): Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-user-education/by-username/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByUsername(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processByUsername(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  latestByUsername(userName: string): Observable<AppUserEducationDto> {
    let url_ = this.baseUrl + '/api/app/app-user-education/latest-by-username/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLatestByUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLatestByUsername(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserEducationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserEducationDto>;
        })
      );
  }

  protected processLatestByUsername(response: HttpResponseBase): Observable<AppUserEducationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserEducationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserEducationDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserPreviewClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  appUserPreviewGet(): Observable<AppUserPreviewDto> {
    let url_ = this.baseUrl + '/api/app/app-user-preview';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserPreviewGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserPreviewGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserPreviewDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserPreviewDto>;
        })
      );
  }

  protected processAppUserPreviewGet(response: HttpResponseBase): Observable<AppUserPreviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserPreviewDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserPreviewDto>(null as any);
  }

  /**
   * @return Success
   */
  appUserPreviewGetByUserName(userName: string): Observable<AppUserPreviewDto> {
    let url_ = this.baseUrl + '/api/app/app-user-preview/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserPreviewGetByUserName(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserPreviewGetByUserName(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserPreviewDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserPreviewDto>;
        })
      );
  }

  protected processAppUserPreviewGetByUserName(
    response: HttpResponseBase
  ): Observable<AppUserPreviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserPreviewDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserPreviewDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserNotificationSettingClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  appUserNotificationSettingsGet(): Observable<AppUserNotificationSettingDto[]> {
    let url_ = this.baseUrl + '/api/app/app-user-notification-settings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserNotificationSettingsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserNotificationSettingsGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserNotificationSettingDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<AppUserNotificationSettingDto[]>;
        })
      );
  }

  protected processAppUserNotificationSettingsGet(
    response: HttpResponseBase
  ): Observable<AppUserNotificationSettingDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(AppUserNotificationSettingDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserNotificationSettingDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserNotificationSettingsPut(
    body: AppUserNotificationSettingUpdateDto[] | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-notification-settings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserNotificationSettingsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserNotificationSettingsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserNotificationSettingsPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserPrivacySettingClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  appUserPrivacySettingsGet(): Observable<AppUserPrivacySettingDto[]> {
    let url_ = this.baseUrl + '/api/app/app-user-privacy-settings';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserPrivacySettingsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserPrivacySettingsGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserPrivacySettingDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<AppUserPrivacySettingDto[]>;
        })
      );
  }

  protected processAppUserPrivacySettingsGet(
    response: HttpResponseBase
  ): Observable<AppUserPrivacySettingDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AppUserPrivacySettingDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserPrivacySettingDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserPrivacySettingsPut(body: AppUserPrivacySettingUpdateDto[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-privacy-settings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserPrivacySettingsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserPrivacySettingsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserPrivacySettingsPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserPrivacySettingsPost(body: AppUserPrivacySettingUpdateDto[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-privacy-settings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserPrivacySettingsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserPrivacySettingsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserPrivacySettingsPost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appUserPrivacySettingsGetByUserId(userId: string): Observable<AppUserPrivacySettingDto[]> {
    let url_ = this.baseUrl + '/api/app/app-user-privacy-settings/{userId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserPrivacySettingsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserPrivacySettingsGetByUserId(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserPrivacySettingDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<AppUserPrivacySettingDto[]>;
        })
      );
  }

  protected processAppUserPrivacySettingsGetByUserId(
    response: HttpResponseBase
  ): Observable<AppUserPrivacySettingDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AppUserPrivacySettingDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserPrivacySettingDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  apply(body: AppUserProfileDto | undefined): Observable<AppUserPreviewProfileDto> {
    let url_ = this.baseUrl + '/api/app/app-user-privacy-settings/apply';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApply(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApply(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserPreviewProfileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserPreviewProfileDto>;
        })
      );
  }

  protected processApply(response: HttpResponseBase): Observable<AppUserPreviewProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserPreviewProfileDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserPreviewProfileDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserProfileClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  searchUser(searchedKey: string, pageSize = 10): Observable<any> {
    const URL = `${this.baseUrl}/api/app/app-user-profile/users/${searchedKey}?takeCount=${pageSize}`;
    return this.http.get(URL, {});
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserProfilePut(body: AppUserProfileCreateUpdateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-profile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserProfilePut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserProfilePut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserProfilePut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appUserProfileGet(): Observable<AppUserProfileDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserProfileGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserProfileGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserProfileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserProfileDto>;
        })
      );
  }

  protected processAppUserProfileGet(response: HttpResponseBase): Observable<AppUserProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserProfileDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserProfileDto>(null as any);
  }

  /**
   * @return Success
   */
  userCanChangeUsernameGet(): Observable<CanUserChangeUserNameDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/user-can-change-username';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserCanChangeUsernameGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserCanChangeUsernameGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CanUserChangeUserNameDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CanUserChangeUserNameDto>;
        })
      );
  }

  protected processUserCanChangeUsernameGet(
    response: HttpResponseBase
  ): Observable<CanUserChangeUserNameDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CanUserChangeUserNameDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CanUserChangeUserNameDto>(null as any);
  }

  /**
   * @return Success
   */
  userCanChangeUsernameGetByUserId(userId: string): Observable<CanUserChangeUserNameDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/user-can-change-username/{userId}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserCanChangeUsernameGetByUserId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserCanChangeUsernameGetByUserId(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CanUserChangeUserNameDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CanUserChangeUserNameDto>;
        })
      );
  }

  protected processUserCanChangeUsernameGetByUserId(
    response: HttpResponseBase
  ): Observable<CanUserChangeUserNameDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CanUserChangeUserNameDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CanUserChangeUserNameDto>(null as any);
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  resetCounterChangeUsername(userId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/reset-counter-change-username?';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetCounterChangeUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetCounterChangeUsername(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResetCounterChangeUsername(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param userId (optional)
   * @return Success
   */
  disableChangeUsername(userId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/disable-change-username?';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDisableChangeUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDisableChangeUsername(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDisableChangeUsername(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  usernameIsUnique(userName: string): Observable<ResponseUserNameIsUniqueDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/username-is-unique/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsernameIsUnique(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsernameIsUnique(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ResponseUserNameIsUniqueDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ResponseUserNameIsUniqueDto>;
        })
      );
  }

  protected processUsernameIsUnique(
    response: HttpResponseBase
  ): Observable<ResponseUserNameIsUniqueDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ResponseUserNameIsUniqueDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ResponseUserNameIsUniqueDto>(null as any);
  }

  /**
   * @return Success
   */
  appUserProfileGetById(id: string): Observable<AppUserProfileDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserProfileGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserProfileGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserProfileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserProfileDto>;
        })
      );
  }

  protected processAppUserProfileGetById(
    response: HttpResponseBase
  ): Observable<AppUserProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserProfileDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserProfileDto>(null as any);
  }

  /**
   * @return Success
   */
  byUsername(userName: string): Observable<AppUserProfileDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/by-username/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByUsername(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserProfileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserProfileDto>;
        })
      );
  }

  protected processByUsername(response: HttpResponseBase): Observable<AppUserProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserProfileDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserProfileDto>(null as any);
  }

  /**
   * @return Success
   */
  programmingLanguages(): Observable<
    LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    let url_ = this.baseUrl + '/api/app/app-user-profile/programming-languages';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguages(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguages(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
            >;
        })
      );
  }

  protected processProgrammingLanguages(
    response: HttpResponseBase
  ): Observable<
    LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<
      LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    >(null as any);
  }

  /**
   * @return Success
   */
  citiesLookup(): Observable<
    LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    let url_ = this.baseUrl + '/api/app/app-user-profile/cities-lookup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCitiesLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCitiesLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
            >;
        })
      );
  }

  protected processCitiesLookup(
    response: HttpResponseBase
  ): Observable<
    LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<
      LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    >(null as any);
  }

  /**
   * @param fileType (optional)
   * @param body (optional)
   * @return Success
   */
  profilePicture(fileType: string | undefined, body: string | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/profile-picture?';
    if (fileType === null) throw new Error("The parameter 'fileType' cannot be null.");
    else if (fileType !== undefined) url_ += 'fileType=' + encodeURIComponent('' + fileType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProfilePicture(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProfilePicture(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processProfilePicture(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @param file (optional)
   * @return Success
   */
  uploadProfilePicture(file: FileParameter | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/upload-profile-picture';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else content_.append('File', file.data, file.fileName ? file.fileName : 'File');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadProfilePicture(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadProfilePicture(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processUploadProfilePicture(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 = _responseText === '' ? null : _responseText;
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @return Success
   */
  lastOnlineDate(): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/last-online-date';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLastOnlineDate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLastOnlineDate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processLastOnlineDate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  skipGetStartedProblemStatus(): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/skip-get-started-problem-status';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSkipGetStartedProblemStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSkipGetStartedProblemStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSkipGetStartedProblemStatus(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  getStartedProblemStatus(): Observable<GetStartedProblemStatusResponseDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/get-started-problem-status';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetStartedProblemStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetStartedProblemStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetStartedProblemStatusResponseDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<GetStartedProblemStatusResponseDto>;
        })
      );
  }

  protected processGetStartedProblemStatus(
    response: HttpResponseBase
  ): Observable<GetStartedProblemStatusResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetStartedProblemStatusResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetStartedProblemStatusResponseDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  users(
    filter: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/users?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsers(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processUsers(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  usersWithRestrictedInfo(
    filter: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/users-with-restricted-info?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersWithRestrictedInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersWithRestrictedInfo(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processUsersWithRestrictedInfo(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  lastPasswordChangeDate(): Observable<AppUserProfileLastPasswordChangeDateDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/last-password-change-date';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLastPasswordChangeDate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLastPasswordChangeDate(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<AppUserProfileLastPasswordChangeDateDto>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<AppUserProfileLastPasswordChangeDateDto>;
        })
      );
  }

  protected processLastPasswordChangeDate(
    response: HttpResponseBase
  ): Observable<AppUserProfileLastPasswordChangeDateDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserProfileLastPasswordChangeDateDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserProfileLastPasswordChangeDateDto>(null as any);
  }

  /**
   * @return Success
   */
  userWithRestrictedInfo(id: string): Observable<IdentityUserRestrictedDto> {
    let url_ = this.baseUrl + '/api/app/app-user-profile/user-with-restricted-info/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserWithRestrictedInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserWithRestrictedInfo(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserRestrictedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserRestrictedDto>;
        })
      );
  }

  protected processUserWithRestrictedInfo(
    response: HttpResponseBase
  ): Observable<IdentityUserRestrictedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserRestrictedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserRestrictedDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserSocialAccountsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserSocialAccountsPut(
    body: AppUserSocialAccountsCreateUpdateDto[] | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-social-accounts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserSocialAccountsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserSocialAccountsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserSocialAccountsPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appUserSocialAccountsGet(): Observable<AppUserSocialAccountDto[]> {
    let url_ = this.baseUrl + '/api/app/app-user-social-accounts';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserSocialAccountsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserSocialAccountsGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserSocialAccountDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserSocialAccountDto[]>;
        })
      );
  }

  protected processAppUserSocialAccountsGet(
    response: HttpResponseBase
  ): Observable<AppUserSocialAccountDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(AppUserSocialAccountDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserSocialAccountDto[]>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserTeamClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserTeamPost(body: TeamCreateUpdateRequestDto | undefined): Observable<TeamDto> {
    let url_ = this.baseUrl + '/api/app/app-user-team';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamDto>;
        })
      );
  }

  protected processAppUserTeamPost(response: HttpResponseBase): Observable<TeamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TeamDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param userName (optional)
   * @return Success
   */
  appUserTeamGet(
    filter: string | undefined,
    userName: string | undefined
  ): Observable<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-user-team?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAppUserTeamGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  appUserTeamDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-team/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserTeamDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appUserTeamGetById(id: string): Observable<TeamDto> {
    let url_ = this.baseUrl + '/api/app/app-user-team/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamDto>;
        })
      );
  }

  protected processAppUserTeamGetById(response: HttpResponseBase): Observable<TeamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TeamDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserTeamPut(id: string, body: TeamCreateUpdateRequestDto | undefined): Observable<TeamDto> {
    let url_ = this.baseUrl + '/api/app/app-user-team/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamDto>;
        })
      );
  }

  protected processAppUserTeamPut(response: HttpResponseBase): Observable<TeamDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TeamDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamDto>(null as any);
  }

  /**
   * @return Success
   */
  leave(teamId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-team/{teamId}/leave';
    if (teamId === undefined || teamId === null)
      throw new Error("The parameter 'teamId' must be defined.");
    url_ = url_.replace('{teamId}', encodeURIComponent('' + teamId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLeave(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLeave(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processLeave(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  preview(id: string): Observable<TeamPreviewDto> {
    let url_ = this.baseUrl + '/api/app/app-user-team/preview/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPreview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPreview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamPreviewDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamPreviewDto>;
        })
      );
  }

  protected processPreview(response: HttpResponseBase): Observable<TeamPreviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TeamPreviewDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamPreviewDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserTeamMemberClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  appUserTeamMemberPost(body: TeamMemberRequestDto | undefined): Observable<TeamMemberDto> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamMemberPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamMemberPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamMemberDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamMemberDto>;
        })
      );
  }

  protected processAppUserTeamMemberPost(response: HttpResponseBase): Observable<TeamMemberDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TeamMemberDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamMemberDto>(null as any);
  }

  /**
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  appUserTeamMemberGetByList(
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member?';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamMemberGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamMemberGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAppUserTeamMemberGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return Success
   */
  appUserTeamMemberPut(
    id: string | undefined,
    body: TeamMemberRequestDto | undefined
  ): Observable<TeamMemberDto> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamMemberPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamMemberPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamMemberDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamMemberDto>;
        })
      );
  }

  protected processAppUserTeamMemberPut(response: HttpResponseBase): Observable<TeamMemberDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TeamMemberDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamMemberDto>(null as any);
  }

  /**
   * @return Success
   */
  appUserTeamMemberDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamMemberDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamMemberDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAppUserTeamMemberDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  appUserTeamMemberGetById(id: string): Observable<TeamMemberDto> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAppUserTeamMemberGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAppUserTeamMemberGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamMemberDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamMemberDto>;
        })
      );
  }

  protected processAppUserTeamMemberGetById(response: HttpResponseBase): Observable<TeamMemberDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TeamMemberDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamMemberDto>(null as any);
  }

  /**
   * @return Success
   */
  details(teamId: string): Observable<TeamMemberDetailedDto[]> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member/{teamId}/details';
    if (teamId === undefined || teamId === null)
      throw new Error("The parameter 'teamId' must be defined.");
    url_ = url_.replace('{teamId}', encodeURIComponent('' + teamId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDetails(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDetails(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamMemberDetailedDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamMemberDetailedDto[]>;
        })
      );
  }

  protected processDetails(response: HttpResponseBase): Observable<TeamMemberDetailedDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(TeamMemberDetailedDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamMemberDetailedDto[]>(null as any);
  }

  /**
   * @return Success
   */
  members(teamId: string): Observable<string[]> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member/{teamId}/members';
    if (teamId === undefined || teamId === null)
      throw new Error("The parameter 'teamId' must be defined.");
    url_ = url_.replace('{teamId}', encodeURIComponent('' + teamId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMembers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMembers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processMembers(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
   * @return Success
   */
  preview(teamId: string): Observable<TeamMemberPreviewDto[]> {
    let url_ = this.baseUrl + '/api/app/app-user-team-member/{teamId}/preview';
    if (teamId === undefined || teamId === null)
      throw new Error("The parameter 'teamId' must be defined.");
    url_ = url_.replace('{teamId}', encodeURIComponent('' + teamId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPreview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPreview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TeamMemberPreviewDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<TeamMemberPreviewDto[]>;
        })
      );
  }

  protected processPreview(response: HttpResponseBase): Observable<TeamMemberPreviewDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(TeamMemberPreviewDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TeamMemberPreviewDto[]>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class AppUserWorkExperienceClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  userWorkExperiencePost(body: AppUserWorkExperienceCreateUpdateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/user-work-experience';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserWorkExperiencePost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserWorkExperiencePost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUserWorkExperiencePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  userWorkExperienceGet(): Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/user-work-experience';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserWorkExperienceGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserWorkExperienceGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processUserWorkExperienceGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  userWorkExperienceDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/user-work-experience/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserWorkExperienceDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserWorkExperienceDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUserWorkExperienceDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  userWorkExperienceGetById(id: string): Observable<AppUserWorkExperienceDto> {
    let url_ = this.baseUrl + '/api/app/user-work-experience/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserWorkExperienceGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserWorkExperienceGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AppUserWorkExperienceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AppUserWorkExperienceDto>;
        })
      );
  }

  protected processUserWorkExperienceGetById(
    response: HttpResponseBase
  ): Observable<AppUserWorkExperienceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AppUserWorkExperienceDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AppUserWorkExperienceDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  userWorkExperiencePut(
    id: string,
    body: AppUserWorkExperienceCreateUpdateDto | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/user-work-experience/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUserWorkExperiencePut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUserWorkExperiencePut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUserWorkExperiencePut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  byUsername(
    userName: string
  ): Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/user-work-experience/by-username/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByUsername(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processByUsername(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuditLogClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  auditLogsGetById(id: string): Observable<AuditLogDetailedDto> {
    let url_ = this.baseUrl + '/api/app/audit-logs/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuditLogsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuditLogsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AuditLogDetailedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AuditLogDetailedDto>;
        })
      );
  }

  protected processAuditLogsGetById(response: HttpResponseBase): Observable<AuditLogDetailedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuditLogDetailedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AuditLogDetailedDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  auditLogsPut(id: string, body: AuditLogDto | undefined): Observable<AuditLogDetailedDto> {
    let url_ = this.baseUrl + '/api/app/audit-logs/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuditLogsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuditLogsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AuditLogDetailedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AuditLogDetailedDto>;
        })
      );
  }

  protected processAuditLogsPut(response: HttpResponseBase): Observable<AuditLogDetailedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuditLogDetailedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AuditLogDetailedDto>(null as any);
  }

  /**
   * @return Success
   */
  auditLogsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/audit-logs/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuditLogsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuditLogsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAuditLogsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  auditLogsGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/audit-logs?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuditLogsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuditLogsGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAuditLogsGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  auditLogsPost(body: AuditLogDto | undefined): Observable<AuditLogDetailedDto> {
    let url_ = this.baseUrl + '/api/app/audit-logs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuditLogsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuditLogsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<AuditLogDetailedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<AuditLogDetailedDto>;
        })
      );
  }

  protected processAuditLogsPost(response: HttpResponseBase): Observable<AuditLogDetailedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = AuditLogDetailedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AuditLogDetailedDto>(null as any);
  }

  /**
   * @return Success
   */
  actions(
    id: string
  ): Observable<PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/audit-logs/{id}/actions';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processActions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processActions(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processActions(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class AuthClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  auth(body: RegisterDto | undefined): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/app/auth';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processAuth(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }

  /**
   * @return Success
   */
  byEmail(email: string): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/app/auth/by-email/{email}';
    if (email === undefined || email === null)
      throw new Error("The parameter 'email' must be defined.");
    url_ = url_.replace('{email}', encodeURIComponent('' + email));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByEmail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByEmail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processByEmail(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  forgotPassword(body: ForgotPasswordDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/auth/forgot-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processForgotPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processForgotPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processForgotPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  resetPassword(body: ResetPasswordDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/auth/reset-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResetPassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResetPassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResetPassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  emailConfirm(userId: string, code: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/auth/email-confirm/{userId}/{code}';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (code === undefined || code === null)
      throw new Error("The parameter 'code' must be defined.");
    url_ = url_.replace('{code}', encodeURIComponent('' + code));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailConfirm(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailConfirm(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processEmailConfirm(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  resendEmailConfirmation(email: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/auth/resend-email-confirmation/{email}';
    if (email === undefined || email === null)
      throw new Error("The parameter 'email' must be defined.");
    url_ = url_.replace('{email}', encodeURIComponent('' + email));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processResendEmailConfirmation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processResendEmailConfirmation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processResendEmailConfirmation(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class CitiesClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  citiesPost(body: CityCreateUpdateDto | undefined): Observable<CityDto> {
    let url_ = this.baseUrl + '/api/app/cities';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCitiesPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCitiesPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CityDto>;
        })
      );
  }

  protected processCitiesPost(response: HttpResponseBase): Observable<CityDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CityDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  citiesGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/cities?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCitiesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCitiesGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processCitiesGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  citiesDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/cities/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCitiesDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCitiesDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCitiesDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  citiesGetById(id: string): Observable<CityDto> {
    let url_ = this.baseUrl + '/api/app/cities/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCitiesGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCitiesGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CityDto>;
        })
      );
  }

  protected processCitiesGetById(response: HttpResponseBase): Observable<CityDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CityDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  citiesPut(id: string, body: CityCreateUpdateDto | undefined): Observable<CityDto> {
    let url_ = this.baseUrl + '/api/app/cities/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCitiesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCitiesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CityDto>;
        })
      );
  }

  protected processCitiesPut(response: HttpResponseBase): Observable<CityDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CityDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CityDto>(null as any);
  }

  /**
   * @return Success
   */
  byCountryId(countryId: string): Observable<CityDto[]> {
    let url_ = this.baseUrl + '/by-country-id/{countryId}';
    if (countryId === undefined || countryId === null)
      throw new Error("The parameter 'countryId' must be defined.");
    url_ = url_.replace('{countryId}', encodeURIComponent('' + countryId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByCountryId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByCountryId(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CityDto[]>;
        })
      );
  }

  protected processByCountryId(response: HttpResponseBase): Observable<CityDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(CityDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CityDto[]>(null as any);
  }

  /**
   * @return Success
   */
  countryLookup(): Observable<ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/cities/country-lookup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountryLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountryLookup(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processCountryLookup(
    response: HttpResponseBase
  ): Observable<ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContestAnnouncementClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsAnnouncementPost(
    body: ContestAnnouncementCreateDto | undefined
  ): Observable<ContestAnnouncementDto> {
    let url_ = this.baseUrl + '/api/app/contests-announcement';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsAnnouncementPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsAnnouncementPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestAnnouncementDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestAnnouncementDto>;
        })
      );
  }

  protected processContestsAnnouncementPost(
    response: HttpResponseBase
  ): Observable<ContestAnnouncementDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestAnnouncementDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestAnnouncementDto>(null as any);
  }

  private contestsAnnouncementGetByListCache$: Observable<PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
  private contestsAnnouncementGetByListUrl = '';
  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestsAnnouncementGetByList(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-announcement?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    if (
      !this.contestsAnnouncementGetByListCache$ ||
      this.contestsAnnouncementGetByListUrl != url_
    ) {
      this.contestsAnnouncementGetByListUrl = url_;
      this.contestsAnnouncementGetByListCache$ = this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processContestsAnnouncementGetByList(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processContestsAnnouncementGetByList(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e
                ) as any as Observable<PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
              }
            } else
              return _observableThrow(
                response_
              ) as any as Observable<PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
          })
        );
    }

    return this.contestsAnnouncementGetByListCache$;
  }

  protected processContestsAnnouncementGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  contestsAnnouncementDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-announcement/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsAnnouncementDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsAnnouncementDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsAnnouncementDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  contestsAnnouncementGetById(id: string): Observable<ContestAnnouncementDto> {
    let url_ = this.baseUrl + '/api/app/contests-announcement/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsAnnouncementGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsAnnouncementGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestAnnouncementDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestAnnouncementDto>;
        })
      );
  }

  protected processContestsAnnouncementGetById(
    response: HttpResponseBase
  ): Observable<ContestAnnouncementDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestAnnouncementDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestAnnouncementDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsAnnouncementPut(
    id: string,
    body: ContestAnnouncementUpdateDto | undefined
  ): Observable<ContestAnnouncementDto> {
    let url_ = this.baseUrl + '/api/app/contests-announcement/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsAnnouncementPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsAnnouncementPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestAnnouncementDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestAnnouncementDto>;
        })
      );
  }

  protected processContestsAnnouncementPut(
    response: HttpResponseBase
  ): Observable<ContestAnnouncementDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestAnnouncementDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestAnnouncementDto>(null as any);
  }

  /**
   * @return Success
   */
  contestsAnnouncementRead(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-announcement/{id}/read';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestAnnouncementRead(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestAnnouncementRead(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestAnnouncementRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  authList(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-announcement/authList?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAuthList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  full(id: string): Observable<ContestAnnouncementFullDto> {
    let url_ = this.baseUrl + '/api/app/contests-announcement/{id}/full';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFull(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFull(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestAnnouncementFullDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ContestAnnouncementFullDto>;
        })
      );
  }

  protected processFull(response: HttpResponseBase): Observable<ContestAnnouncementFullDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestAnnouncementFullDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestAnnouncementFullDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContestClarificationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsClarificationPost(
    body: ContestClarificationCreateDto | undefined
  ): Observable<ContestClarificationDto> {
    let url_ = this.baseUrl + '/api/app/contests-clarification';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsClarificationPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsClarificationPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestClarificationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestClarificationDto>;
        })
      );
  }

  protected processContestsClarificationPost(
    response: HttpResponseBase
  ): Observable<ContestClarificationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestClarificationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestClarificationDto>(null as any);
  }


  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestsClarificationGetByList(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined,
  ): Observable<PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-clarification?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };
    return this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processContestsClarificationGetByList(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processContestsClarificationGetByList(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e
                ) as any as Observable<PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
              }
            } else
              return _observableThrow(
                response_
              ) as any as Observable<PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
          })
        );

  }

  protected processContestsClarificationGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  contestsClarificationDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-clarification/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsClarificationDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsClarificationDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsClarificationDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  contestsClarificationGetById(id: string): Observable<ContestClarificationDto> {
    let url_ = this.baseUrl + '/api/app/contests-clarification/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsClarificationGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsClarificationGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestClarificationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestClarificationDto>;
        })
      );
  }

  protected processContestsClarificationGetById(
    response: HttpResponseBase
  ): Observable<ContestClarificationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestClarificationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestClarificationDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsClarificationPut(
    id: string,
    body: ContestClarificationUpdateDto | undefined
  ): Observable<ContestClarificationDto> {
    let url_ = this.baseUrl + '/api/app/contests-clarification/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsClarificationPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsClarificationPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestClarificationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestClarificationDto>;
        })
      );
  }

  protected processContestsClarificationPut(
    response: HttpResponseBase
  ): Observable<ContestClarificationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestClarificationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestClarificationDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  answer(id: string, body: ContestClarificationAnswerDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-clarification/answer/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAnswer(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAnswer(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAnswer(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  clarificationRead(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-clarification/{id}/read';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processClarificationRead(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processClarificationRead(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processClarificationRead(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  authList(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-clarification/authList?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAuthList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContestCoSetterClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  contestsCoSetterGetById(id: string): Observable<ContestCoSetterDto> {
    let url_ = this.baseUrl + '/api/app/contests-co-setter/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsCoSetterGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsCoSetterGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestCoSetterDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestCoSetterDto>;
        })
      );
  }

  protected processContestsCoSetterGetById(
    response: HttpResponseBase
  ): Observable<ContestCoSetterDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestCoSetterDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestCoSetterDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsCoSetterPut(
    id: string,
    body: ContestCoSetterCreateDto | undefined
  ): Observable<ContestCoSetterDto> {
    let url_ = this.baseUrl + '/api/app/contests-co-setter/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsCoSetterPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsCoSetterPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestCoSetterDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestCoSetterDto>;
        })
      );
  }

  protected processContestsCoSetterPut(response: HttpResponseBase): Observable<ContestCoSetterDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestCoSetterDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestCoSetterDto>(null as any);
  }

  /**
   * @return Success
   */
  contestsCoSetterDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-co-setter/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsCoSetterDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsCoSetterDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsCoSetterDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestsCoSetterGetByList(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-co-setter?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsCoSetterGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsCoSetterGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processContestsCoSetterGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsCoSetterPost(body: ContestCoSetterCreateDto | undefined): Observable<ContestCoSetterDto> {
    let url_ = this.baseUrl + '/api/app/contests-co-setter';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsCoSetterPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsCoSetterPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestCoSetterDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestCoSetterDto>;
        })
      );
  }

  protected processContestsCoSetterPost(
    response: HttpResponseBase
  ): Observable<ContestCoSetterDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestCoSetterDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestCoSetterDto>(null as any);
  }

  /**
   * @return Success
   */
  sendApproval(contestId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-co-setter/{contestId}/send-approval';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendApproval(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendApproval(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendApproval(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  approvalRequest(contestId: string): Observable<CoSetterApprovalDto> {
    let url_ = this.baseUrl + '/api/app/contests-co-setter/{contestId}/approval-request';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processApprovalRequest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processApprovalRequest(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CoSetterApprovalDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CoSetterApprovalDto>;
        })
      );
  }

  protected processApprovalRequest(response: HttpResponseBase): Observable<CoSetterApprovalDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CoSetterApprovalDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CoSetterApprovalDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContestProblemClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  contestsProblemGet(id: string): Observable<ContestProblemDto> {
    let url_ = this.baseUrl + '/api/app/contests-problem/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsProblemGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsProblemGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestProblemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestProblemDto>;
        })
      );
  }

  protected processContestsProblemGet(response: HttpResponseBase): Observable<ContestProblemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestProblemDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestProblemDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsProblemPut(
    id: string,
    body: ContestProblemUpdateDto | undefined
  ): Observable<ContestProblemDto> {
    let url_ = this.baseUrl + '/api/app/contests-problem/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsProblemPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsProblemPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestProblemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestProblemDto>;
        })
      );
  }

  protected processContestsProblemPut(response: HttpResponseBase): Observable<ContestProblemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestProblemDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestProblemDto>(null as any);
  }

  /**
   * @return Success
   */
  contestsProblemDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-problem/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsProblemDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsProblemDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsProblemDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param teamId (optional)
   * @return Success
   */
  contestsProblemGetByList(
    contestId: string | undefined,
    teamId: string | undefined
  ): Observable<PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-problem?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (teamId === null) throw new Error("The parameter 'teamId' cannot be null.");
    else if (teamId !== undefined) url_ += 'TeamId=' + encodeURIComponent('' + teamId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        shareReplay(1),
        _observableMergeMap((response_: any) => {
          return this.processContestsProblemGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsProblemGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processContestsProblemGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsProblemPost(body: ContestProblemCreateDto | undefined): Observable<ContestProblemDto> {
    let url_ = this.baseUrl + '/api/app/contests-problem';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsProblemPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsProblemPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestProblemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestProblemDto>;
        })
      );
  }

  protected processContestsProblemPost(response: HttpResponseBase): Observable<ContestProblemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestProblemDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestProblemDto>(null as any);
  }

  /**
   * @param contestId (optional)
   * @return Success
   */
  getProblemsInfo(
    contestId: string | undefined
  ): Observable<ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-problem/get-problems-info?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetProblemsInfo(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetProblemsInfo(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processGetProblemsInfo(
    response: HttpResponseBase
  ): Observable<ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  orderIndex(id: string, newPosition: number): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-problem/{id}/order-index/{newPosition}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (newPosition === undefined || newPosition === null)
      throw new Error("The parameter 'newPosition' must be defined.");
    url_ = url_.replace('{newPosition}', encodeURIComponent('' + newPosition));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processOrderIndex(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processOrderIndex(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processOrderIndex(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  canReadContestProblems(contestId: string): Observable<boolean> {
    let url_ = this.baseUrl + '/api/app/contests-problem/can-read-contest-problems/{contestId}';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCanReadContestProblems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCanReadContestProblems(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processCanReadContestProblems(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @return Success
   */
  problemId(contestId: string, problemId: string): Observable<ContestProblemDto> {
    let url_ =
      this.baseUrl + '/api/app/contests-problem/by-ids/contestId/{contestId}/problemId/{problemId}';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemId(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestProblemDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestProblemDto>;
        })
      );
  }

  protected processProblemId(response: HttpResponseBase): Observable<ContestProblemDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestProblemDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestProblemDto>(null as any);
  }
}

export interface IContestUser {
  id: number;
  name: string;
  userName: string;
}

@Injectable({
  providedIn: 'root',
})
export class ContestsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  getConstestUsers(
    contestId: string | undefined,
    filteredUsers: string | undefined = '',
    skipCount: number | undefined = 0,
    maxResultCount: number | undefined = 50,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<IContestUser[]> {
    let url_ = `${this.baseUrl}/api/app/contests/${contestId}/users?`;
    if (filteredUsers === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filteredUsers !== undefined)
      url_ += 'Filter=' + encodeURIComponent('' + filteredUsers) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    return this.http
      .request('get', url_)
      .pipe(map((result: any) => result.items as IContestUser[]));
  }

  /**
   * @return Success
   */
  contestsGetById(id: string): Observable<ContestDetailsDto> {
    let url_ = this.baseUrl + '/api/app/contests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestDetailsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestDetailsDto>;
        })
      );
  }

  protected processContestsGetById(response: HttpResponseBase): Observable<ContestDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestDetailsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestDetailsDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param status (optional)
   * @param contestScoring (optional)
   * @param contestActivity (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestsGetByList(
    filter: string | undefined,
    status: ContestStatus | undefined,
    contestScoring: ContestScoring | undefined,
    contestActivity: ContestActivity | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests?Content=Contest&';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (contestScoring === null) throw new Error("The parameter 'contestScoring' cannot be null.");
    else if (contestScoring !== undefined)
      url_ += 'ContestScoring=' + encodeURIComponent('' + contestScoring) + '&';
    if (contestActivity === null)
      throw new Error("The parameter 'contestActivity' cannot be null.");
    else if (contestActivity !== undefined)
      url_ += 'ContestActivity=' + encodeURIComponent('' + contestActivity) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        shareReplay(1),
        _observableMergeMap((response_: any) => {
          return this.processContestsGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processContestsGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsPost(body: ContestCreateDto | undefined): Observable<ContestDetailsDto> {
    let url_ = this.baseUrl + '/api/app/contests';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestDetailsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestDetailsDto>;
        })
      );
  }

  protected processContestsPost(response: HttpResponseBase): Observable<ContestDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestDetailsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestDetailsDto>(null as any);
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return Success
   */
  contestsPut(
    id: string | undefined,
    body: ContestUpdateDto | undefined
  ): Observable<ContestDetailsDto> {
    let url_ = this.baseUrl + '/api/app/contests?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestDetailsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestDetailsDto>;
        })
      );
  }

  protected processContestsPut(response: HttpResponseBase): Observable<ContestDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestDetailsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestDetailsDto>(null as any);
  }

  /**
   * @param id (optional)
   * @return Success
   */
  contestsDelete(id: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param fileType (optional)
   * @param body (optional)
   * @return Success
   */
  uploadCoverImage(fileType: string | undefined, body: string | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/app/contests/upload-cover-image?';
    if (fileType === null) throw new Error("The parameter 'fileType' cannot be null.");
    else if (fileType !== undefined) url_ += 'fileType=' + encodeURIComponent('' + fileType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUploadCoverImage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUploadCoverImage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processUploadCoverImage(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @return Success
   */
  slugPreview(name: string): Observable<ContestSlugPreviewDto> {
    let url_ = this.baseUrl + '/api/app/contests/slug-preview/{name}';
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace('{name}', encodeURIComponent('' + name));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSlugPreview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSlugPreview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestSlugPreviewDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestSlugPreviewDto>;
        })
      );
  }

  protected processSlugPreview(response: HttpResponseBase): Observable<ContestSlugPreviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestSlugPreviewDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestSlugPreviewDto>(null as any);
  }

  /**
   * @param status (optional)
   * @return Success
   */
  status(id: string, status: ContestStatus | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests/{id}/status?';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStatus(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStatus(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processStatus(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  bySlug(slug: string): Observable<ContestDetailsDto> {
    let url_ = this.baseUrl + '/api/app/contests/by-slug/{slug}';
    if (slug === undefined || slug === null)
      throw new Error("The parameter 'slug' must be defined.");
    url_ = url_.replace('{slug}', encodeURIComponent('' + slug));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBySlug(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBySlug(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestDetailsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestDetailsDto>;
        })
      );
  }

  protected processBySlug(response: HttpResponseBase): Observable<ContestDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestDetailsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestDetailsDto>(null as any);
  }

  /**
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  teamContestHistory(
    teamId: string,
    maxResultCount: number | undefined,
    skipCount: number | undefined
  ): Observable<PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests/team-contest-history/{teamId}?';
    if (teamId === undefined || teamId === null)
      throw new Error("The parameter 'teamId' must be defined.");
    url_ = url_.replace('{teamId}', encodeURIComponent('' + teamId));
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTeamContestHistory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTeamContestHistory(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processTeamContestHistory(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param maxResultCount (optional)
   * @param skipCount (optional)
   * @return Success
   */
  contestHistory(
    userId: string,
    maxResultCount: number | undefined,
    skipCount: number | undefined
  ): Observable<PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests/contest-history/{userId}?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestHistory(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestHistory(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processContestHistory(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return Success
   */
  generalInformation(
    id: string | undefined,
    body: ContestGeneralInformationUpdateDto | undefined
  ): Observable<ContestDetailsDto> {
    let url_ = this.baseUrl + '/api/app/contests/general-information?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGeneralInformation(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGeneralInformation(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestDetailsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestDetailsDto>;
        })
      );
  }

  protected processGeneralInformation(response: HttpResponseBase): Observable<ContestDetailsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestDetailsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestDetailsDto>(null as any);
  }

  /**
   * @param contestId (optional)
   * @return Success
   */
  exportSignups(contestId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests/export-signups?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processExportSignups(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processExportSignups(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processExportSignups(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param email (optional)
   * @return Success
   */
  sendExcelWithMail(contestId: string | undefined, email: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests/send-excel-with-mail?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    if (email === null) throw new Error("The parameter 'email' cannot be null.");
    else if (email !== undefined) url_ += 'email=' + encodeURIComponent('' + email) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendExcelWithMail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendExcelWithMail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendExcelWithMail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  sendReminderMail(contestId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests/send-reminder-mail/{contestId}';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSendReminderMail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSendReminderMail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSendReminderMail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  signedUps(
    contestId: string,
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests/signedUps/{contestId}?';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSignedUps(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSignedUps(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processSignedUps(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContestScoreClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsScorePost(body: ContestScoreCreateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-score';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsScorePost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsScorePost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsScorePost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsScorePut(body: ContestScoreUpdateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-score';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsScorePut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsScorePut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsScorePut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestsScoreGet(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined,
    startFrom: 'AllTime' | 'Weekly' | 'LastMonth' | 'LastYear' = 'AllTime'
  ): Observable<ContestScoreResponseDto> {
    let url_ = this.baseUrl + '/api/app/contests-score?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ += 'StartFrom=' + encodeURIComponent('' + startFrom);
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsScoreGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsScoreGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestScoreResponseDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestScoreResponseDto>;
        })
      );
  }

  protected processContestsScoreGet(
    response: HttpResponseBase
  ): Observable<ContestScoreResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestScoreResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestScoreResponseDto>(null as any);
  }

  /**
   * @return Success
   */
  cloneReport(contestId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-score/{contestId}/clone-report';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCloneReport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCloneReport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCloneReport(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  live(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<ContestScoreResponseDto> {
    let url_ = this.baseUrl + '/api/app/contests-score/live?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLive(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLive(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestScoreResponseDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestScoreResponseDto>;
        })
      );
  }

  protected processLive(response: HttpResponseBase): Observable<ContestScoreResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestScoreResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestScoreResponseDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContestTeamSignUpsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  contestsTeamSignUpsGetById(id: string): Observable<ContestTeamSignUpsDto> {
    let url_ = this.baseUrl + '/api/app/contests-team-sign-ups/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsTeamSignUpsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsTeamSignUpsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestTeamSignUpsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestTeamSignUpsDto>;
        })
      );
  }

  protected processContestsTeamSignUpsGetById(
    response: HttpResponseBase
  ): Observable<ContestTeamSignUpsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestTeamSignUpsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestTeamSignUpsDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsTeamSignUpsPut(
    id: string,
    body: ContestTeamSignUpsCreateDto | undefined
  ): Observable<ContestTeamSignUpsDto> {
    let url_ = this.baseUrl + '/api/app/contests-team-sign-ups/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsTeamSignUpsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsTeamSignUpsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestTeamSignUpsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestTeamSignUpsDto>;
        })
      );
  }

  protected processContestsTeamSignUpsPut(
    response: HttpResponseBase
  ): Observable<ContestTeamSignUpsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestTeamSignUpsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestTeamSignUpsDto>(null as any);
  }

  /**
   * @return Success
   */
  contestsTeamSignUpsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-team-sign-ups/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsTeamSignUpsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsTeamSignUpsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsTeamSignUpsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param contestId (optional)
   * @param signUpStatus (optional)
   * @param allSignups (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestsTeamSignUpsGet(
    filter: string | undefined,
    contestId: string | undefined,
    signUpStatus: SignUpStatus | undefined,
    allSignups: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-team-sign-ups?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (signUpStatus === null) throw new Error("The parameter 'signUpStatus' cannot be null.");
    else if (signUpStatus !== undefined)
      url_ += 'SignUpStatus=' + encodeURIComponent('' + signUpStatus) + '&';
    if (allSignups === null) throw new Error("The parameter 'allSignups' cannot be null.");
    else if (allSignups !== undefined)
      url_ += 'AllSignups=' + encodeURIComponent('' + allSignups) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsTeamSignUpsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsTeamSignUpsGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processContestsTeamSignUpsGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsTeamSignUpsPost(
    body: ContestTeamSignUpsCreateDto | undefined
  ): Observable<ContestTeamSignUpsDto> {
    let url_ = this.baseUrl + '/api/app/contests-team-sign-ups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsTeamSignUpsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsTeamSignUpsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestTeamSignUpsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestTeamSignUpsDto>;
        })
      );
  }

  protected processContestsTeamSignUpsPost(
    response: HttpResponseBase
  ): Observable<ContestTeamSignUpsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestTeamSignUpsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestTeamSignUpsDto>(null as any);
  }

  /**
   * @param status (optional)
   * @param body (optional)
   * @return Success
   */
  allStatuses(status: SignUpStatus | undefined, body: string[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-team-sign-ups/all-statuses?';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAllStatuses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAllStatuses(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAllStatuses(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  isTeamApproved(contestId: string): Observable<boolean> {
    let url_ = this.baseUrl + '/api/app/contests-team-sign-ups/{contestId}/is-team-approved';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsTeamApproved(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsTeamApproved(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processIsTeamApproved(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ContestUserSignUpsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  contestsUserSignUpsGetById(id: string): Observable<ContestUserSignUpsDto> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsUserSignUpsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsUserSignUpsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestUserSignUpsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestUserSignUpsDto>;
        })
      );
  }

  protected processContestsUserSignUpsGetById(
    response: HttpResponseBase
  ): Observable<ContestUserSignUpsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestUserSignUpsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestUserSignUpsDto>(null as any);
  }

  /**
   * @return Success
   */
  contestsUserSignUpsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsUserSignUpsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsUserSignUpsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsUserSignUpsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param contestId (optional)
   * @param signUpStatus (optional)
   * @param allSignups (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestsUserSignUpsGet(
    filter: string | undefined,
    contestId: string | undefined,
    signUpStatus: SignUpStatus | undefined,
    allSignups: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (signUpStatus === null) throw new Error("The parameter 'signUpStatus' cannot be null.");
    else if (signUpStatus !== undefined)
      url_ += 'SignUpStatus=' + encodeURIComponent('' + signUpStatus) + '&';
    if (allSignups === null) throw new Error("The parameter 'allSignups' cannot be null.");
    else if (allSignups !== undefined)
      url_ += 'AllSignups=' + encodeURIComponent('' + allSignups) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsUserSignUpsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsUserSignUpsGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processContestsUserSignUpsGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  contestsUserSignUpsPost(
    body: ContestUserSignUpsCreateDto | undefined
  ): Observable<ContestUserSignUpsDto> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsUserSignUpsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsUserSignUpsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestUserSignUpsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestUserSignUpsDto>;
        })
      );
  }

  protected processContestsUserSignUpsPost(
    response: HttpResponseBase
  ): Observable<ContestUserSignUpsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestUserSignUpsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestUserSignUpsDto>(null as any);
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return Success
   */
  contestsUserSignUpsPut(
    id: string | undefined,
    body: ContestUserSignUpsCreateDto | undefined
  ): Observable<ContestUserSignUpsDto> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsUserSignUpsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsUserSignUpsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestUserSignUpsDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ContestUserSignUpsDto>;
        })
      );
  }

  protected processContestsUserSignUpsPut(
    response: HttpResponseBase
  ): Observable<ContestUserSignUpsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestUserSignUpsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestUserSignUpsDto>(null as any);
  }

  /**
   * @param status (optional)
   * @param body (optional)
   * @return Success
   */
  allStatuses(status: SignUpStatus | undefined, body: string[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups/all-statuses?';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAllStatuses(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAllStatuses(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processAllStatuses(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  isUserApproved(contestId: string): Observable<boolean> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups/{contestId}/is-user-approved';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIsUserApproved(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIsUserApproved(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processIsUserApproved(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param filter (optional)
   * @param contestId (optional)
   * @param signUpStatus (optional)
   * @param allSignups (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  listWithFullProfile(
    filter: string | undefined,
    contestId: string | undefined,
    signUpStatus: SignUpStatus | undefined,
    allSignups: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/contests-user-sign-ups/list-with-full-profile?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (signUpStatus === null) throw new Error("The parameter 'signUpStatus' cannot be null.");
    else if (signUpStatus !== undefined)
      url_ += 'SignUpStatus=' + encodeURIComponent('' + signUpStatus) + '&';
    if (allSignups === null) throw new Error("The parameter 'allSignups' cannot be null.");
    else if (allSignups !== undefined)
      url_ += 'AllSignups=' + encodeURIComponent('' + allSignups) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processListWithFullProfile(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processListWithFullProfile(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processListWithFullProfile(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class CountriesClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  countriesPost(body: CountryCreateUpdateDto | undefined): Observable<CountryDto> {
    let url_ = this.baseUrl + '/api/app/countries';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountriesPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountriesPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CountryDto>;
        })
      );
  }

  protected processCountriesPost(response: HttpResponseBase): Observable<CountryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CountryDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  countriesGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/countries?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountriesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountriesGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processCountriesGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  countriesDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/countries/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountriesDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountriesDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processCountriesDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  countriesGetById(id: string): Observable<CountryDto> {
    let url_ = this.baseUrl + '/api/app/countries/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountriesGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountriesGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CountryDto>;
        })
      );
  }

  protected processCountriesGetById(response: HttpResponseBase): Observable<CountryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CountryDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  countriesPut(id: string, body: CountryCreateUpdateDto | undefined): Observable<CountryDto> {
    let url_ = this.baseUrl + '/api/app/countries/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCountriesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCountriesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CountryDto>;
            }
          } else return _observableThrow(response_) as any as Observable<CountryDto>;
        })
      );
  }

  protected processCountriesPut(response: HttpResponseBase): Observable<CountryDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CountryDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CountryDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class EmailDomainClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  emailDomainPost(body: EmailDomainCreateUpdateDto | undefined): Observable<EmailDomainDto> {
    let url_ = this.baseUrl + '/api/app/email-domain';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailDomainPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailDomainPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailDomainDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EmailDomainDto>;
        })
      );
  }

  protected processEmailDomainPost(response: HttpResponseBase): Observable<EmailDomainDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailDomainDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<EmailDomainDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  emailDomainGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/email-domain?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailDomainGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailDomainGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processEmailDomainGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  emailDomainDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/email-domain/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailDomainDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailDomainDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processEmailDomainDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  emailDomainGetById(id: string): Observable<EmailDomainDto> {
    let url_ = this.baseUrl + '/api/app/email-domain/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailDomainGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailDomainGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailDomainDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EmailDomainDto>;
        })
      );
  }

  protected processEmailDomainGetById(response: HttpResponseBase): Observable<EmailDomainDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailDomainDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<EmailDomainDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  emailDomainPut(
    id: string,
    body: EmailDomainCreateUpdateDto | undefined
  ): Observable<EmailDomainDto> {
    let url_ = this.baseUrl + '/api/app/email-domain/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailDomainPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailDomainPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailDomainDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EmailDomainDto>;
        })
      );
  }

  protected processEmailDomainPut(response: HttpResponseBase): Observable<EmailDomainDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailDomainDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<EmailDomainDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class EmailProviderClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  emailProviderPost(body: EmailProviderCreateUpdateDto | undefined): Observable<EmailProviderDto> {
    let url_ = this.baseUrl + '/api/app/email-provider';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailProviderPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailProviderPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailProviderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EmailProviderDto>;
        })
      );
  }

  protected processEmailProviderPost(response: HttpResponseBase): Observable<EmailProviderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailProviderDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<EmailProviderDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  emailProviderGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/email-provider?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailProviderGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailProviderGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processEmailProviderGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  emailProviderDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/email-provider/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailProviderDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailProviderDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processEmailProviderDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  emailProviderGetById(id: string): Observable<EmailProviderDto> {
    let url_ = this.baseUrl + '/api/app/email-provider/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailProviderGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailProviderGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailProviderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EmailProviderDto>;
        })
      );
  }

  protected processEmailProviderGetById(response: HttpResponseBase): Observable<EmailProviderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailProviderDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<EmailProviderDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  emailProviderPut(
    id: string,
    body: EmailProviderCreateUpdateDto | undefined
  ): Observable<EmailProviderDto> {
    let url_ = this.baseUrl + '/api/app/email-provider/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processEmailProviderPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processEmailProviderPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailProviderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EmailProviderDto>;
        })
      );
  }

  protected processEmailProviderPut(response: HttpResponseBase): Observable<EmailProviderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailProviderDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<EmailProviderDto>(null as any);
  }

  /**
   * @return Success
   */
  dedicatedOrDefault(mailToDomain: string): Observable<EmailProviderDto> {
    let url_ = this.baseUrl + '/api/app/email-provider/dedicated-or-default/{mailToDomain}';
    if (mailToDomain === undefined || mailToDomain === null)
      throw new Error("The parameter 'mailToDomain' must be defined.");
    url_ = url_.replace('{mailToDomain}', encodeURIComponent('' + mailToDomain));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDedicatedOrDefault(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDedicatedOrDefault(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<EmailProviderDto>;
            }
          } else return _observableThrow(response_) as any as Observable<EmailProviderDto>;
        })
      );
  }

  protected processDedicatedOrDefault(response: HttpResponseBase): Observable<EmailProviderDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = EmailProviderDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<EmailProviderDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class FeaturedContestsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  featuredContestsPost(
    body: FeaturedContestCreateUpdateDto | undefined
  ): Observable<FeaturedContestDto> {
    let url_ = this.baseUrl + '/api/app/featured-contests';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFeaturedContestsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFeaturedContestsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FeaturedContestDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FeaturedContestDto>;
        })
      );
  }

  protected processFeaturedContestsPost(
    response: HttpResponseBase
  ): Observable<FeaturedContestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FeaturedContestDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<FeaturedContestDto>(null as any);
  }

  private featuredContestsGetCache$: Observable<PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
  private featuredContestsGetUrl = '';
  featuredContestsGet(
    page: number | undefined,
    perPage: number | undefined,
    sortBy: Sorting | undefined,
    sort: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/featured-contests?';
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (perPage === null) throw new Error("The parameter 'perPage' cannot be null.");
    else if (perPage !== undefined) url_ += 'PerPage=' + encodeURIComponent('' + perPage) + '&';
    if (sortBy === null) throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined) url_ += 'SortBy=' + encodeURIComponent('' + sortBy) + '&';
    if (sort === null) throw new Error("The parameter 'sort' cannot be null.");
    else if (sort !== undefined) url_ += 'Sort=' + encodeURIComponent('' + sort) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    if (!this.featuredContestsGetCache$ || this.featuredContestsGetUrl !== url_) {
      this.featuredContestsGetUrl = url_;
      this.featuredContestsGetCache$ = this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processFeaturedContestsGet(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processFeaturedContestsGet(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e
                ) as any as Observable<PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
              }
            } else
              return _observableThrow(
                response_
              ) as any as Observable<PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
          })
        );
    }

    return this.featuredContestsGetCache$;
  }

  protected processFeaturedContestsGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  featuredContestsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/featured-contests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFeaturedContestsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFeaturedContestsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processFeaturedContestsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  featuredContestsGetById(id: string): Observable<FeaturedContestDto> {
    let url_ = this.baseUrl + '/api/app/featured-contests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFeaturedContestsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFeaturedContestsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FeaturedContestDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FeaturedContestDto>;
        })
      );
  }

  protected processFeaturedContestsGetById(
    response: HttpResponseBase
  ): Observable<FeaturedContestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FeaturedContestDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<FeaturedContestDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  featuredContestsPut(
    id: string,
    body: FeaturedContestCreateUpdateDto | undefined
  ): Observable<FeaturedContestDto> {
    let url_ = this.baseUrl + '/api/app/featured-contests/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFeaturedContestsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFeaturedContestsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<FeaturedContestDto>;
            }
          } else return _observableThrow(response_) as any as Observable<FeaturedContestDto>;
        })
      );
  }

  protected processFeaturedContestsPut(response: HttpResponseBase): Observable<FeaturedContestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = FeaturedContestDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<FeaturedContestDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class FeaturesClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param providerName (optional)
   * @param providerKey (optional)
   * @return Success
   */
  featuresGet(
    providerName: string | undefined,
    providerKey: string | undefined
  ): Observable<GetFeatureListResultDto> {
    let url_ = this.baseUrl + '/api/feature-management/features?';
    if (providerName === null) throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
      url_ += 'providerName=' + encodeURIComponent('' + providerName) + '&';
    if (providerKey === null) throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
      url_ += 'providerKey=' + encodeURIComponent('' + providerKey) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFeaturesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFeaturesGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetFeatureListResultDto>;
            }
          } else return _observableThrow(response_) as any as Observable<GetFeatureListResultDto>;
        })
      );
  }

  protected processFeaturesGet(response: HttpResponseBase): Observable<GetFeatureListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetFeatureListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetFeatureListResultDto>(null as any);
  }

  /**
   * @param providerName (optional)
   * @param providerKey (optional)
   * @param body (optional)
   * @return Success
   */
  featuresPut(
    providerName: string | undefined,
    providerKey: string | undefined,
    body: UpdateFeaturesDto | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/feature-management/features?';
    if (providerName === null) throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
      url_ += 'providerName=' + encodeURIComponent('' + providerName) + '&';
    if (providerKey === null) throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
      url_ += 'providerKey=' + encodeURIComponent('' + providerKey) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processFeaturesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processFeaturesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processFeaturesPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class JudgerConfigurationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  judgerConfigurationPost(body: JudgerCreateUpdateDto | undefined): Observable<JudgerDto> {
    let url_ = this.baseUrl + '/api/app/judger-configuration';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processJudgerConfigurationPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processJudgerConfigurationPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<JudgerDto>;
            }
          } else return _observableThrow(response_) as any as Observable<JudgerDto>;
        })
      );
  }

  protected processJudgerConfigurationPost(response: HttpResponseBase): Observable<JudgerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = JudgerDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<JudgerDto>(null as any);
  }

  /**
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  judgerConfigurationGet(
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/judger-configuration?';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processJudgerConfigurationGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processJudgerConfigurationGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processJudgerConfigurationGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  judgerConfigurationDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/judger-configuration/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processJudgerConfigurationDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processJudgerConfigurationDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processJudgerConfigurationDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  judgerConfigurationGetById(id: string): Observable<JudgerDto> {
    let url_ = this.baseUrl + '/api/app/judger-configuration/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processJudgerConfigurationGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processJudgerConfigurationGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<JudgerDto>;
            }
          } else return _observableThrow(response_) as any as Observable<JudgerDto>;
        })
      );
  }

  protected processJudgerConfigurationGetById(response: HttpResponseBase): Observable<JudgerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = JudgerDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<JudgerDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  judgerConfigurationPut(
    id: string,
    body: JudgerCreateUpdateDto | undefined
  ): Observable<JudgerDto> {
    let url_ = this.baseUrl + '/api/app/judger-configuration/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processJudgerConfigurationPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processJudgerConfigurationPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<JudgerDto>;
            }
          } else return _observableThrow(response_) as any as Observable<JudgerDto>;
        })
      );
  }

  protected processJudgerConfigurationPut(response: HttpResponseBase): Observable<JudgerDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = JudgerDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<JudgerDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class GLeaderboardClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  canRequestCalculate(contestId: string): Observable<CanUserRequestCalculateDto> {
    let url_ = this.baseUrl + '/api/app/gleaderboard/can-request-calculate/{contestId}';
    if (contestId === undefined || contestId === null)
      throw new Error("The parameter 'contestId' must be defined.");
    url_ = url_.replace('{contestId}', encodeURIComponent('' + contestId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCanRequestCalculate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCanRequestCalculate(<any>response_);
            } catch (e) {
              return <Observable<CanUserRequestCalculateDto>>(<any>_observableThrow(e));
            }
          } else return <Observable<CanUserRequestCalculateDto>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processCanRequestCalculate(
    response: HttpResponseBase
  ): Observable<CanUserRequestCalculateDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = CanUserRequestCalculateDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CanUserRequestCalculateDto>(<any>null);
  }

  /**
   * @param contestId (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  gleaderboardGet(
    contestId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/gleaderboard?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGleaderboardGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGleaderboardGet(<any>response_);
            } catch (e) {
              return <
                Observable<PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>
              >(<any>_observableThrow(e));
            }
          } else
            return <
              Observable<PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>
            >(<any>_observableThrow(response_));
        })
      );
  }

  protected processGleaderboardGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      <any>null
    );
  }

  /**
   * @param contestId (optional)
   * @return Success
   */
  gleaderboardPost(contestId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/gleaderboard?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGleaderboardPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGleaderboardPost(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGleaderboardPost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }

  /**
   * @param contestId (optional)
   * @return Success
   */
  gleaderboardPut(contestId: string | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/gleaderboard?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGleaderboardPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGleaderboardPut(<any>response_);
            } catch (e) {
              return <Observable<void>>(<any>_observableThrow(e));
            }
          } else return <Observable<void>>(<any>_observableThrow(response_));
        })
      );
  }

  protected processGleaderboardPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(<any>null);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(<any>null);
  }
}

@Injectable({
  providedIn: 'root',
})
export class GLeaderboardScoreClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  private gleaderboardScoreCache$: Observable<PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
  private gleaderboardScoreUrl = '';
  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  gleaderboardScore(
    filter: string | undefined,
    institutionId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/gleaderboard-score?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (institutionId === null) throw new Error("The parameter 'institutionId' cannot be null.");
    else if (institutionId !== undefined && institutionId.length > 0)
      url_ += 'InstitutionId=' + encodeURIComponent('' + institutionId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    if (!this.gleaderboardScoreCache$ || this.gleaderboardScoreUrl !== url_) {
      this.gleaderboardScoreUrl = url_;
      this.gleaderboardScoreCache$ = this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processGleaderboardScore(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processGleaderboardScore(<any>response_);
              } catch (e) {
                return <
                  Observable<PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>
                >(<any>_observableThrow(e));
              }
            } else
              return <
                Observable<PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>
              >(<any>_observableThrow(response_));
          })
        );
    }
    return this.gleaderboardScoreCache$;
  }

  protected processGleaderboardScore(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
        ? (<any>response).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      <any>null
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class LanguagesClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  lookup(): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    let url_ = this.baseUrl + '/api/app/languages/lookup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
            >;
        })
      );
  }

  protected processLookup(
    response: HttpResponseBase
  ): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<
      LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    >(null as any);
  }

  /**
   * @return Success
   */
  languages(
    id: string
  ): Observable<LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
    let url_ = this.baseUrl + '/api/app/languages/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLanguages(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLanguages(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
        })
      );
  }

  protected processLanguages(
    response: HttpResponseBase
  ): Observable<LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class LeaderBoardClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  languages(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/languages?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLanguages(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLanguages(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processLanguages(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class OjsIdentityUserClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param isConfirmed (optional)
   * @return Success
   */
  forceConfirmEmail(userId: string, isConfirmed: boolean | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/ojs-identity-user/{userId}/force-confirm-email?';
    if (userId === undefined || userId === null)
      throw new Error("The parameter 'userId' must be defined.");
    url_ = url_.replace('{userId}', encodeURIComponent('' + userId));
    if (isConfirmed === null) throw new Error("The parameter 'isConfirmed' cannot be null.");
    else if (isConfirmed !== undefined)
      url_ += 'isConfirmed=' + encodeURIComponent('' + isConfirmed) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processForceConfirmEmail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processForceConfirmEmail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processForceConfirmEmail(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class OrganizationClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  organizationsGetById(id: string): Observable<OrganizationDto> {
    let url_ = this.baseUrl + '/api/app/organizations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processOrganizationsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processOrganizationsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrganizationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<OrganizationDto>;
        })
      );
  }

  protected processOrganizationsGetById(response: HttpResponseBase): Observable<OrganizationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<OrganizationDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  organizationsPut(
    id: string,
    body: CreateOrganizationDto | undefined
  ): Observable<OrganizationDto> {
    let url_ = this.baseUrl + '/api/app/organizations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processOrganizationsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processOrganizationsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrganizationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<OrganizationDto>;
        })
      );
  }

  protected processOrganizationsPut(response: HttpResponseBase): Observable<OrganizationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<OrganizationDto>(null as any);
  }

  /**
   * @return Success
   */
  organizationsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/organizations/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processOrganizationsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processOrganizationsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processOrganizationsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  organizationsGetByList(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/organizations?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processOrganizationsGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processOrganizationsGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processOrganizationsGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  organizationsPost(body: CreateOrganizationDto | undefined): Observable<OrganizationDto> {
    let url_ = this.baseUrl + '/api/app/organizations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processOrganizationsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processOrganizationsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<OrganizationDto>;
            }
          } else return _observableThrow(response_) as any as Observable<OrganizationDto>;
        })
      );
  }

  protected processOrganizationsPost(response: HttpResponseBase): Observable<OrganizationDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = OrganizationDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<OrganizationDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class PermissionsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param providerName (optional)
   * @param providerKey (optional)
   * @return Success
   */
  permissionsGet(
    providerName: string | undefined,
    providerKey: string | undefined
  ): Observable<GetPermissionListResultDto> {
    let url_ = this.baseUrl + '/api/permission-management/permissions?';
    if (providerName === null) throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
      url_ += 'providerName=' + encodeURIComponent('' + providerName) + '&';
    if (providerKey === null) throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
      url_ += 'providerKey=' + encodeURIComponent('' + providerKey) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermissionsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermissionsGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<GetPermissionListResultDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<GetPermissionListResultDto>;
        })
      );
  }

  protected processPermissionsGet(
    response: HttpResponseBase
  ): Observable<GetPermissionListResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = GetPermissionListResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetPermissionListResultDto>(null as any);
  }

  /**
   * @param providerName (optional)
   * @param providerKey (optional)
   * @param body (optional)
   * @return Success
   */
  permissionsPut(
    providerName: string | undefined,
    providerKey: string | undefined,
    body: UpdatePermissionsDto | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/permission-management/permissions?';
    if (providerName === null) throw new Error("The parameter 'providerName' cannot be null.");
    else if (providerName !== undefined)
      url_ += 'providerName=' + encodeURIComponent('' + providerName) + '&';
    if (providerKey === null) throw new Error("The parameter 'providerKey' cannot be null.");
    else if (providerKey !== undefined)
      url_ += 'providerKey=' + encodeURIComponent('' + providerKey) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPermissionsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPermissionsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPermissionsPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  problemGetById(id: string): Observable<ProblemDetailedDto> {
    let url_ = this.baseUrl + '/api/app/problem/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemDetailedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemDetailedDto>;
        })
      );
  }

  protected processProblemGetById(response: HttpResponseBase): Observable<ProblemDetailedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemDetailedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemDetailedDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemPut(id: string, body: ProblemCreateUpdateDto | undefined): Observable<ProblemDetailedDto> {
    let url_ = this.baseUrl + '/api/app/problem/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemDetailedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemDetailedDto>;
        })
      );
  }

  protected processProblemPut(response: HttpResponseBase): Observable<ProblemDetailedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemDetailedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemDetailedDto>(null as any);
  }

  /**
   * @return Success
   */
  problemDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProblemDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param difficulty (optional)
   * @param status (optional)
   * @param userName (optional)
   * @param doIsMy (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  problemGetByList(
    filter: string | undefined,
    difficulty: ProblemDifficulty | undefined,
    status: ProblemStatus | undefined,
    userName: string | undefined,
    doIsMy: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (difficulty === null) throw new Error("The parameter 'difficulty' cannot be null.");
    else if (difficulty !== undefined)
      url_ += 'Difficulty=' + encodeURIComponent('' + difficulty) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (doIsMy === null) throw new Error("The parameter 'doIsMy' cannot be null.");
    else if (doIsMy !== undefined) url_ += 'DoIsMy=' + encodeURIComponent('' + doIsMy) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processProblemGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemPost(body: ProblemCreateUpdateDto | undefined): Observable<ProblemDetailedDto> {
    let url_ = this.baseUrl + '/api/app/problem';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemDetailedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemDetailedDto>;
        })
      );
  }

  protected processProblemPost(response: HttpResponseBase): Observable<ProblemDetailedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemDetailedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemDetailedDto>(null as any);
  }

  /**
   * @return Success
   */
  slugPreview(name: string): Observable<ProblemSlugPreviewDto> {
    let url_ = this.baseUrl + '/api/app/problem/slug-preview/{name}';
    if (name === undefined || name === null)
      throw new Error("The parameter 'name' must be defined.");
    url_ = url_.replace('{name}', encodeURIComponent('' + name));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSlugPreview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSlugPreview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSlugPreviewDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSlugPreviewDto>;
        })
      );
  }

  protected processSlugPreview(response: HttpResponseBase): Observable<ProblemSlugPreviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemSlugPreviewDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSlugPreviewDto>(null as any);
  }

  /**
   * @param slug (optional)
   * @return Success
   */
  bySlug(slug: string | undefined): Observable<ProblemDetailedDto> {
    let url_ = this.baseUrl + '/api/app/problem/by-slug?';
    if (slug === null) throw new Error("The parameter 'slug' cannot be null.");
    else if (slug !== undefined) url_ += 'slug=' + encodeURIComponent('' + slug) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBySlug(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBySlug(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemDetailedDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemDetailedDto>;
        })
      );
  }

  protected processBySlug(response: HttpResponseBase): Observable<ProblemDetailedDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemDetailedDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemDetailedDto>(null as any);
  }

  /**
   * @param slug (optional)
   * @param contestId (optional)
   * @return Success
   */
  contestProblemBySlug(
    slug: string | undefined,
    contestId: string | undefined
  ): Observable<ProblemContestResponseDto> {
    let url_ = this.baseUrl + '/api/app/problem/contest-problem-by-slug?';
    if (slug === null) throw new Error("The parameter 'slug' cannot be null.");
    else if (slug !== undefined) url_ += 'slug=' + encodeURIComponent('' + slug) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestProblemBySlug(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestProblemBySlug(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemContestResponseDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemContestResponseDto>;
        })
      );
  }

  protected processContestProblemBySlug(
    response: HttpResponseBase
  ): Observable<ProblemContestResponseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemContestResponseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemContestResponseDto>(null as any);
  }

  /**
   * @param problemSlug (optional)
   * @return Success
   */
  idBySlug(
    problemSlug: string | undefined
  ): Observable<DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
    let url_ = this.baseUrl + '/api/app/problem/id-by-slug?';
    if (problemSlug === null) throw new Error("The parameter 'problemSlug' cannot be null.");
    else if (problemSlug !== undefined)
      url_ += 'problemSlug=' + encodeURIComponent('' + problemSlug) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processIdBySlug(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processIdBySlug(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
        })
      );
  }

  protected processIdBySlug(
    response: HttpResponseBase
  ): Observable<DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(
      null as any
    );
  }

  /**
   * @return Success
   */
  slug(
    id: string
  ): Observable<DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
    let url_ = this.baseUrl + '/api/app/problem/{id}/slug';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSlug(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSlug(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>;
        })
      );
  }

  protected processSlug(
    response: HttpResponseBase
  ): Observable<DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e>(
      null as any
    );
  }

  /**
   * @param filter (optional)
   * @param difficulty (optional)
   * @param status (optional)
   * @param userName (optional)
   * @param doIsMy (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  unsolvedList(
    filter: string | undefined,
    difficulty: ProblemDifficulty | undefined,
    status: ProblemStatus | undefined,
    userName: string | undefined,
    doIsMy: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem/unsolved-list?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (difficulty === null) throw new Error("The parameter 'difficulty' cannot be null.");
    else if (difficulty !== undefined)
      url_ += 'Difficulty=' + encodeURIComponent('' + difficulty) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (doIsMy === null) throw new Error("The parameter 'doIsMy' cannot be null.");
    else if (doIsMy !== undefined) url_ += 'DoIsMy=' + encodeURIComponent('' + doIsMy) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnsolvedList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnsolvedList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processUnsolvedList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param value (optional)
   * @param isEnabled (optional)
   * @return Success
   */
  precisionValue(
    problemId: string,
    value: number | undefined,
    isEnabled: boolean | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem/{problemId}/precision-value?';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    if (value === null) throw new Error("The parameter 'value' cannot be null.");
    else if (value !== undefined) url_ += 'value=' + encodeURIComponent('' + value) + '&';
    if (isEnabled === null) throw new Error("The parameter 'isEnabled' cannot be null.");
    else if (isEnabled !== undefined)
      url_ += 'isEnabled=' + encodeURIComponent('' + isEnabled) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPrecisionValue(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPrecisionValue(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processPrecisionValue(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param difficulty (optional)
   * @param status (optional)
   * @param userName (optional)
   * @param doIsMy (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  summaryForContest(
    filter: string | undefined,
    difficulty: ProblemDifficulty | undefined,
    status: ProblemStatus | undefined,
    userName: string | undefined,
    doIsMy: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem/summary-for-contest?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (difficulty === null) throw new Error("The parameter 'difficulty' cannot be null.");
    else if (difficulty !== undefined)
      url_ += 'Difficulty=' + encodeURIComponent('' + difficulty) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (doIsMy === null) throw new Error("The parameter 'doIsMy' cannot be null.");
    else if (doIsMy !== undefined) url_ += 'DoIsMy=' + encodeURIComponent('' + doIsMy) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSummaryForContest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSummaryForContest(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processSummaryForContest(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  private practiceProblemsCache$: Observable<PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
  private practiceProblemsUrl = '';

  /**
   * @param filter (optional)
   * @param isSolved (optional)
   * @param difficulty (optional)
   * @param tags_Name (optional)
   * @param tags_CombineWith (optional)
   * @param page (optional)
   * @param perPage (optional)
   * @param sortBy (optional)
   * @param sort (optional)
   * @param combineWith (optional)
   * @return Success
   */
  practiceProblems(
    filter: string | undefined,
    isSolved: boolean | undefined,
    difficulty: ProblemDifficulty | undefined,
    tags_Name: string | undefined,
    tags_CombineWith: CombineType | undefined,
    page: number | undefined,
    perPage: number | undefined,
    sortBy: Sorting | undefined,
    sort: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem/practice-problems?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (isSolved === null) throw new Error("The parameter 'isSolved' cannot be null.");
    else if (isSolved !== undefined) url_ += 'IsSolved=' + encodeURIComponent('' + isSolved) + '&';
    if (difficulty === null) throw new Error("The parameter 'difficulty' cannot be null.");
    else if (difficulty !== undefined)
      url_ += 'Difficulty=' + encodeURIComponent('' + difficulty) + '&';
    if (tags_Name === null) throw new Error("The parameter 'tags_Name' cannot be null.");
    else if (tags_Name !== undefined)
      url_ += 'Tags.Name=' + encodeURIComponent('' + tags_Name) + '&';
    if (tags_CombineWith === null)
      throw new Error("The parameter 'tags_CombineWith' cannot be null.");
    else if (tags_CombineWith !== undefined)
      url_ += 'Tags.CombineWith=' + encodeURIComponent('' + tags_CombineWith) + '&';
    if (page === null) throw new Error("The parameter 'page' cannot be null.");
    else if (page !== undefined) url_ += 'Page=' + encodeURIComponent('' + page) + '&';
    if (perPage === null) throw new Error("The parameter 'perPage' cannot be null.");
    else if (perPage !== undefined) url_ += 'PerPage=' + encodeURIComponent('' + perPage) + '&';
    if (sortBy === null) throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined) url_ += 'SortBy=' + encodeURIComponent('' + sortBy) + '&';
    if (sort === null) throw new Error("The parameter 'sort' cannot be null.");
    else if (sort !== undefined) url_ += 'Sort=' + encodeURIComponent('' + sort) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');
    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    if (!this.practiceProblemsCache$ || this.practiceProblemsUrl !== url_) {
      this.practiceProblemsUrl = url_;
      this.practiceProblemsCache$ = this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processPracticeProblems(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPracticeProblems(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e
                ) as any as Observable<PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
              }
            } else
              return _observableThrow(
                response_
              ) as any as Observable<PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
          })
        );
    }
    return this.practiceProblemsCache$;
  }

  protected processPracticeProblems(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  practiceSuccessRatio(id: string): Observable<number> {
    let url_ = this.baseUrl + '/api/app/problem/{id}/practice-success-ratio';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPracticeSuccessRatio(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPracticeSuccessRatio(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processPracticeSuccessRatio(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @return Success
   */
  solvedPracticeProblemsByUser(): Observable<string[]> {
    let url_ = this.baseUrl + '/api/app/problem/solved-practice-problems-by-user';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSolvedPracticeProblemsByUser(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSolvedPracticeProblemsByUser(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processSolvedPracticeProblemsByUser(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
   * @param userName (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  createdProblems(
    userName: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem/created-problems?';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatedProblems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCreatedProblems(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processCreatedProblems(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param filter (optional)
   * @param difficulty (optional)
   * @param status (optional)
   * @param userName (optional)
   * @param doIsMy (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  authorizedProblems(
    filter: string | undefined,
    difficulty: ProblemDifficulty | undefined,
    status: ProblemStatus | undefined,
    userName: string | undefined,
    doIsMy: boolean | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem/authorized-problems?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (difficulty === null) throw new Error("The parameter 'difficulty' cannot be null.");
    else if (difficulty !== undefined)
      url_ += 'Difficulty=' + encodeURIComponent('' + difficulty) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (doIsMy === null) throw new Error("The parameter 'doIsMy' cannot be null.");
    else if (doIsMy !== undefined) url_ += 'DoIsMy=' + encodeURIComponent('' + doIsMy) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuthorizedProblems(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuthorizedProblems(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAuthorizedProblems(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemEditorialClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemEditorialPost(
    body: ProblemEditorialCreateUpdateDto | undefined
  ): Observable<ProblemEditorialDto> {
    let url_ = this.baseUrl + '/api/app/problem-editorial';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemEditorialPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemEditorialPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemEditorialDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemEditorialDto>;
        })
      );
  }

  protected processProblemEditorialPost(
    response: HttpResponseBase
  ): Observable<ProblemEditorialDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemEditorialDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemEditorialDto>(null as any);
  }

  /**
   * @param problemId (optional)
   * @param timeComplexity (optional)
   * @param hint (optional)
   * @param editorial (optional)
   * @param isUnlocked (optional)
   * @param id (optional)
   * @return Success
   */
  problemEditorialGetByList(
    problemId: string | undefined,
    timeComplexity: string | undefined,
    hint: string | undefined,
    editorial: string | undefined,
    isUnlocked: boolean | undefined,
    id: string | undefined
  ): Observable<PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem-editorial?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'ProblemId=' + encodeURIComponent('' + problemId) + '&';
    if (timeComplexity === null) throw new Error("The parameter 'timeComplexity' cannot be null.");
    else if (timeComplexity !== undefined)
      url_ += 'TimeComplexity=' + encodeURIComponent('' + timeComplexity) + '&';
    if (hint === null) throw new Error("The parameter 'hint' cannot be null.");
    else if (hint !== undefined) url_ += 'Hint=' + encodeURIComponent('' + hint) + '&';
    if (editorial === null) throw new Error("The parameter 'editorial' cannot be null.");
    else if (editorial !== undefined)
      url_ += 'Editorial=' + encodeURIComponent('' + editorial) + '&';
    if (isUnlocked === null) throw new Error("The parameter 'isUnlocked' cannot be null.");
    else if (isUnlocked !== undefined)
      url_ += 'IsUnlocked=' + encodeURIComponent('' + isUnlocked) + '&';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'Id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemEditorialGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemEditorialGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processProblemEditorialGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  problemEditorialDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-editorial/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemEditorialDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemEditorialDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProblemEditorialDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  problemEditorialGetById(id: string): Observable<ProblemEditorialDto> {
    let url_ = this.baseUrl + '/api/app/problem-editorial/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemEditorialGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemEditorialGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemEditorialDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemEditorialDto>;
        })
      );
  }

  protected processProblemEditorialGetById(
    response: HttpResponseBase
  ): Observable<ProblemEditorialDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemEditorialDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemEditorialDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemEditorialPut(
    id: string,
    body: ProblemEditorialCreateUpdateDto | undefined
  ): Observable<ProblemEditorialDto> {
    let url_ = this.baseUrl + '/api/app/problem-editorial/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemEditorialPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemEditorialPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemEditorialDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemEditorialDto>;
        })
      );
  }

  protected processProblemEditorialPut(
    response: HttpResponseBase
  ): Observable<ProblemEditorialDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemEditorialDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemEditorialDto>(null as any);
  }

  /**
   * @param contestId (optional)
   * @return Success
   */
  byProblemGet(problemId: string, contestId: string | undefined): Observable<ProblemEditorialDto> {
    let url_ = this.baseUrl + '/api/app/problem-editorial/by-problem/{problemId}?';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByProblemGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByProblemGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemEditorialDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemEditorialDto>;
        })
      );
  }

  protected processByProblemGet(response: HttpResponseBase): Observable<ProblemEditorialDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemEditorialDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemEditorialDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  byProblemPut(
    problemId: string,
    body: ProblemEditorialCreateUpdateDto | undefined
  ): Observable<ProblemEditorialDto> {
    let url_ = this.baseUrl + '/api/app/problem-editorial/by-problem/{problemId}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByProblemPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByProblemPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemEditorialDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemEditorialDto>;
        })
      );
  }

  protected processByProblemPut(response: HttpResponseBase): Observable<ProblemEditorialDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemEditorialDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemEditorialDto>(null as any);
  }

  /**
   * @return Success
   */
  unlockHint(problemId: string): Observable<ProblemEditorialDto> {
    let url_ = this.baseUrl + '/api/app/problem-editorial/by-problem/{problemId}/unlock-hint';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUnlockHint(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUnlockHint(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemEditorialDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemEditorialDto>;
        })
      );
  }

  protected processUnlockHint(response: HttpResponseBase): Observable<ProblemEditorialDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemEditorialDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemEditorialDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemPreviewClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  preview(problemId: string): Observable<ProblemPreviewDto> {
    let url_ = this.baseUrl + '/api/app/problem/{problemId}/preview';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processPreview(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processPreview(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemPreviewDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemPreviewDto>;
        })
      );
  }

  protected processPreview(response: HttpResponseBase): Observable<ProblemPreviewDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemPreviewDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemPreviewDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemProgrammingLanguageClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemProgrammingLanguagePost(
    body: ProblemProgrammingLanguageCreateDto | undefined
  ): Observable<ProblemProgrammingLanguageDto> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemProgrammingLanguagePost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemProgrammingLanguagePost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemProgrammingLanguageDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ProblemProgrammingLanguageDto>;
        })
      );
  }

  protected processProblemProgrammingLanguagePost(
    response: HttpResponseBase
  ): Observable<ProblemProgrammingLanguageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemProgrammingLanguageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemProgrammingLanguageDto>(null as any);
  }

  /**
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @return Success
   */
  problemProgrammingLanguageGetByList(
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined
  ): Observable<PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language?';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemProgrammingLanguageGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemProgrammingLanguageGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processProblemProgrammingLanguageGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  problemProgrammingLanguageDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemProgrammingLanguageDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemProgrammingLanguageDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProblemProgrammingLanguageDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  problemProgrammingLanguageGetById(id: string): Observable<ProblemProgrammingLanguageDto> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemProgrammingLanguageGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemProgrammingLanguageGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemProgrammingLanguageDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ProblemProgrammingLanguageDto>;
        })
      );
  }

  protected processProblemProgrammingLanguageGetById(
    response: HttpResponseBase
  ): Observable<ProblemProgrammingLanguageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemProgrammingLanguageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemProgrammingLanguageDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemProgrammingLanguagePut(
    id: string,
    body: ProblemProgrammingLanguageUpdateDto | undefined
  ): Observable<ProblemProgrammingLanguageDto> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemProgrammingLanguagePut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemProgrammingLanguagePut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemProgrammingLanguageDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ProblemProgrammingLanguageDto>;
        })
      );
  }

  protected processProblemProgrammingLanguagePut(
    response: HttpResponseBase
  ): Observable<ProblemProgrammingLanguageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemProgrammingLanguageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemProgrammingLanguageDto>(null as any);
  }

  /**
   * @return Success
   */
  byProblem(problemId: string): Observable<ProblemProgrammingLanguageDto[]> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language/by-problem/{problemId}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByProblem(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByProblem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemProgrammingLanguageDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ProblemProgrammingLanguageDto[]
            >;
        })
      );
  }

  protected processByProblem(
    response: HttpResponseBase
  ): Observable<ProblemProgrammingLanguageDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ProblemProgrammingLanguageDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemProgrammingLanguageDto[]>(null as any);
  }

  /**
   * @return Success
   */
  lookup(
    problemId: string
  ): Observable<
    LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    let url_ = this.baseUrl + '/api/app/problem-programming-language/by-problem/{problemId}/lookup';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
            >;
        })
      );
  }

  protected processLookup(
    response: HttpResponseBase
  ): Observable<
    LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<
      LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    >(null as any);
  }

  /**
   * @return Success
   */
  programmingLanguages(problemId: string): Observable<ProblemProgrammingLanguageDto[]> {
    let url_ =
      this.baseUrl +
      '/api/app/problem-programming-language/by-problem/{problemId}/programming-languages';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguages(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguages(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemProgrammingLanguageDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ProblemProgrammingLanguageDto[]
            >;
        })
      );
  }

  protected processProgrammingLanguages(
    response: HttpResponseBase
  ): Observable<ProblemProgrammingLanguageDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ProblemProgrammingLanguageDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemProgrammingLanguageDto[]>(null as any);
  }

  /**
   * @return Success
   */
  programmingLanguageNames(problemId: string): Observable<string[]> {
    let url_ =
      this.baseUrl +
      '/api/app/problem-programming-language/by-problem/{problemId}/programming-language-names';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguageNames(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguageNames(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string[]>;
            }
          } else return _observableThrow(response_) as any as Observable<string[]>;
        })
      );
  }

  protected processProgrammingLanguageNames(response: HttpResponseBase): Observable<string[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(item);
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  byDto(body: ProblemProgrammingLanguageDto[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language/by-dto';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByDto(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByDto(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processByDto(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  programmingLanguage(body: ProblemProgrammingLanguageDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-programming-language/programming-language';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguage(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguage(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProgrammingLanguage(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemSolutionClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  problemSolutionDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-solution/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSolutionDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSolutionDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProblemSolutionDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  problemSolutionGet(id: string): Observable<ProblemSolutionDto> {
    let url_ = this.baseUrl + '/api/app/problem-solution/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSolutionGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSolutionGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSolutionDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSolutionDto>;
        })
      );
  }

  protected processProblemSolutionGet(response: HttpResponseBase): Observable<ProblemSolutionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemSolutionDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSolutionDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemSolutionPut(id: string, body: ProblemSolutionUpdateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-solution/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSolutionPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSolutionPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProblemSolutionPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  byProblem(problemId: string): Observable<ProblemSolutionDto[]> {
    let url_ = this.baseUrl + '/api/app/problem-solution/by-problem/{problemId}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByProblem(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByProblem(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSolutionDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSolutionDto[]>;
        })
      );
  }

  protected processByProblem(response: HttpResponseBase): Observable<ProblemSolutionDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProblemSolutionDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSolutionDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  runMany(body: string[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-solution/run-many';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunMany(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunMany(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRunMany(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  run(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-solution/{id}/run';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRun(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRun(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRun(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  testCasesPost(id: string, testCaseId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-solution/{id}/run/test-cases/{testCaseId}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (testCaseId === undefined || testCaseId === null)
      throw new Error("The parameter 'testCaseId' must be defined.");
    url_ = url_.replace('{testCaseId}', encodeURIComponent('' + testCaseId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCasesPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCasesPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTestCasesPost(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  set(body: ProblemSolutionCreateDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-solution/set';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSet(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  testCasesPut(id: string, testCaseId: string, token: string): Observable<void> {
    let url_ =
      this.baseUrl + '/api/app/problem-solution/{id}/track/test-cases/{testCaseId}/{token}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (testCaseId === undefined || testCaseId === null)
      throw new Error("The parameter 'testCaseId' must be defined.");
    url_ = url_.replace('{testCaseId}', encodeURIComponent('' + testCaseId));
    if (token === undefined || token === null)
      throw new Error("The parameter 'token' must be defined.");
    url_ = url_.replace('{token}', encodeURIComponent('' + token));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCasesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCasesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTestCasesPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param name (optional)
   * @param body (optional)
   * @return Success
   */
  upload(name: string | undefined, body: string | undefined): Observable<string> {
    let url_ = this.baseUrl + '/api/app/problem-solution/upload?';
    if (name === null) throw new Error("The parameter 'name' cannot be null.");
    else if (name !== undefined) url_ += 'name=' + encodeURIComponent('' + name) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpload(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUpload(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processUpload(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemStatementClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  statementGet(problemId: string): Observable<ProblemStatementDto> {
    let url_ = this.baseUrl + '/api/app/problem/{problemId}/statement';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStatementGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStatementGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemStatementDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemStatementDto>;
        })
      );
  }

  protected processStatementGet(response: HttpResponseBase): Observable<ProblemStatementDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemStatementDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemStatementDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  statementPut(
    problemId: string,
    body: ProblemStatementSetDto | undefined
  ): Observable<ProblemStatementDto> {
    let url_ = this.baseUrl + '/api/app/problem/{problemId}/statement';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processStatementPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processStatementPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemStatementDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemStatementDto>;
        })
      );
  }

  protected processStatementPut(response: HttpResponseBase): Observable<ProblemStatementDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemStatementDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemStatementDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemSubmissionResultClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  testCases(
    problemSlug: string,
    submissionId: string,
    testCaseId: string
  ): Observable<ProblemSubmissionResultDto> {
    let url_ =
      this.baseUrl +
      '/api/app/problem-submission-results/by-slug/{problemSlug}/submissions/{submissionId}/test-cases/{testCaseId}';
    if (problemSlug === undefined || problemSlug === null)
      throw new Error("The parameter 'problemSlug' must be defined.");
    url_ = url_.replace('{problemSlug}', encodeURIComponent('' + problemSlug));
    if (submissionId === undefined || submissionId === null)
      throw new Error("The parameter 'submissionId' must be defined.");
    url_ = url_.replace('{submissionId}', encodeURIComponent('' + submissionId));
    if (testCaseId === undefined || testCaseId === null)
      throw new Error("The parameter 'testCaseId' must be defined.");
    url_ = url_.replace('{testCaseId}', encodeURIComponent('' + testCaseId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCases(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionResultDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ProblemSubmissionResultDto>;
        })
      );
  }

  protected processTestCases(response: HttpResponseBase): Observable<ProblemSubmissionResultDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemSubmissionResultDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionResultDto>(null as any);
  }

  /**
   * @return Success
   */
  submissions(
    problemSlug: string,
    submissionId: string
  ): Observable<ProblemSubmissionResultLimitedDto[]> {
    let url_ =
      this.baseUrl +
      '/api/app/problem-submission-results/by-slug/{problemSlug}/submissions/{submissionId}';
    if (problemSlug === undefined || problemSlug === null)
      throw new Error("The parameter 'problemSlug' must be defined.");
    url_ = url_.replace('{problemSlug}', encodeURIComponent('' + problemSlug));
    if (submissionId === undefined || submissionId === null)
      throw new Error("The parameter 'submissionId' must be defined.");
    url_ = url_.replace('{submissionId}', encodeURIComponent('' + submissionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSubmissions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSubmissions(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionResultLimitedDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              ProblemSubmissionResultLimitedDto[]
            >;
        })
      );
  }

  protected processSubmissions(
    response: HttpResponseBase
  ): Observable<ProblemSubmissionResultLimitedDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ProblemSubmissionResultLimitedDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionResultLimitedDto[]>(null as any);
  }

  /**
   * @return Success
   */
  migrate(): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/migrate';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMigrate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMigrate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processMigrate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param problemId (optional)
   * @param judgerMappingId (optional)
   * @param body (optional)
   * @return Success
   */
  runCode(
    problemId: string | undefined,
    judgerMappingId: number | undefined,
    isCustomInputEnabled: boolean | undefined,
    customInput: string | undefined,
    body: string | undefined
  ): Observable<ProblemSubmissionResultDto[]> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/run-code?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    if (judgerMappingId === null)
      throw new Error("The parameter 'judgerMappingId' cannot be null.");
    else if (judgerMappingId !== undefined)
      url_ += 'judgerMappingId=' + encodeURIComponent('' + judgerMappingId) + '&';
    if (isCustomInputEnabled === null)
      throw new Error("The parameter 'isCustomInputEnabled' cannot be null.");
    else if (isCustomInputEnabled !== undefined)
      url_ += 'isCustomInputEnabled=' + encodeURIComponent('' + isCustomInputEnabled) + '&';
    if (customInput !== undefined)
      url_ += 'customInput=' + encodeURIComponent('' + customInput) + '&';

    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunCode(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunCode(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionResultDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ProblemSubmissionResultDto[]>;
        })
      );
  }

  protected processRunCode(response: HttpResponseBase): Observable<ProblemSubmissionResultDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ProblemSubmissionResultDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionResultDto[]>(null as any);
  }

  /**
   * @param problemId (optional)
   * @param problemSubmissionId (optional)
   * @param contestId (optional)
   * @return Success
   */
  runJudger(
    problemId: string | undefined,
    problemSubmissionId: string | undefined,
    contestId: string | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/run-judger?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    if (problemSubmissionId === null)
      throw new Error("The parameter 'problemSubmissionId' cannot be null.");
    else if (problemSubmissionId !== undefined)
      url_ += 'problemSubmissionId=' + encodeURIComponent('' + problemSubmissionId) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunJudger(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunJudger(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRunJudger(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param problemId (optional)
   * @param problemSubmissionId (optional)
   * @param problemTestCaseId (optional)
   * @param contestId (optional)
   * @return Success
   */
  runJudgerForTestCase(
    problemId: string | undefined,
    problemSubmissionId: string | undefined,
    problemTestCaseId: string | undefined,
    contestId: string | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/run-judger-for-test-case?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    if (problemSubmissionId === null)
      throw new Error("The parameter 'problemSubmissionId' cannot be null.");
    else if (problemSubmissionId !== undefined)
      url_ += 'problemSubmissionId=' + encodeURIComponent('' + problemSubmissionId) + '&';
    if (problemTestCaseId === null)
      throw new Error("The parameter 'problemTestCaseId' cannot be null.");
    else if (problemTestCaseId !== undefined)
      url_ += 'problemTestCaseId=' + encodeURIComponent('' + problemTestCaseId) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunJudgerForTestCase(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunJudgerForTestCase(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRunJudgerForTestCase(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param problemId (optional)
   * @param problemSubmissionId (optional)
   * @param contestId (optional)
   * @param body (optional)
   * @return Success
   */
  runJudgerForTestCases(
    problemId: string | undefined,
    problemSubmissionId: string | undefined,
    contestId: string | undefined,
    body: string[] | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/run-judger-for-test-cases?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    if (problemSubmissionId === null)
      throw new Error("The parameter 'problemSubmissionId' cannot be null.");
    else if (problemSubmissionId !== undefined)
      url_ += 'problemSubmissionId=' + encodeURIComponent('' + problemSubmissionId) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRunJudgerForTestCases(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRunJudgerForTestCases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRunJudgerForTestCases(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param problemSubmissionId (optional)
   * @param problemTestCaseId (optional)
   * @param contestId (optional)
   * @return Success
   */
  trackTestCase(
    problemSubmissionId: string | undefined,
    problemTestCaseId: string | undefined,
    contestId: string | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/track-test-case?';
    if (problemSubmissionId === null)
      throw new Error("The parameter 'problemSubmissionId' cannot be null.");
    else if (problemSubmissionId !== undefined)
      url_ += 'problemSubmissionId=' + encodeURIComponent('' + problemSubmissionId) + '&';
    if (problemTestCaseId === null)
      throw new Error("The parameter 'problemTestCaseId' cannot be null.");
    else if (problemTestCaseId !== undefined)
      url_ += 'problemTestCaseId=' + encodeURIComponent('' + problemTestCaseId) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTrackTestCase(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTrackTestCase(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTrackTestCase(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param problemId (optional)
   * @param problemSubmissionId (optional)
   * @param problemTestCaseId (optional)
   * @param contestId (optional)
   * @return Success
   */
  trackTestCaseWithProblemId(
    problemId: string | undefined,
    problemSubmissionId: string | undefined,
    problemTestCaseId: string | undefined,
    contestId: string | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/track-test-case-with-problemId?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    if (problemSubmissionId === null)
      throw new Error("The parameter 'problemSubmissionId' cannot be null.");
    else if (problemSubmissionId !== undefined)
      url_ += 'problemSubmissionId=' + encodeURIComponent('' + problemSubmissionId) + '&';
    if (problemTestCaseId === null)
      throw new Error("The parameter 'problemTestCaseId' cannot be null.");
    else if (problemTestCaseId !== undefined)
      url_ += 'problemTestCaseId=' + encodeURIComponent('' + problemTestCaseId) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTrackTestCaseWithProblemId(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTrackTestCaseWithProblemId(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTrackTestCaseWithProblemId(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param problemId (optional)
   * @param problemSubmissionId (optional)
   * @param contestId (optional)
   * @param body (optional)
   * @return Success
   */
  trackTestCases(
    problemId: string | undefined,
    problemSubmissionId: string | undefined,
    contestId: string | undefined,
    body: string[] | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/track-test-cases?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    if (problemSubmissionId === null)
      throw new Error("The parameter 'problemSubmissionId' cannot be null.");
    else if (problemSubmissionId !== undefined)
      url_ += 'problemSubmissionId=' + encodeURIComponent('' + problemSubmissionId) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTrackTestCases(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTrackTestCases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTrackTestCases(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param problemId (optional)
   * @param submissionDate (optional)
   * @param status (optional)
   * @param userId (optional)
   * @return Success
   */
  contestsScore(
    contestId: string | undefined,
    problemId: string | undefined,
    submissionDate: Date | undefined,
    status: ContestScoreStatus | undefined,
    userId: string | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/contests-score?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    if (submissionDate === null) throw new Error("The parameter 'submissionDate' cannot be null.");
    else if (submissionDate !== undefined)
      url_ +=
        'submissionDate=' +
        encodeURIComponent(submissionDate ? '' + submissionDate.toISOString() : '') +
        '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'status=' + encodeURIComponent('' + status) + '&';
    if (userId === null) throw new Error("The parameter 'userId' cannot be null.");
    else if (userId !== undefined) url_ += 'userId=' + encodeURIComponent('' + userId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestsScore(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestsScore(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processContestsScore(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  auth(problemSlug: string, submissionId: string): Observable<ProblemSubmissionResultDto[]> {
    let url_ =
      this.baseUrl +
      '/api/app/problem-submission-results/by-slug/{problemSlug}/submissions/{submissionId}/auth';
    if (problemSlug === undefined || problemSlug === null)
      throw new Error("The parameter 'problemSlug' must be defined.");
    url_ = url_.replace('{problemSlug}', encodeURIComponent('' + problemSlug));
    if (submissionId === undefined || submissionId === null)
      throw new Error("The parameter 'submissionId' must be defined.");
    url_ = url_.replace('{submissionId}', encodeURIComponent('' + submissionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAuth(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAuth(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionResultDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ProblemSubmissionResultDto[]>;
        })
      );
  }

  protected processAuth(response: HttpResponseBase): Observable<ProblemSubmissionResultDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ProblemSubmissionResultDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionResultDto[]>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemSubmissionsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemSubmissionResultsPost(
    body: ProblemSubmissionCreateUpdateDto | undefined
  ): Observable<ProblemSubmissionDto> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSubmissionResultsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSubmissionResultsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSubmissionDto>;
        })
      );
  }

  protected processProblemSubmissionResultsPost(
    response: HttpResponseBase
  ): Observable<ProblemSubmissionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemSubmissionDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionDto>(null as any);
  }

  /**
   * @param filter (optional)
   * @param status (optional)
   * @param problemId (optional)
   * @param programmingLanguageId (optional)
   * @param creatorId (optional)
   * @param userName (optional)
   * @param slugFilter_Slug (optional)
   * @param slugFilter_CombineWith (optional)
   * @param allSubmissions (optional)
   * @param context (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  problemSubmissionResultsGetByList(
    filter: string | undefined,
    status: ProblemSubmissionStatus[] | undefined,
    problemId: string | undefined,
    programmingLanguageId: string[] | undefined,
    creatorId: string[] | undefined,
    userName: string | undefined,
    slugFilter_Slug: string | undefined,
    slugFilter_CombineWith: CombineType | undefined,
    allSubmissions: boolean | undefined,
    context: Context | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined)
      status &&
        status.forEach(item => {
          url_ += 'Status=' + encodeURIComponent('' + item) + '&';
        });
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'ProblemId=' + encodeURIComponent('' + problemId) + '&';
    if (programmingLanguageId === null)
      throw new Error("The parameter 'programmingLanguageId' cannot be null.");
    else if (programmingLanguageId !== undefined)
      programmingLanguageId &&
        programmingLanguageId.forEach(item => {
          url_ += 'ProgrammingLanguageId=' + encodeURIComponent('' + item) + '&';
        });
    if (creatorId === null) throw new Error("The parameter 'creatorId' cannot be null.");
    else if (creatorId !== undefined)
      creatorId &&
        creatorId.forEach(item => {
          url_ += 'CreatorId=' + encodeURIComponent('' + item) + '&';
        });
    if (userName === null) throw new Error("The parameter 'userName' cannot be null.");
    else if (userName !== undefined) url_ += 'UserName=' + encodeURIComponent('' + userName) + '&';
    if (slugFilter_Slug === null)
      throw new Error("The parameter 'slugFilter_Slug' cannot be null.");
    else if (slugFilter_Slug !== undefined)
      url_ += 'SlugFilter.Slug=' + encodeURIComponent('' + slugFilter_Slug) + '&';
    if (slugFilter_CombineWith === null)
      throw new Error("The parameter 'slugFilter_CombineWith' cannot be null.");
    else if (slugFilter_CombineWith !== undefined)
      url_ += 'SlugFilter.CombineWith=' + encodeURIComponent('' + slugFilter_CombineWith) + '&';
    if (allSubmissions === null) throw new Error("The parameter 'allSubmissions' cannot be null.");
    else if (allSubmissions !== undefined)
      url_ += 'AllSubmissions=' + encodeURIComponent('' + allSubmissions) + '&';
    if (context === null) throw new Error("The parameter 'context' cannot be null.");
    else if (context !== undefined) url_ += 'Context=' + encodeURIComponent('' + context) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSubmissionResultsGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSubmissionResultsGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processProblemSubmissionResultsGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  problemSubmissionResultsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSubmissionResultsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSubmissionResultsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProblemSubmissionResultsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  problemSubmissionResultsGetById(id: string): Observable<ProblemSubmissionDto> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSubmissionResultsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSubmissionResultsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSubmissionDto>;
        })
      );
  }

  protected processProblemSubmissionResultsGetById(
    response: HttpResponseBase
  ): Observable<ProblemSubmissionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemSubmissionDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemSubmissionResultsPut(
    id: string,
    body: ProblemSubmissionCreateUpdateDto | undefined
  ): Observable<ProblemSubmissionDto> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemSubmissionResultsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemSubmissionResultsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSubmissionDto>;
        })
      );
  }

  protected processProblemSubmissionResultsPut(
    response: HttpResponseBase
  ): Observable<ProblemSubmissionDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemSubmissionDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionDto>(null as any);
  }

  /**
   * @return Success
   */
  all(problemId: string): Observable<ProblemSubmissionDto[]> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/all/{problemId}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAll(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSubmissionDto[]>;
        })
      );
  }

  protected processAll(response: HttpResponseBase): Observable<ProblemSubmissionDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProblemSubmissionDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionDto[]>(null as any);
  }

  /**
   * @param contestId
   * @param problemId
   * @param skipCount
   * @param maxResultCount
   * @param requestForAllSubmissions
   * @param status
   * @param programmingLanguageId
   * @param creatorId
   * @returns submission result of contest
   */
  allByContest(
    contestId: string | undefined,
    problemId: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    requestForAllSubmissions: boolean = false,
    status: string | undefined = undefined,
    programmingLanguageId: string | undefined = undefined,
    creatorId: string | undefined = undefined
  ): Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/all-by-contest?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'ProblemId=' + encodeURIComponent('' + problemId) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (requestForAllSubmissions === null)
      throw new Error("The parameter 'requestForAllSubmissions' cannot be null.");
    else if (requestForAllSubmissions !== undefined)
      url_ += 'AllSubmissions=' + encodeURIComponent('' + requestForAllSubmissions) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (programmingLanguageId === null)
      throw new Error("The parameter 'ProgrammingLanguageId' cannot be null.");
    else if (programmingLanguageId !== undefined)
      url_ += 'ProgrammingLanguageId=' + encodeURIComponent('' + programmingLanguageId) + '&';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (creatorId !== undefined)
      url_ += 'CreatorId=' + encodeURIComponent('' + creatorId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAllByContest(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAllByContest(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAllByContest(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  byProblemSlug(problemSlug: string): Observable<ProblemSubmissionDto[]> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/by-problem-slug/{problemSlug}';
    if (problemSlug === undefined || problemSlug === null)
      throw new Error("The parameter 'problemSlug' must be defined.");
    url_ = url_.replace('{problemSlug}', encodeURIComponent('' + problemSlug));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByProblemSlug(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByProblemSlug(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSubmissionDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSubmissionDto[]>;
        })
      );
  }

  protected processByProblemSlug(response: HttpResponseBase): Observable<ProblemSubmissionDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProblemSubmissionDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSubmissionDto[]>(null as any);
  }

  /**
   * @param contestProblemId (optional)
   * @return Success
   */
  solvedCountFromCache(contestProblemId: string | undefined): Observable<number> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/solved-count-from-cache?';
    if (contestProblemId === null)
      throw new Error("The parameter 'contestProblemId' cannot be null.");
    else if (contestProblemId !== undefined)
      url_ += 'contestProblemId=' + encodeURIComponent('' + contestProblemId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSolvedCountFromCache(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSolvedCountFromCache(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processSolvedCountFromCache(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }

  /**
   * @param contestId (optional)
   * @param status (optional)
   * @param username (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  contestSubmissions(
    contestId: string | undefined,
    status: ProblemSubmissionStatus | undefined,
    username: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problem-submission-results/contest-submissions?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'ContestId=' + encodeURIComponent('' + contestId) + '&';
    if (status === null) throw new Error("The parameter 'status' cannot be null.");
    else if (status !== undefined) url_ += 'Status=' + encodeURIComponent('' + status) + '&';
    if (username === null) throw new Error("The parameter 'username' cannot be null.");
    else if (username !== undefined) url_ += 'Username=' + encodeURIComponent('' + username) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestSubmissions(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestSubmissions(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processContestSubmissions(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProblemTestCasesClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @param problemId (optional)
   * @param body (optional)
   * @return Success
   */
  bulkImport(
    problemId: string | undefined,
    body: ProblemTestCaseBulkImportDto | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-test-cases/bulk-import?';
    if (problemId === null) throw new Error("The parameter 'problemId' cannot be null.");
    else if (problemId !== undefined)
      url_ += 'problemId=' + encodeURIComponent('' + problemId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processBulkImport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processBulkImport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processBulkImport(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  canICreate(problemId: string): Observable<boolean> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/can-i-create';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCanICreate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCanICreate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processCanICreate(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @return Success
   */
  canIModify(problemId: string, testCaseId: string): Observable<boolean> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/{testCaseId}/can-i-modify';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    if (testCaseId === undefined || testCaseId === null)
      throw new Error("The parameter 'testCaseId' must be defined.");
    url_ = url_.replace('{testCaseId}', encodeURIComponent('' + testCaseId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCanIModify(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCanIModify(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<boolean>;
            }
          } else return _observableThrow(response_) as any as Observable<boolean>;
        })
      );
  }

  protected processCanIModify(response: HttpResponseBase): Observable<boolean> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<boolean>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  testCasesPost(
    problemId: string,
    body: ProblemTestCaseCreateUpdateDto | undefined
  ): Observable<ProblemTestCaseDto> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCasesPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCasesPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemTestCaseDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemTestCaseDto>;
        })
      );
  }

  protected processTestCasesPost(response: HttpResponseBase): Observable<ProblemTestCaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemTestCaseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemTestCaseDto>(null as any);
  }

  /**
   * @return Success
   */
  testCasesGetById(
    problemId: string
  ): Observable<PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCasesGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCasesGetById(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processTestCasesGetById(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  testCasesDelete(problemId: string, id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/{id}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCasesDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCasesDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTestCasesDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  testCasesGet(problemId: string, id: string): Observable<ProblemTestCaseDto> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/{id}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCasesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCasesGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemTestCaseDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemTestCaseDto>;
        })
      );
  }

  protected processTestCasesGet(response: HttpResponseBase): Observable<ProblemTestCaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemTestCaseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemTestCaseDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  testCasesPut(
    problemId: string,
    id: string,
    body: ProblemTestCaseCreateUpdateDto | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/{id}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTestCasesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTestCasesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTestCasesPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  problemTestCases(body: string[] | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problem-test-cases';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProblemTestCases(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProblemTestCases(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProblemTestCases(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  samples(problemId: string): Observable<ProblemTestCaseDto[]> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/samples';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSamples(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSamples(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemTestCaseDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemTestCaseDto[]>;
        })
      );
  }

  protected processSamples(response: HttpResponseBase): Observable<ProblemTestCaseDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProblemTestCaseDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemTestCaseDto[]>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  import(problemId: string, body: ProblemTestCaseImportDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/import';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processImport(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processImport(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processImport(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  migrate(problemId: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/migrate';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMigrate(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMigrate(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processMigrate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  truncated(problemId: string, id: string): Observable<ProblemTestCaseDto> {
    let url_ = this.baseUrl + '/api/app/problems/{problemId}/test-cases/truncated/{id}';
    if (problemId === undefined || problemId === null)
      throw new Error("The parameter 'problemId' must be defined.");
    url_ = url_.replace('{problemId}', encodeURIComponent('' + problemId));
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTruncated(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTruncated(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemTestCaseDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemTestCaseDto>;
        })
      );
  }

  protected processTruncated(response: HttpResponseBase): Observable<ProblemTestCaseDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProblemTestCaseDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemTestCaseDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProfileClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  myProfileGet(): Observable<ProfileDto> {
    let url_ = this.baseUrl + '/api/identity/my-profile';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMyProfileGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMyProfileGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProfileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProfileDto>;
        })
      );
  }

  protected processMyProfileGet(response: HttpResponseBase): Observable<ProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProfileDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProfileDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  myProfilePut(body: UpdateProfileDto | undefined): Observable<ProfileDto> {
    let url_ = this.baseUrl + '/api/identity/my-profile';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processMyProfilePut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processMyProfilePut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProfileDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProfileDto>;
        })
      );
  }

  protected processMyProfilePut(response: HttpResponseBase): Observable<ProfileDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProfileDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProfileDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  changePassword(body: ChangePasswordInput | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/account/my-profile/change-password';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processChangePassword(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processChangePassword(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processChangePassword(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class ProgrammingLanguageClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  programmingLanguagesGetById(id: string): Observable<ProgrammingLanguageDto> {
    let url_ = this.baseUrl + '/api/app/programming-languages/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguagesGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguagesGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProgrammingLanguageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProgrammingLanguageDto>;
        })
      );
  }

  protected processProgrammingLanguagesGetById(
    response: HttpResponseBase
  ): Observable<ProgrammingLanguageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProgrammingLanguageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProgrammingLanguageDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  programmingLanguagesPut(
    id: string,
    body: ProgrammingLanguageCreateUpdateDto | undefined
  ): Observable<ProgrammingLanguageDto> {
    let url_ = this.baseUrl + '/api/app/programming-languages/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguagesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguagesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProgrammingLanguageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProgrammingLanguageDto>;
        })
      );
  }

  protected processProgrammingLanguagesPut(
    response: HttpResponseBase
  ): Observable<ProgrammingLanguageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProgrammingLanguageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProgrammingLanguageDto>(null as any);
  }

  /**
   * @return Success
   */
  programmingLanguagesDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/programming-languages/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguagesDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguagesDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processProgrammingLanguagesDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  programmingLanguagesGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/programming-languages?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguagesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguagesGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processProgrammingLanguagesGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  programmingLanguagesPost(
    body: ProgrammingLanguageCreateUpdateDto | undefined
  ): Observable<ProgrammingLanguageDto> {
    let url_ = this.baseUrl + '/api/app/programming-languages';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processProgrammingLanguagesPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processProgrammingLanguagesPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProgrammingLanguageDto>;
            }
          } else return _observableThrow(response_) as any as Observable<ProgrammingLanguageDto>;
        })
      );
  }

  protected processProgrammingLanguagesPost(
    response: HttpResponseBase
  ): Observable<ProgrammingLanguageDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ProgrammingLanguageDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProgrammingLanguageDto>(null as any);
  }

  /**
   * @return Success
   */
  lookup(): Observable<ProgrammingLanguageLookupDto[]> {
    let url_ = this.baseUrl + '/api/app/programming-languages/lookup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProgrammingLanguageLookupDto[]>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ProgrammingLanguageLookupDto[]>;
        })
      );
  }

  protected processLookup(response: HttpResponseBase): Observable<ProgrammingLanguageLookupDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(ProgrammingLanguageLookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProgrammingLanguageLookupDto[]>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class RoleClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  all(): Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/identity/roles/all';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAll(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAll(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAll(
    response: HttpResponseBase
  ): Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  rolesGet(
    filter: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/identity/roles?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processRolesGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  rolesPost(body: IdentityRoleCreateDto | undefined): Observable<IdentityRoleDto> {
    let url_ = this.baseUrl + '/api/identity/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityRoleDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityRoleDto>;
        })
      );
  }

  protected processRolesPost(response: HttpResponseBase): Observable<IdentityRoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityRoleDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityRoleDto>(null as any);
  }

  /**
   * @return Success
   */
  rolesGetById(id: string): Observable<IdentityRoleDto> {
    let url_ = this.baseUrl + '/api/identity/roles/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityRoleDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityRoleDto>;
        })
      );
  }

  protected processRolesGetById(response: HttpResponseBase): Observable<IdentityRoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityRoleDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityRoleDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  rolesPut(id: string, body: IdentityRoleUpdateDto | undefined): Observable<IdentityRoleDto> {
    let url_ = this.baseUrl + '/api/identity/roles/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityRoleDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityRoleDto>;
        })
      );
  }

  protected processRolesPut(response: HttpResponseBase): Observable<IdentityRoleDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityRoleDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityRoleDto>(null as any);
  }

  /**
   * @return Success
   */
  rolesDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/identity/roles/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRolesDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class SchoolClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  schoolGetById(id: string): Observable<SchoolDto> {
    let url_ = this.baseUrl + '/api/app/school/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSchoolGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSchoolGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SchoolDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SchoolDto>;
        })
      );
  }

  protected processSchoolGetById(response: HttpResponseBase): Observable<SchoolDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SchoolDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SchoolDto>(null as any);
  }

  /**
   * @return Success
   */
  schoolDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/school/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSchoolDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSchoolDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSchoolDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private schoolGetByListCache$: Observable<PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
  private schoolGetByListUrl = '';
  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  schoolGetByList(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/school?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    if (!this.schoolGetByListCache$ || this.schoolGetByListUrl !== url_) {
      this.schoolGetByListCache$ = this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processSchoolGetByList(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processSchoolGetByList(response_ as any);
              } catch (e) {
                return _observableThrow(
                  e
                ) as any as Observable<PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
              }
            } else
              return _observableThrow(
                response_
              ) as any as Observable<PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
          })
        );
    }
    return this.schoolGetByListCache$;
  }

  protected processSchoolGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  schoolPost(body: SchoolCreateUpdateDto | undefined): Observable<SchoolDto> {
    let url_ = this.baseUrl + '/api/app/school';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSchoolPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSchoolPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SchoolDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SchoolDto>;
        })
      );
  }

  protected processSchoolPost(response: HttpResponseBase): Observable<SchoolDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SchoolDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SchoolDto>(null as any);
  }

  /**
   * @param id (optional)
   * @param body (optional)
   * @return Success
   */
  schoolPut(
    id: string | undefined,
    body: SchoolCreateUpdateDto | undefined
  ): Observable<SchoolDto> {
    let url_ = this.baseUrl + '/api/app/school?';
    if (id === null) throw new Error("The parameter 'id' cannot be null.");
    else if (id !== undefined) url_ += 'id=' + encodeURIComponent('' + id) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSchoolPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSchoolPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SchoolDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SchoolDto>;
        })
      );
  }

  protected processSchoolPut(response: HttpResponseBase): Observable<SchoolDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SchoolDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SchoolDto>(null as any);
  }

  /**
   * @return Success
   */
  citiesLookup(): Observable<CityLookupDto[]> {
    let url_ = this.baseUrl + '/api/app/school/cities-lookup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCitiesLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCitiesLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<CityLookupDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<CityLookupDto[]>;
        })
      );
  }

  protected processCitiesLookup(response: HttpResponseBase): Observable<CityLookupDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(CityLookupDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CityLookupDto[]>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class SocialAccountsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  socialAccountsGetById(id: string): Observable<SocialAccountDto> {
    let url_ = this.baseUrl + '/api/app/social-accounts/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSocialAccountsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSocialAccountsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SocialAccountDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SocialAccountDto>;
        })
      );
  }

  protected processSocialAccountsGetById(response: HttpResponseBase): Observable<SocialAccountDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SocialAccountDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SocialAccountDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  socialAccountsPut(
    id: string,
    body: SocialAccountCreateUpdateDto | undefined
  ): Observable<SocialAccountDto> {
    let url_ = this.baseUrl + '/api/app/social-accounts/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSocialAccountsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSocialAccountsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SocialAccountDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SocialAccountDto>;
        })
      );
  }

  protected processSocialAccountsPut(response: HttpResponseBase): Observable<SocialAccountDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SocialAccountDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SocialAccountDto>(null as any);
  }

  /**
   * @return Success
   */
  socialAccountsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/social-accounts/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSocialAccountsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSocialAccountsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSocialAccountsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @return Success
   */
  socialAccountsGet(
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined
  ): Observable<PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/social-accounts?';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSocialAccountsGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSocialAccountsGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processSocialAccountsGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  socialAccountsPost(body: SocialAccountCreateUpdateDto | undefined): Observable<SocialAccountDto> {
    let url_ = this.baseUrl + '/api/app/social-accounts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSocialAccountsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSocialAccountsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SocialAccountDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SocialAccountDto>;
        })
      );
  }

  protected processSocialAccountsPost(response: HttpResponseBase): Observable<SocialAccountDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SocialAccountDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SocialAccountDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class SourceClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  sourcesGetById(id: string): Observable<SourceDto> {
    let url_ = this.baseUrl + '/api/app/sources/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSourcesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSourcesGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SourceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SourceDto>;
        })
      );
  }

  protected processSourcesGetById(response: HttpResponseBase): Observable<SourceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SourceDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SourceDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sourcesPut(id: string, body: CreateUpdateSourceDto | undefined): Observable<SourceDto> {
    let url_ = this.baseUrl + '/api/app/sources/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSourcesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSourcesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SourceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SourceDto>;
        })
      );
  }

  protected processSourcesPut(response: HttpResponseBase): Observable<SourceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SourceDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SourceDto>(null as any);
  }

  /**
   * @return Success
   */
  sourcesDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/sources/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSourcesDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSourcesDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processSourcesDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  sourcesGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/sources?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSourcesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSourcesGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processSourcesGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  sourcesPost(body: CreateUpdateSourceDto | undefined): Observable<SourceDto> {
    let url_ = this.baseUrl + '/api/app/sources';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSourcesPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSourcesPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<SourceDto>;
            }
          } else return _observableThrow(response_) as any as Observable<SourceDto>;
        })
      );
  }

  protected processSourcesPost(response: HttpResponseBase): Observable<SourceDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = SourceDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<SourceDto>(null as any);
  }

  /**
   * @return Success
   */
  lookup(): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    let url_ = this.baseUrl + '/api/app/sources/lookup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
            >;
        })
      );
  }

  protected processLookup(
    response: HttpResponseBase
  ): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<
      LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    >(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class StatisticsClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;
  private upcomingCache$: Observable<UpcomingContestDto>;
  private upcomingUrl = '';

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  upcoming(): Observable<UpcomingContestDto> {
    let url_ = this.baseUrl + '/api/app/statics/contests/upcoming';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    if (!this.upcomingCache$ || this.upcomingUrl !== url_) {
      this.upcomingUrl = url_;
      this.upcomingCache$ = this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processUpcoming(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processUpcoming(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<UpcomingContestDto>;
              }
            } else return _observableThrow(response_) as any as Observable<UpcomingContestDto>;
          })
        );
    }
    return this.upcomingCache$;
  }

  protected processUpcoming(response: HttpResponseBase): Observable<UpcomingContestDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UpcomingContestDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UpcomingContestDto>(null as any);
  }

  private previousContestsCache$: Observable<PreviousContestDto[]>;
  private previousContestsUrl = '';
  previous(): Observable<PreviousContestDto[]> {
    let url_ = this.baseUrl + '/api/app/statics/contests/previous';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    if (!this.previousContestsCache$ || this.previousContestsUrl !== url_) {
      this.previousContestsUrl = url_;
      this.previousContestsCache$ = this.http
        .request('get', url_, options_)
        .pipe(
          shareReplay(1),
          _observableMergeMap((response_: any) => {
            return this.processPrevious(response_);
          })
        )
        .pipe(
          _observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
              try {
                return this.processPrevious(response_ as any);
              } catch (e) {
                return _observableThrow(e) as any as Observable<PreviousContestDto[]>;
              }
            } else return _observableThrow(response_) as any as Observable<PreviousContestDto[]>;
          })
        );
    }
    return this.previousContestsCache$;
  }

  protected processPrevious(response: HttpResponseBase): Observable<PreviousContestDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(PreviousContestDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PreviousContestDto[]>(null as any);
  }

  topProblemSetterUsers(): Observable<ProblemSetterDto[]> {
    let url_ = this.baseUrl + '/api/app/statics/top-problem-setter-users';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        shareReplay(1),
        _observableMergeMap((response_: any) => {
          return this.processTopProblemSetterUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTopProblemSetterUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSetterDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSetterDto[]>;
        })
      );
  }

  protected processTopProblemSetterUsers(
    response: HttpResponseBase
  ): Observable<ProblemSetterDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProblemSetterDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSetterDto[]>(null as any);
  }

  topProblemSolverUsers(filter: ProblemSolverFilter | undefined): Observable<ProblemSolverDto[]> {
    let url_ = this.baseUrl + '/api/app/statics/top-problem-solver-users?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'filter=' + encodeURIComponent('' + filter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        shareReplay(1),
        _observableMergeMap((response_: any) => {
          return this.processTopProblemSolverUsers(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTopProblemSolverUsers(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ProblemSolverDto[]>;
            }
          } else return _observableThrow(response_) as any as Observable<ProblemSolverDto[]>;
        })
      );
  }

  protected processTopProblemSolverUsers(
    response: HttpResponseBase
  ): Observable<ProblemSolverDto[]> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200) result200!.push(ProblemSolverDto.fromJS(item));
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ProblemSolverDto[]>(null as any);
  }

  /**
   * @param contestId (optional)
   * @return Success
   */
  contestProblemStatistics(contestId: string | undefined): Observable<ContestProblemStatisticsDto> {
    let url_ = this.baseUrl + '/api/app/statics/contest-problem-statistics?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestProblemStatistics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestProblemStatistics(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestProblemStatisticsDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ContestProblemStatisticsDto>;
        })
      );
  }

  protected processContestProblemStatistics(
    response: HttpResponseBase
  ): Observable<ContestProblemStatisticsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestProblemStatisticsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestProblemStatisticsDto>(null as any);
  }

  /**
   * @param contestId (optional)
   * @return Success
   */
  contestSignupsStatistics(contestId: string | undefined): Observable<ContestSignupsStatisticsDto> {
    let url_ = this.baseUrl + '/api/app/statics/contest-signups-statistics?';
    if (contestId === null) throw new Error("The parameter 'contestId' cannot be null.");
    else if (contestId !== undefined)
      url_ += 'contestId=' + encodeURIComponent('' + contestId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processContestSignupsStatistics(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processContestSignupsStatistics(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<ContestSignupsStatisticsDto>;
            }
          } else
            return _observableThrow(response_) as any as Observable<ContestSignupsStatisticsDto>;
        })
      );
  }

  protected processContestSignupsStatistics(
    response: HttpResponseBase
  ): Observable<ContestSignupsStatisticsDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = ContestSignupsStatisticsDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ContestSignupsStatisticsDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class TagClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  tagGetById(id: string): Observable<TagDto> {
    let url_ = this.baseUrl + '/api/app/tag/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTagGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTagGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TagDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TagDto>;
        })
      );
  }

  protected processTagGetById(response: HttpResponseBase): Observable<TagDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TagDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TagDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  tagPut(id: string, body: CreateUpdateTagDto | undefined): Observable<TagDto> {
    let url_ = this.baseUrl + '/api/app/tag/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTagPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTagPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TagDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TagDto>;
        })
      );
  }

  protected processTagPut(response: HttpResponseBase): Observable<TagDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TagDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TagDto>(null as any);
  }

  /**
   * @return Success
   */
  tagDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/app/tag/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTagDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTagDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTagDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @param sorting (optional)
   * @param combineWith (optional)
   * @return Success
   */
  tagGet(
    filter: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined,
    sorting: string | undefined,
    combineWith: CombineType | undefined
  ): Observable<PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/app/tag?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (combineWith === null) throw new Error("The parameter 'combineWith' cannot be null.");
    else if (combineWith !== undefined)
      url_ += 'CombineWith=' + encodeURIComponent('' + combineWith) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTagGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTagGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processTagGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  tagPost(body: CreateUpdateTagDto | undefined): Observable<TagDto> {
    let url_ = this.baseUrl + '/api/app/tag';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTagPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTagPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TagDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TagDto>;
        })
      );
  }

  protected processTagPost(response: HttpResponseBase): Observable<TagDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TagDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TagDto>(null as any);
  }

  /**
   * @return Success
   */
  lookup(): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    let url_ = this.baseUrl + '/api/app/tag/lookup';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
            >;
        })
      );
  }

  protected processLookup(
    response: HttpResponseBase
  ): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<
      LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    >(null as any);
  }

  /**
   * @param ids (optional)
   * @return Success
   */
  getById(
    ids: string[] | undefined
  ): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    let url_ = this.baseUrl + '/api/app/tag/get-by-id?';
    if (ids === null) throw new Error("The parameter 'ids' cannot be null.");
    else if (ids !== undefined)
      ids &&
        ids.forEach(item => {
          url_ += 'ids=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
              >;
            }
          } else
            return _observableThrow(response_) as any as Observable<
              LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
            >;
        })
      );
  }

  protected processGetById(
    response: HttpResponseBase
  ): Observable<
    LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
  > {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          if (Array.isArray(resultData200)) {
            result200 = [] as any;
            for (let item of resultData200)
              result200!.push(
                LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
                  item
                )
              );
          } else {
            result200 = <any>null;
          }
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<
      LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    >(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class TenantClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  tenantsGetById(id: string): Observable<TenantDto> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTenantsGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTenantsGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantDto>;
        })
      );
  }

  protected processTenantsGetById(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  tenantsPut(id: string, body: TenantUpdateDto | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTenantsPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTenantsPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantDto>;
        })
      );
  }

  protected processTenantsPut(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(null as any);
  }

  /**
   * @return Success
   */
  tenantsDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTenantsDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTenantsDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processTenantsDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  tenantsGetByList(
    filter: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTenantsGetByList(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTenantsGetByList(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processTenantsGetByList(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  tenantsPost(body: TenantCreateDto | undefined): Observable<TenantDto> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processTenantsPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processTenantsPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<TenantDto>;
            }
          } else return _observableThrow(response_) as any as Observable<TenantDto>;
        })
      );
  }

  protected processTenantsPost(response: HttpResponseBase): Observable<TenantDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = TenantDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<TenantDto>(null as any);
  }

  /**
   * @return Success
   */
  defaultConnectionStringGet(id: string): Observable<string> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants/{id}/default-connection-string';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDefaultConnectionStringGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDefaultConnectionStringGet(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<string>;
            }
          } else return _observableThrow(response_) as any as Observable<string>;
        })
      );
  }

  protected processDefaultConnectionStringGet(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * @param defaultConnectionString (optional)
   * @return Success
   */
  defaultConnectionStringPut(
    id: string,
    defaultConnectionString: string | undefined
  ): Observable<void> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants/{id}/default-connection-string?';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (defaultConnectionString === null)
      throw new Error("The parameter 'defaultConnectionString' cannot be null.");
    else if (defaultConnectionString !== undefined)
      url_ += 'defaultConnectionString=' + encodeURIComponent('' + defaultConnectionString) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDefaultConnectionStringPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDefaultConnectionStringPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDefaultConnectionStringPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  defaultConnectionStringDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/multi-tenancy/tenants/{id}/default-connection-string';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDefaultConnectionStringDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processDefaultConnectionStringDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processDefaultConnectionStringDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class UserClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  usersGetById(id: string): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/identity/users/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersGetById(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersGetById(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processUsersGetById(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }

  /**
   * @param body (optional)
   * @return Success
   */
  usersPut(id: string, body: IdentityUserUpdateDto | undefined): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/identity/users/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processUsersPut(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }

  /**
   * @return Success
   */
  usersDelete(id: string): Observable<void> {
    let url_ = this.baseUrl + '/api/identity/users/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersDelete(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersDelete(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processUsersDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  usersGet(
    filter: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/identity/users?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processUsersGet(
    response: HttpResponseBase
  ): Observable<PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  usersPost(body: IdentityUserCreateDto | undefined): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/identity/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUsersPost(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processUsersPost(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processUsersPost(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }

  /**
   * @return Success
   */
  rolesGet(
    id: string
  ): Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/identity/users/{id}/roles';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesGet(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesGet(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processRolesGet(
    response: HttpResponseBase
  ): Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param body (optional)
   * @return Success
   */
  rolesPut(id: string, body: IdentityUserUpdateRolesDto | undefined): Observable<void> {
    let url_ = this.baseUrl + '/api/identity/users/{id}/roles';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processRolesPut(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processRolesPut(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<void>;
            }
          } else return _observableThrow(response_) as any as Observable<void>;
        })
      );
  }

  protected processRolesPut(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * @return Success
   */
  assignableRoles(): Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/identity/users/assignable-roles';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processAssignableRoles(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processAssignableRoles(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processAssignableRoles(
    response: HttpResponseBase
  ): Observable<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @return Success
   */
  byUsername(userName: string): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/identity/users/by-username/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByUsername(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processByUsername(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }

  /**
   * @return Success
   */
  byEmail(email: string): Observable<IdentityUserDto> {
    let url_ = this.baseUrl + '/api/identity/users/by-email/{email}';
    if (email === undefined || email === null)
      throw new Error("The parameter 'email' must be defined.");
    url_ = url_.replace('{email}', encodeURIComponent('' + email));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByEmail(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByEmail(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<IdentityUserDto>;
            }
          } else return _observableThrow(response_) as any as Observable<IdentityUserDto>;
        })
      );
  }

  protected processByEmail(response: HttpResponseBase): Observable<IdentityUserDto> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = IdentityUserDto.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<IdentityUserDto>(null as any);
  }
}

@Injectable({
  providedIn: 'root',
})
export class UserLookupClient {
  private http: HttpClient;
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(@Inject(HttpClient) http: HttpClient, environmentService: EnvironmentService) {
    this.http = http;
    this.baseUrl = environmentService.getApiUrl('default');
  }

  /**
   * @return Success
   */
  lookup(id: string): Observable<UserData> {
    let url_ = this.baseUrl + '/api/identity/users/lookup/{id}';
    if (id === undefined || id === null) throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processLookup(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processLookup(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserData>;
            }
          } else return _observableThrow(response_) as any as Observable<UserData>;
        })
      );
  }

  protected processLookup(response: HttpResponseBase): Observable<UserData> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserData.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserData>(null as any);
  }

  /**
   * @return Success
   */
  byUsername(userName: string): Observable<UserData> {
    let url_ = this.baseUrl + '/api/identity/users/lookup/by-username/{userName}';
    if (userName === undefined || userName === null)
      throw new Error("The parameter 'userName' must be defined.");
    url_ = url_.replace('{userName}', encodeURIComponent('' + userName));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processByUsername(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processByUsername(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<UserData>;
            }
          } else return _observableThrow(response_) as any as Observable<UserData>;
        })
      );
  }

  protected processByUsername(response: HttpResponseBase): Observable<UserData> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = UserData.fromJS(resultData200);
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UserData>(null as any);
  }

  /**
   * @param filter (optional)
   * @param sorting (optional)
   * @param skipCount (optional)
   * @param maxResultCount (optional)
   * @return Success
   */
  search(
    filter: string | undefined,
    sorting: string | undefined,
    skipCount: number | undefined,
    maxResultCount: number | undefined
  ): Observable<ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    let url_ = this.baseUrl + '/api/identity/users/lookup/search?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    if (sorting === null) throw new Error("The parameter 'sorting' cannot be null.");
    else if (sorting !== undefined) url_ += 'Sorting=' + encodeURIComponent('' + sorting) + '&';
    if (skipCount === null) throw new Error("The parameter 'skipCount' cannot be null.");
    else if (skipCount !== undefined)
      url_ += 'SkipCount=' + encodeURIComponent('' + skipCount) + '&';
    if (maxResultCount === null) throw new Error("The parameter 'maxResultCount' cannot be null.");
    else if (maxResultCount !== undefined)
      url_ += 'MaxResultCount=' + encodeURIComponent('' + maxResultCount) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processSearch(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processSearch(response_ as any);
            } catch (e) {
              return _observableThrow(
                e
              ) as any as Observable<ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
            }
          } else
            return _observableThrow(
              response_
            ) as any as Observable<ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null>;
        })
      );
  }

  protected processSearch(
    response: HttpResponseBase
  ): Observable<ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 =
            ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(
              resultData200
            );
          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null>(
      null as any
    );
  }

  /**
   * @param filter (optional)
   * @return Success
   */
  count(filter: string | undefined): Observable<number> {
    let url_ = this.baseUrl + '/api/identity/users/lookup/count?';
    if (filter === null) throw new Error("The parameter 'filter' cannot be null.");
    else if (filter !== undefined) url_ += 'Filter=' + encodeURIComponent('' + filter) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCount(response_);
        })
      )
      .pipe(
        _observableCatch((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            try {
              return this.processCount(response_ as any);
            } catch (e) {
              return _observableThrow(e) as any as Observable<number>;
            }
          } else return _observableThrow(response_) as any as Observable<number>;
        })
      );
  }

  protected processCount(response: HttpResponseBase): Observable<number> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result200: any = null;
          let resultData200 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 !== undefined ? resultData200 : <any>null;

          return _observableOf(result200);
        })
      );
    } else if (status === 403) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result403: any = null;
          let resultData403 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result403 = RemoteServiceErrorResponse.fromJS(resultData403);
          return throwException('Forbidden', status, _responseText, _headers, result403);
        })
      );
    } else if (status === 401) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result401: any = null;
          let resultData401 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result401 = RemoteServiceErrorResponse.fromJS(resultData401);
          return throwException('Unauthorized', status, _responseText, _headers, result401);
        })
      );
    } else if (status === 400) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result400: any = null;
          let resultData400 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result400 = RemoteServiceErrorResponse.fromJS(resultData400);
          return throwException('Bad Request', status, _responseText, _headers, result400);
        })
      );
    } else if (status === 404) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result404: any = null;
          let resultData404 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result404 = RemoteServiceErrorResponse.fromJS(resultData404);
          return throwException('Not Found', status, _responseText, _headers, result404);
        })
      );
    } else if (status === 501) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result501: any = null;
          let resultData501 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result501 = RemoteServiceErrorResponse.fromJS(resultData501);
          return throwException('Server Error', status, _responseText, _headers, result501);
        })
      );
    } else if (status === 500) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          let result500: any = null;
          let resultData500 =
            _responseText === '' ? null : JSON.parse(_responseText, this.jsonParseReviver);
          result500 = RemoteServiceErrorResponse.fromJS(resultData500);
          return throwException('Server Error', status, _responseText, _headers, result500);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap(_responseText => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<number>(null as any);
  }
}

export enum CombineType {
  And = 'And',
  Or = 'Or',
}

export enum Sorting {
  Ascending = 'Ascending',
  Descending = 'Descending',
}

export class AuditLogActionDto implements IAuditLogActionDto {
  auditLogId?: string;
  serviceName?: string | undefined;
  methodName?: string | undefined;
  parameters?: string | undefined;
  executionTime?: Date;
  executionDuration?: number;
  extraProperties?: { [key: string]: any } | undefined;

  constructor(data?: IAuditLogActionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.auditLogId = _data['auditLogId'];
      this.serviceName = _data['serviceName'];
      this.methodName = _data['methodName'];
      this.parameters = _data['parameters'];
      this.executionTime = _data['executionTime']
        ? new Date(_data['executionTime'].toString())
        : <any>undefined;
      this.executionDuration = _data['executionDuration'];
      if (_data['extraProperties']) {
        this.extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>this.extraProperties)![key] = _data['extraProperties'][key];
        }
      }
    }
  }

  static fromJS(data: any): AuditLogActionDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditLogActionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['auditLogId'] = this.auditLogId;
    data['serviceName'] = this.serviceName;
    data['methodName'] = this.methodName;
    data['parameters'] = this.parameters;
    data['executionTime'] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
    data['executionDuration'] = this.executionDuration;
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    return data;
  }
}

export interface IAuditLogActionDto {
  auditLogId?: string;
  serviceName?: string | undefined;
  methodName?: string | undefined;
  parameters?: string | undefined;
  executionTime?: Date;
  executionDuration?: number;
  extraProperties?: { [key: string]: any } | undefined;
}

export class AuditLogDetailedDto implements IAuditLogDetailedDto {
  id?: string;
  httpStatusCode?: number | undefined;
  readonly comments?: string | undefined;
  readonly exceptions?: string | undefined;
  readonly url?: string | undefined;
  readonly httpMethod?: string | undefined;
  readonly browserInfo?: string | undefined;
  correlationId?: string | undefined;
  clientId?: string | undefined;
  readonly clientName?: string | undefined;
  readonly clientIpAddress?: string | undefined;
  readonly executionDuration?: number;
  readonly executionTime?: Date;
  readonly impersonatorTenantId?: string | undefined;
  readonly impersonatorUserId?: string | undefined;
  readonly tenantName?: string | undefined;
  readonly tenantId?: string | undefined;
  readonly userName?: string | undefined;
  readonly userId?: string | undefined;
  applicationName?: string | undefined;

  constructor(data?: IAuditLogDetailedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.httpStatusCode = _data['httpStatusCode'];
      (<any>this).comments = _data['comments'];
      (<any>this).exceptions = _data['exceptions'];
      (<any>this).url = _data['url'];
      (<any>this).httpMethod = _data['httpMethod'];
      (<any>this).browserInfo = _data['browserInfo'];
      this.correlationId = _data['correlationId'];
      this.clientId = _data['clientId'];
      (<any>this).clientName = _data['clientName'];
      (<any>this).clientIpAddress = _data['clientIpAddress'];
      (<any>this).executionDuration = _data['executionDuration'];
      (<any>this).executionTime = _data['executionTime']
        ? new Date(_data['executionTime'].toString())
        : <any>undefined;
      (<any>this).impersonatorTenantId = _data['impersonatorTenantId'];
      (<any>this).impersonatorUserId = _data['impersonatorUserId'];
      (<any>this).tenantName = _data['tenantName'];
      (<any>this).tenantId = _data['tenantId'];
      (<any>this).userName = _data['userName'];
      (<any>this).userId = _data['userId'];
      this.applicationName = _data['applicationName'];
    }
  }

  static fromJS(data: any): AuditLogDetailedDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditLogDetailedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['httpStatusCode'] = this.httpStatusCode;
    data['comments'] = this.comments;
    data['exceptions'] = this.exceptions;
    data['url'] = this.url;
    data['httpMethod'] = this.httpMethod;
    data['browserInfo'] = this.browserInfo;
    data['correlationId'] = this.correlationId;
    data['clientId'] = this.clientId;
    data['clientName'] = this.clientName;
    data['clientIpAddress'] = this.clientIpAddress;
    data['executionDuration'] = this.executionDuration;
    data['executionTime'] = this.executionTime ? this.executionTime.toISOString() : <any>undefined;
    data['impersonatorTenantId'] = this.impersonatorTenantId;
    data['impersonatorUserId'] = this.impersonatorUserId;
    data['tenantName'] = this.tenantName;
    data['tenantId'] = this.tenantId;
    data['userName'] = this.userName;
    data['userId'] = this.userId;
    data['applicationName'] = this.applicationName;
    return data;
  }
}

export interface IAuditLogDetailedDto {
  id?: string;
  httpStatusCode?: number | undefined;
  comments?: string | undefined;
  exceptions?: string | undefined;
  url?: string | undefined;
  httpMethod?: string | undefined;
  browserInfo?: string | undefined;
  correlationId?: string | undefined;
  clientId?: string | undefined;
  clientName?: string | undefined;
  clientIpAddress?: string | undefined;
  executionDuration?: number;
  executionTime?: Date;
  impersonatorTenantId?: string | undefined;
  impersonatorUserId?: string | undefined;
  tenantName?: string | undefined;
  tenantId?: string | undefined;
  userName?: string | undefined;
  userId?: string | undefined;
  applicationName?: string | undefined;
}

export class AuditLogDto implements IAuditLogDto {
  id?: string;
  readonly comments?: string | undefined;
  readonly url?: string | undefined;
  readonly httpMethod?: string | undefined;
  httpStatusCode?: number | undefined;
  readonly clientIpAddress?: string | undefined;
  readonly executionDuration?: number;
  readonly userName?: string | undefined;

  constructor(data?: IAuditLogDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      (<any>this).comments = _data['comments'];
      (<any>this).url = _data['url'];
      (<any>this).httpMethod = _data['httpMethod'];
      this.httpStatusCode = _data['httpStatusCode'];
      (<any>this).clientIpAddress = _data['clientIpAddress'];
      (<any>this).executionDuration = _data['executionDuration'];
      (<any>this).userName = _data['userName'];
    }
  }

  static fromJS(data: any): AuditLogDto {
    data = typeof data === 'object' ? data : {};
    let result = new AuditLogDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['comments'] = this.comments;
    data['url'] = this.url;
    data['httpMethod'] = this.httpMethod;
    data['httpStatusCode'] = this.httpStatusCode;
    data['clientIpAddress'] = this.clientIpAddress;
    data['executionDuration'] = this.executionDuration;
    data['userName'] = this.userName;
    return data;
  }
}

export interface IAuditLogDto {
  id?: string;
  comments?: string | undefined;
  url?: string | undefined;
  httpMethod?: string | undefined;
  httpStatusCode?: number | undefined;
  clientIpAddress?: string | undefined;
  executionDuration?: number;
  userName?: string | undefined;
}

export class ForgotPasswordDto implements IForgotPasswordDto {
  email!: string;
  recaptchaToken!: string;

  constructor(data?: IForgotPasswordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
      this.recaptchaToken = _data['recaptchaToken'];
    }
  }

  static fromJS(data: any): ForgotPasswordDto {
    data = typeof data === 'object' ? data : {};
    let result = new ForgotPasswordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['recaptchaToken'] = this.recaptchaToken;
    return data;
  }
}

export interface IForgotPasswordDto {
  email: string;
  recaptchaToken:string
}

export class RegisterDto implements IRegisterDto {
  name!: string;
  surname!: string;
  appName!: string;
  emailAddress!: string;
  password!: string;
  recaptchaToken!: string;

  constructor(data?: IRegisterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.appName = _data['appName'];
      this.emailAddress = _data['emailAddress'];
      this.password = _data['password'];
      this.recaptchaToken = _data['recaptchaToken'];
    }
  }

  static fromJS(data: any): RegisterDto {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['appName'] = this.appName;
    data['emailAddress'] = this.emailAddress;
    data['password'] = this.password;
    data['recaptchaToken'] = this. recaptchaToken;
    return data;
  }
}

export interface IRegisterDto {
  name: string;
  surname: string;
  appName: string;
  emailAddress: string;
  password: string;
  recaptchaToken: string;
}

export enum AnnouncementTarget {
  Everyone = 'Everyone',
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Specific = 'Specific',
}

export enum ContestScoreStatus {
  Solved = 'Solved',
  UnSolved = 'UnSolved',
}

export enum ContestScoring {
  Rated = 'Rated',
  Unrated = 'Unrated',
}

export enum ContestStatus {
  Incomplete = 'Incomplete',
  Pending = 'Pending',
  Rejected = 'Rejected',
  Accepted = 'Accepted',
  Published = 'Published',
}

export enum ContestType {
  ICPC = 'ICPC',
}

export class ContestAnnouncementCreateDto implements IContestAnnouncementCreateDto {
  subject!: string;
  message!: string;
  contestId!: string;
  target!: AnnouncementTarget;
  targetIds?: string[] | undefined;

  constructor(data?: IContestAnnouncementCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subject = _data['subject'];
      this.message = _data['message'];
      this.contestId = _data['contestId'];
      this.target = _data['target'];
      if (Array.isArray(_data['targetIds'])) {
        this.targetIds = [] as any;
        for (let item of _data['targetIds']) this.targetIds!.push(item);
      }
    }
  }

  static fromJS(data: any): ContestAnnouncementCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestAnnouncementCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['subject'] = this.subject;
    data['message'] = this.message;
    data['contestId'] = this.contestId;
    data['target'] = this.target;
    if (Array.isArray(this.targetIds)) {
      data['targetIds'] = [];
      for (let item of this.targetIds) data['targetIds'].push(item);
    }
    return data;
  }
}

export interface IContestAnnouncementCreateDto {
  subject: string;
  message: string;
  contestId: string;
  target: AnnouncementTarget;
  targetIds?: string[] | undefined;
}

export class ContestAnnouncementDto implements IContestAnnouncementDto {
  id?: string;
  subject?: string | undefined;
  message?: string | undefined;

  constructor(data?: IContestAnnouncementDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.subject = _data['subject'];
      this.message = _data['message'];
    }
  }

  static fromJS(data: any): ContestAnnouncementDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestAnnouncementDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['subject'] = this.subject;
    data['message'] = this.message;
    return data;
  }
}

export interface IContestAnnouncementDto {
  id?: string;
  subject?: string | undefined;
  message?: string | undefined;
}

export class ContestAnnouncementFullDto implements IContestAnnouncementFullDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  subject?: string | undefined;
  message?: string | undefined;
  contestId?: string;
  target?: AnnouncementTarget;
  creatorUsername?: string | undefined;
  isRead?: boolean | undefined;
  announcementTargets?: ContestAnnouncementTargetDto[] | undefined;

  constructor(data?: IContestAnnouncementFullDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.isDeleted = _data['isDeleted'];
      this.deleterId = _data['deleterId'];
      this.deletionTime = _data['deletionTime']
        ? new Date(_data['deletionTime'].toString())
        : <any>undefined;
      this.subject = _data['subject'];
      this.message = _data['message'];
      this.contestId = _data['contestId'];
      this.target = _data['target'];
      this.creatorUsername = _data['creatorUsername'];
      this.isRead = _data['isRead'];
      if (Array.isArray(_data['announcementTargets'])) {
        this.announcementTargets = [] as any;
        for (let item of _data['announcementTargets'])
          this.announcementTargets!.push(ContestAnnouncementTargetDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ContestAnnouncementFullDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestAnnouncementFullDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['isDeleted'] = this.isDeleted;
    data['deleterId'] = this.deleterId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['subject'] = this.subject;
    data['message'] = this.message;
    data['contestId'] = this.contestId;
    data['target'] = this.target;
    data['creatorUsername'] = this.creatorUsername;
    data['isRead'] = this.isRead;
    if (Array.isArray(this.announcementTargets)) {
      data['announcementTargets'] = [];
      for (let item of this.announcementTargets) data['announcementTargets'].push(item.toJSON());
    }
    return data;
  }
}

export interface IContestAnnouncementFullDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  subject?: string | undefined;
  message?: string | undefined;
  contestId?: string;
  target?: AnnouncementTarget;
  creatorUsername?: string | undefined;
  isRead?: boolean | undefined;
  announcementTargets?: ContestAnnouncementTargetDto[] | undefined;
}

export class ContestAnnouncementListOutputDto implements IContestAnnouncementListOutputDto {
  id?: string;
  creationTime?: Date;
  subject?: string | undefined;
  message?: string | undefined;
  isRead?: boolean | undefined;
  constructor(data?: IContestAnnouncementListOutputDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.subject = _data['subject'];
      this.message = _data['message'];
      this.isRead = _data['isRead'];
    }
  }

  static fromJS(data: any): ContestAnnouncementListOutputDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestAnnouncementListOutputDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['subject'] = this.subject;
    data['message'] = this.message;
    data['isRead'] = this.isRead;
    return data;
  }
}

export interface IContestAnnouncementListOutputDto {
  id?: string;
  creationTime?: Date;
  subject?: string | undefined;
  message?: string | undefined;
  isRead?: boolean | undefined;
}

export class ContestAnnouncementTargetDto implements IContestAnnouncementTargetDto {
  id?: string;
  targetType?: SpecificTargetType;
  targetId?: string;
  contestAnnouncementId?: string;
  targetName?: string | undefined;

  constructor(data?: IContestAnnouncementTargetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.targetType = _data['targetType'];
      this.targetId = _data['targetId'];
      this.contestAnnouncementId = _data['contestAnnouncementId'];
      this.targetName = _data['targetName'];
    }
  }

  static fromJS(data: any): ContestAnnouncementTargetDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestAnnouncementTargetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['targetType'] = this.targetType;
    data['targetId'] = this.targetId;
    data['contestAnnouncementId'] = this.contestAnnouncementId;
    data['targetName'] = this.targetName;
    return data;
  }
}

export interface IContestAnnouncementTargetDto {
  id?: string;
  targetType?: SpecificTargetType;
  targetId?: string;
  contestAnnouncementId?: string;
  targetName?: string | undefined;
}

export class ContestAnnouncementUpdateDto implements IContestAnnouncementUpdateDto {
  subject!: string;
  message!: string;
  sendUpdateNotification?: boolean;
  target!: AnnouncementTarget;
  targetIds?: string[] | undefined;

  constructor(data?: IContestAnnouncementUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.subject = _data['subject'];
      this.message = _data['message'];
      this.sendUpdateNotification = _data['sendUpdateNotification'];
      this.target = _data['target'];
      if (Array.isArray(_data['targetIds'])) {
        this.targetIds = [] as any;
        for (let item of _data['targetIds']) this.targetIds!.push(item);
      }
    }
  }

  static fromJS(data: any): ContestAnnouncementUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestAnnouncementUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['subject'] = this.subject;
    data['message'] = this.message;
    data['sendUpdateNotification'] = this.sendUpdateNotification;
    data['target'] = this.target;
    if (Array.isArray(this.targetIds)) {
      data['targetIds'] = [];
      for (let item of this.targetIds) data['targetIds'].push(item);
    }
    return data;
  }
}

export interface IContestAnnouncementUpdateDto {
  subject: string;
  message: string;
  sendUpdateNotification?: boolean;
  target: AnnouncementTarget;
  targetIds?: string[] | undefined;
}

export class ContestClarificationAnswerDto implements IContestClarificationAnswerDto {
  answer?: string | undefined;

  constructor(data?: IContestClarificationAnswerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.answer = _data['answer'];
    }
  }

  static fromJS(data: any): ContestClarificationAnswerDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestClarificationAnswerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['answer'] = this.answer;
    return data;
  }
}

export interface IContestClarificationAnswerDto {
  answer?: string | undefined;
}

export class ContestClarificationCreateDto implements IContestClarificationCreateDto {
  contestId!: string;
  question!: string;
  problemId!: string;

  constructor(data?: IContestClarificationCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contestId = _data['contestId'];
      this.question = _data['question'];
      this.problemId = _data['problemId'];
    }
  }

  static fromJS(data: any): ContestClarificationCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestClarificationCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contestId'] = this.contestId;
    data['question'] = this.question;
    data['problemId'] = this.problemId;
    return data;
  }
}

export interface IContestClarificationCreateDto {
  contestId: string;
  question: string;
  problemId: string;
}

export class ContestClarificationDto implements IContestClarificationDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  creatorTeamId?: string | undefined;
  problemId?: string | undefined;
  question?: string | undefined;
  answer?: string | undefined;
  answererId?: string | undefined;
  creatorUsername?: string | undefined;
  creatorTeamname?: string | undefined;
  answererUsername?: string | undefined;
  isRead?: boolean | undefined;

  constructor(data?: IContestClarificationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.contestId = _data['contestId'];
      this.creatorTeamId = _data['creatorTeamId'];
      this.problemId = _data['problemId'];
      this.question = _data['question'];
      this.answer = _data['answer'];
      this.answererId = _data['answererId'];
      this.creatorUsername = _data['creatorUsername'];
      this.creatorTeamname = _data['creatorTeamname'];
      this.answererUsername = _data['answererUsername'];
      this.isRead = _data['isRead'];
    }
  }

  static fromJS(data: any): ContestClarificationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestClarificationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['contestId'] = this.contestId;
    data['creatorTeamId'] = this.creatorTeamId;
    data['problemId'] = this.problemId;
    data['question'] = this.question;
    data['answer'] = this.answer;
    data['answererId'] = this.answererId;
    data['creatorUsername'] = this.creatorUsername;
    data['creatorTeamname'] = this.creatorTeamname;
    data['answererUsername'] = this.answererUsername;
    data['isRead'] = this.isRead;
    return data;
  }
}

export interface IContestClarificationDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  creatorTeamId?: string | undefined;
  problemId?: string | undefined;
  problemName?: string | undefined;
  question?: string | undefined;
  answer?: string | undefined;
  answererId?: string | undefined;
  creatorUsername?: string | undefined;
  creatorTeamname?: string | undefined;
  answererUsername?: string | undefined;
  isRead?: boolean | undefined;
}

export class ContestClarificationListOutputDto implements IContestClarificationListOutputDto {
  id?: string;
  creatorId?: string | undefined;
  creationTime?: Date;
  contestId?: string;
  creatorTeamId?: string | undefined;
  problemId?: string | undefined;
  problemName?: string | undefined;
  question?: string | undefined;
  answer?: string | undefined;
  answererId?: string | undefined;
  creatorUsername?: string | undefined;
  creatorTeamname?: string | undefined;
  answererUsername?: string | undefined;
  isRead?: boolean | undefined;

  constructor(data?: IContestClarificationListOutputDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creatorId = _data['creatorId'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.contestId = _data['contestId'];
      this.creatorTeamId = _data['creatorTeamId'];
      this.problemId = _data['problemId'];
      this.problemName = _data['problemName'];
      this.question = _data['question'];
      this.answer = _data['answer'];
      this.answererId = _data['answererId'];
      this.creatorUsername = _data['creatorUsername'];
      this.creatorTeamname = _data['creatorTeamname'];
      this.answererUsername = _data['answererUsername'];
      this.isRead = _data['isRead'];
    }
  }

  static fromJS(data: any): ContestClarificationListOutputDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestClarificationListOutputDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creatorId'] = this.creatorId;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['contestId'] = this.contestId;
    data['creatorTeamId'] = this.creatorTeamId;
    data['problemId'] = this.problemId;
    data['question'] = this.question;
    data['answer'] = this.answer;
    data['answererId'] = this.answererId;
    data['creatorUsername'] = this.creatorUsername;
    data['creatorTeamname'] = this.creatorTeamname;
    data['answererUsername'] = this.answererUsername;
    data['isRead'] = this.isRead;
    return data;
  }
}

export interface IContestClarificationListOutputDto {
  id?: string;
  creatorId?: string | undefined;
  creationTime?: Date;
  contestId?: string;
  creatorTeamId?: string | undefined;
  problemId?: string | undefined;
  problemName?: string | undefined;
  question?: string | undefined;
  answer?: string | undefined;
  answererId?: string | undefined;
  creatorUsername?: string | undefined;
  creatorTeamname?: string | undefined;
  answererUsername?: string | undefined;
}

export class ContestClarificationUpdateDto implements IContestClarificationUpdateDto {
  question?: string | undefined;
  problemId?: string | undefined;

  constructor(data?: IContestClarificationUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.question = _data['question'];
      this.problemId = _data['problemId'];
    }
  }

  static fromJS(data: any): ContestClarificationUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestClarificationUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['question'] = this.question;
    data['problemId'] = this.problemId;
    return data;
  }
}

export interface IContestClarificationUpdateDto {
  question?: string | undefined;
  problemId?: string | undefined;
}

export class ContestCoSetterCreateDto implements IContestCoSetterCreateDto {
  contestId?: string;
  appUserProfileId?: string;

  constructor(data?: IContestCoSetterCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contestId = _data['contestId'];
      this.appUserProfileId = _data['appUserProfileId'];
    }
  }

  static fromJS(data: any): ContestCoSetterCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestCoSetterCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contestId'] = this.contestId;
    data['appUserProfileId'] = this.appUserProfileId;
    return data;
  }
}

export interface IContestCoSetterCreateDto {
  contestId?: string;
  appUserProfileId?: string;
}

export class ContestCoSetterDto implements IContestCoSetterDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  appUserProfile?: AppUserProfileDto;
  roleType?: string | undefined;
  isAdmin?: boolean;
  isApproved?: boolean;

  constructor(data?: IContestCoSetterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.appUserProfile = _data['appUserProfile']
        ? AppUserProfileDto.fromJS(_data['appUserProfile'])
        : <any>undefined;
      this.roleType = _data['roleType'];
      this.isAdmin = _data['isAdmin'];
      this.isApproved = _data['isApproved'];
    }
  }

  static fromJS(data: any): ContestCoSetterDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestCoSetterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['appUserProfile'] = this.appUserProfile ? this.appUserProfile.toJSON() : <any>undefined;
    data['roleType'] = this.roleType;
    data['isAdmin'] = this.isAdmin;
    data['isApproved'] = this.isApproved;
    return data;
  }
}

export interface IContestCoSetterDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  appUserProfile?: AppUserProfileDto;
  roleType?: string | undefined;
  isAdmin?: boolean;
  isApproved?: boolean;
}

export class ContestCreateDto implements IContestCreateDto {
  name!: string;
  slug!: string;
  startDate!: Date;
  endDate?: Date | undefined;
  organizationId?: string | undefined;
  organizationType?: OrganizationType;

  constructor(data?: IContestCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.slug = _data['slug'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      this.organizationId = _data['organizationId'];
      this.organizationType = _data['organizationType'];
    }
  }

  static fromJS(data: any): ContestCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['slug'] = this.slug;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data['organizationId'] = this.organizationId;
    data['organizationType'] = this.organizationType;
    return data;
  }
}

export interface IContestCreateDto {
  name: string;
  slug: string;
  startDate: Date;
  endDate?: Date | undefined;
  organizationId?: string | undefined;
  organizationType?: OrganizationType;
}

export class ContestDetailsDto implements IContestDetailsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  slug?: string | undefined;
  ownerUserProfile?: AppUserProfileDto;
  status?: ContestStatus;
  startDate?: Date;
  relativeStartDate?: string | undefined;
  endDate?: Date | undefined;
  length?: TimeSpan;
  relativeEndDate?: string | undefined;
  relativeCreateDate?: string | undefined;
  relativeLengthDate?: string | undefined;
  orderNumber?: number;
  contestScoring?: ContestScoring;
  signUpStatus?: SignUpStatus;
  organization?: OrganizationDto;
  organizationId?: string | undefined;
  organizationType?: OrganizationType;
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;
  description?: string | undefined;
  contestType?: ContestType;
  leaderBoardFreezeTime?: number;
  participationType?: ParticipationType;
  penaltyScore?: number;
  approvalRequired?: boolean;
  restrictByEmailDomain?: boolean;
  allowedEmailDomains?: string | undefined;
  restrictByApprovedList?: boolean;
  requiresEmailVerification?: boolean;
  registeredUserCount?: number;
  currentTime?: Date | undefined;
  isDiscussionEnabledDuringContest: boolean;
  isInMaintenance?: boolean;
  showEditorials?: boolean;
  showAllSubmissionsAfterTheContest: boolean;
  isAllSubmissionsAvailableToShow: boolean;

  constructor(data?: IContestDetailsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
      this.slug = _data['slug'];
      this.ownerUserProfile = _data['ownerUserProfile']
        ? AppUserProfileDto.fromJS(_data['ownerUserProfile'])
        : <any>undefined;
      this.status = _data['status'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.relativeStartDate = _data['relativeStartDate'];
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      this.length = _data['length'] ? TimeSpan.fromJS(_data['length']) : <any>undefined;
      this.relativeEndDate = _data['relativeEndDate'];
      this.relativeCreateDate = _data['relativeCreateDate'];
      this.relativeLengthDate = _data['relativeLengthDate'];
      this.orderNumber = _data['orderNumber'];
      this.contestScoring = _data['contestScoring'];
      this.signUpStatus = _data['signUpStatus'];
      this.organization = _data['organization']
        ? OrganizationDto.fromJS(_data['organization'])
        : <any>undefined;
      this.organizationId = _data['organizationId'];
      this.organizationType = _data['organizationType'];
      this.landingPageTitle = _data['landingPageTitle'];
      this.coverImage = _data['coverImage'];
      this.description = _data['description'];
      this.contestType = _data['contestType'];
      this.leaderBoardFreezeTime = _data['leaderBoardFreezeTime'];
      this.participationType = _data['participationType'];
      this.penaltyScore = _data['penaltyScore'];
      this.approvalRequired = _data['approvalRequired'];
      this.restrictByEmailDomain = _data['restrictByEmailDomain'];
      this.allowedEmailDomains = _data['allowedEmailDomains'];
      this.restrictByApprovedList = _data['restrictByApprovedList'];
      this.requiresEmailVerification = _data['requiresEmailVerification'];
      this.registeredUserCount = _data['registeredUserCount'];
      this.currentTime = _data['currentTime']
        ? new Date(_data['currentTime'].toString())
        : <any>undefined;
      this.isDiscussionEnabledDuringContest = _data['isDiscussionEnabledDuringContest'];
      this.isInMaintenance = _data['isInMaintenance'];
      this.showEditorials = _data['showEditorials'];
      this.showAllSubmissionsAfterTheContest = _data['showAllSubmissionsAfterTheContest'];
      this.isAllSubmissionsAvailableToShow = _data['isAllSubmissionsAvailableToShow'];
    }
  }

  static fromJS(data: any): ContestDetailsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestDetailsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    data['slug'] = this.slug;
    data['ownerUserProfile'] = this.ownerUserProfile
      ? this.ownerUserProfile.toJSON()
      : <any>undefined;
    data['status'] = this.status;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['relativeStartDate'] = this.relativeStartDate;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data['length'] = this.length ? this.length.toJSON() : <any>undefined;
    data['relativeEndDate'] = this.relativeEndDate;
    data['relativeCreateDate'] = this.relativeCreateDate;
    data['relativeLengthDate'] = this.relativeLengthDate;
    data['orderNumber'] = this.orderNumber;
    data['contestScoring'] = this.contestScoring;
    data['signUpStatus'] = this.signUpStatus;
    data['organization'] = this.organization ? this.organization.toJSON() : <any>undefined;
    data['organizationId'] = this.organizationId;
    data['organizationType'] = this.organizationType;
    data['landingPageTitle'] = this.landingPageTitle;
    data['coverImage'] = this.coverImage;
    data['description'] = this.description;
    data['contestType'] = this.contestType;
    data['leaderBoardFreezeTime'] = this.leaderBoardFreezeTime;
    data['participationType'] = this.participationType;
    data['penaltyScore'] = this.penaltyScore;
    data['approvalRequired'] = this.approvalRequired;
    data['restrictByEmailDomain'] = this.restrictByEmailDomain;
    data['allowedEmailDomains'] = this.allowedEmailDomains;
    data['restrictByApprovedList'] = this.restrictByApprovedList;
    data['requiresEmailVerification'] = this.requiresEmailVerification;
    data['registeredUserCount'] = this.registeredUserCount;
    data['currentTime'] = this.currentTime ? this.currentTime.toISOString() : <any>undefined;
    data['isDiscussionEnabledDuringContest'] = this.isDiscussionEnabledDuringContest;
    data['isInMaintenance'] = this.isInMaintenance;
    data['showAllSubmissionsAfterTheContest'] = this.showAllSubmissionsAfterTheContest;
    data['isAllSubmissionsAvailableToShow'] = this.isAllSubmissionsAvailableToShow;
    return data;
  }
}

export interface IContestDetailsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  slug?: string | undefined;
  ownerUserProfile?: AppUserProfileDto;
  status?: ContestStatus;
  startDate?: Date;
  relativeStartDate?: string | undefined;
  endDate?: Date | undefined;
  length?: TimeSpan;
  relativeEndDate?: string | undefined;
  relativeCreateDate?: string | undefined;
  relativeLengthDate?: string | undefined;
  orderNumber?: number;
  contestScoring?: ContestScoring;
  signUpStatus?: SignUpStatus;
  organization?: OrganizationDto;
  organizationId?: string | undefined;
  organizationType?: OrganizationType;
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;
  description?: string | undefined;
  contestType?: ContestType;
  leaderBoardFreezeTime?: number;
  participationType?: ParticipationType;
  penaltyScore?: number;
  approvalRequired?: boolean;
  restrictByEmailDomain?: boolean;
  allowedEmailDomains?: string | undefined;
  restrictByApprovedList?: boolean;
  requiresEmailVerification?: boolean;
  registeredUserCount?: number;
  currentTime?: Date | undefined;
  isDiscussionEnabledDuringContest: boolean;
  isInMaintenance?: boolean;
  showAllSubmissionsAfterTheContest: boolean;
  isAllSubmissionsAvailableToShow: boolean;
}

export class ContestDto implements IContestDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  slug?: string | undefined;
  ownerUserProfile?: AppUserProfileDto;
  status?: ContestStatus;
  startDate?: Date;
  relativeStartDate?: string | undefined;
  endDate?: Date | undefined;
  length?: TimeSpan;
  relativeEndDate?: string | undefined;
  relativeCreateDate?: string | undefined;
  relativeLengthDate?: string | undefined;
  orderNumber?: number;
  contestScoring?: ContestScoring;
  contestType?: ContestType;
  participationType?: ParticipationType;
  signUpStatus?: SignUpStatus;
  isDiscussionEnabledDuringContest: boolean;
  isInMaintenance?: boolean;
  showAllSubmissionsAfterTheContest: boolean;
  isAllSubmissionsAvailableToShow: boolean;

  constructor(data?: IContestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
      this.slug = _data['slug'];
      this.ownerUserProfile = _data['ownerUserProfile']
        ? AppUserProfileDto.fromJS(_data['ownerUserProfile'])
        : <any>undefined;
      this.status = _data['status'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.relativeStartDate = _data['relativeStartDate'];
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      this.length = _data['length'] ? TimeSpan.fromJS(_data['length']) : <any>undefined;
      this.relativeEndDate = _data['relativeEndDate'];
      this.relativeCreateDate = _data['relativeCreateDate'];
      this.relativeLengthDate = _data['relativeLengthDate'];
      this.orderNumber = _data['orderNumber'];
      this.contestScoring = _data['contestScoring'];
      this.contestType = _data['contestType'];
      this.participationType = _data['participationType'];
      this.signUpStatus = _data['signUpStatus'];
      this.isDiscussionEnabledDuringContest = _data['isDiscussionEnabledDuringContest'];
      this.isInMaintenance = _data['isInMaintenance'];
      this.showAllSubmissionsAfterTheContest = _data['showAllSubmissionsAfterTheContest'];
      this.isAllSubmissionsAvailableToShow = _data['isAllSubmissionsAvailableToShow'];
    }
  }

  static fromJS(data: any): ContestDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    data['slug'] = this.slug;
    data['ownerUserProfile'] = this.ownerUserProfile
      ? this.ownerUserProfile.toJSON()
      : <any>undefined;
    data['status'] = this.status;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['relativeStartDate'] = this.relativeStartDate;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data['length'] = this.length ? this.length.toJSON() : <any>undefined;
    data['relativeEndDate'] = this.relativeEndDate;
    data['relativeCreateDate'] = this.relativeCreateDate;
    data['relativeLengthDate'] = this.relativeLengthDate;
    data['orderNumber'] = this.orderNumber;
    data['contestScoring'] = this.contestScoring;
    data['contestType'] = this.contestType;
    data['participationType'] = this.participationType;
    data['signUpStatus'] = this.signUpStatus;
    data['isDiscussionEnabledDuringContest'] = this.isDiscussionEnabledDuringContest;
    data['isInMaintenance'] = this.isInMaintenance;
    data['showAllSubmissionsAfterTheContest'] = this.showAllSubmissionsAfterTheContest;
    return data;
  }
}

export interface IContestDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  slug?: string | undefined;
  ownerUserProfile?: AppUserProfileDto;
  status?: ContestStatus;
  startDate?: Date;
  relativeStartDate?: string | undefined;
  endDate?: Date | undefined;
  length?: TimeSpan;
  relativeEndDate?: string | undefined;
  relativeCreateDate?: string | undefined;
  relativeLengthDate?: string | undefined;
  orderNumber?: number;
  contestScoring?: ContestScoring;
  contestType?: ContestType;
  participationType?: ParticipationType;
  signUpStatus?: SignUpStatus;
  isInMaintenance?: boolean;
  showAllSubmissionsAfterTheContest: boolean;
  isAllSubmissionsAvailableToShow: boolean;
}

export class ContestFullProfileUserSignUpsDto implements IContestFullProfileUserSignUpsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  orderIndex?: number;
  relativeSignUpDate?: string | undefined;
  signUpStatus?: SignUpStatus;
  flagUrl?: string | undefined;
  institution?: string | undefined;
  profile?: AppUserProfileDto;

  constructor(data?: IContestFullProfileUserSignUpsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.contestId = _data['contestId'];
      this.orderIndex = _data['orderIndex'];
      this.relativeSignUpDate = _data['relativeSignUpDate'];
      this.signUpStatus = _data['signUpStatus'];
      this.flagUrl = _data['flagUrl'];
      this.institution = _data['institution'];
      this.profile = _data['profile'] ? AppUserProfileDto.fromJS(_data['profile']) : <any>undefined;
    }
  }

  static fromJS(data: any): ContestFullProfileUserSignUpsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestFullProfileUserSignUpsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['contestId'] = this.contestId;
    data['orderIndex'] = this.orderIndex;
    data['relativeSignUpDate'] = this.relativeSignUpDate;
    data['signUpStatus'] = this.signUpStatus;
    data['flagUrl'] = this.flagUrl;
    data['institution'] = this.institution;
    data['profile'] = this.profile ? this.profile.toJSON() : <any>undefined;
    return data;
  }
}

export interface IContestFullProfileUserSignUpsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  orderIndex?: number;
  relativeSignUpDate?: string | undefined;
  signUpStatus?: SignUpStatus;
  flagUrl?: string | undefined;
  institution?: string | undefined;
  profile?: AppUserProfileDto;
}

export class ContestGeneralInformationUpdateDto implements IContestGeneralInformationUpdateDto {
  name?: string | undefined;
  slug?: string | undefined;
  startDate?: Date;
  endDate?: Date | undefined;
  organizationId?: string | undefined;
  organizationType?: OrganizationType;

  constructor(data?: IContestGeneralInformationUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.slug = _data['slug'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      this.organizationId = _data['organizationId'];
      this.organizationType = _data['organizationType'];
    }
  }

  static fromJS(data: any): ContestGeneralInformationUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestGeneralInformationUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['slug'] = this.slug;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data['organizationId'] = this.organizationId;
    data['organizationType'] = this.organizationType;
    return data;
  }
}

export interface IContestGeneralInformationUpdateDto {
  name?: string | undefined;
  slug?: string | undefined;
  startDate?: Date;
  endDate?: Date | undefined;
  organizationId?: string | undefined;
  organizationType?: OrganizationType;
}

export class ContestHistoryDto implements IContestHistoryDto {
  contest?: ContestDto;
  date?: string | undefined;
  result?: string | undefined;
  team?: TeamDto;

  constructor(data?: IContestHistoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contest = _data['contest'] ? ContestDto.fromJS(_data['contest']) : <any>undefined;
      this.date = _data['date'];
      this.result = _data['result'];
      this.team = _data['team'] ? TeamDto.fromJS(_data['team']) : <any>undefined;
    }
  }

  static fromJS(data: any): ContestHistoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestHistoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contest'] = this.contest ? this.contest.toJSON() : <any>undefined;
    data['date'] = this.date;
    data['result'] = this.result;
    data['team'] = this.team ? this.team.toJSON() : <any>undefined;
    return data;
  }
}

export interface IContestHistoryDto {
  contest?: ContestDto;
  date?: string | undefined;
  result?: string | undefined;
  team?: TeamDto;
}

export class ContestProblemCreateDto implements IContestProblemCreateDto {
  contestId?: string;
  problemId?: string;
  maxScore?: number;
  orderIndex?: number;

  constructor(data?: IContestProblemCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contestId = _data['contestId'];
      this.problemId = _data['problemId'];
      this.maxScore = _data['maxScore'];
      this.orderIndex = _data['orderIndex'];
    }
  }

  static fromJS(data: any): ContestProblemCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestProblemCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contestId'] = this.contestId;
    data['problemId'] = this.problemId;
    data['maxScore'] = this.maxScore;
    data['orderIndex'] = this.orderIndex;
    return data;
  }
}

export interface IContestProblemCreateDto {
  contestId?: string;
  problemId?: string;
  maxScore?: number;
  orderIndex?: number;
}

export class ContestProblemDto implements IContestProblemDto {
  id?: string;
  contestId?: string;
  contest?: ContestDto;
  problemId?: string;
  problem?: ProblemDto;
  maxScore?: number;
  orderIndex?: number;
  isSolved?: boolean;

  constructor(data?: IContestProblemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.contestId = _data['contestId'];
      this.contest = _data['contest'] ? ContestDto.fromJS(_data['contest']) : <any>undefined;
      this.problemId = _data['problemId'];
      this.problem = _data['problem'] ? ProblemDto.fromJS(_data['problem']) : <any>undefined;
      this.maxScore = _data['maxScore'];
      this.orderIndex = _data['orderIndex'];
      this.isSolved = _data['isSolved'];
    }
  }

  static fromJS(data: any): ContestProblemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestProblemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['contestId'] = this.contestId;
    data['contest'] = this.contest ? this.contest.toJSON() : <any>undefined;
    data['problemId'] = this.problemId;
    data['problem'] = this.problem ? this.problem.toJSON() : <any>undefined;
    data['maxScore'] = this.maxScore;
    data['orderIndex'] = this.orderIndex;
    data['isSolved'] = this.isSolved;
    return data;
  }
}

export interface IContestProblemDto {
  id?: string;
  contestId?: string;
  contest?: ContestDto;
  problemId?: string;
  problem?: ProblemDto;
  maxScore?: number;
  orderIndex?: number;
  isSolved?: boolean;
}

export class ContestProblemInfoDto implements IContestProblemInfoDto {
  id?: string;
  slug?: string | undefined;
  name?: string | undefined;

  constructor(data?: IContestProblemInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.slug = _data['slug'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): ContestProblemInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestProblemInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['slug'] = this.slug;
    data['name'] = this.name;
    return data;
  }
}

export interface IContestProblemInfoDto {
  id?: string;
  slug?: string | undefined;
  name?: string | undefined;
}

export class ContestProblemUpdateDto implements IContestProblemUpdateDto {
  id?: string;
  problemId!: string;
  maxScore!: number;

  constructor(data?: IContestProblemUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.problemId = _data['problemId'];
      this.maxScore = _data['maxScore'];
    }
  }

  static fromJS(data: any): ContestProblemUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestProblemUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['problemId'] = this.problemId;
    data['maxScore'] = this.maxScore;
    return data;
  }
}

export interface IContestProblemUpdateDto {
  id?: string;
  problemId: string;
  maxScore: number;
}

export class ContestScoreCreateDto implements IContestScoreCreateDto {
  creatorId?: string;
  contestId?: string;
  problemId?: string;
  name?: string | undefined;

  constructor(data?: IContestScoreCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creatorId = _data['creatorId'];
      this.contestId = _data['contestId'];
      this.problemId = _data['problemId'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): ContestScoreCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestScoreCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creatorId'] = this.creatorId;
    data['contestId'] = this.contestId;
    data['problemId'] = this.problemId;
    data['name'] = this.name;
    return data;
  }
}

export interface IContestScoreCreateDto {
  creatorId?: string;
  contestId?: string;
  problemId?: string;
  name?: string | undefined;
}

export class ContestScoreListItemDto implements IContestScoreListItemDto {
  creatorId?: string | undefined;
  name?: string | undefined;
  institution?: string | undefined;
  totalSolved?: number;
  totalPenalty?: number;
  scores?: ScoreListItemDto[] | undefined;

  constructor(data?: IContestScoreListItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creatorId = _data['creatorId'];
      this.name = _data['name'];
      this.institution = _data['institution'];
      this.totalSolved = _data['totalSolved'];
      this.totalPenalty = _data['totalPenalty'];
      if (Array.isArray(_data['scores'])) {
        this.scores = [] as any;
        for (let item of _data['scores']) this.scores!.push(ScoreListItemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ContestScoreListItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestScoreListItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creatorId'] = this.creatorId;
    data['name'] = this.name;
    data['institution'] = this.institution;
    data['totalSolved'] = this.totalSolved;
    data['totalPenalty'] = this.totalPenalty;
    if (Array.isArray(this.scores)) {
      data['scores'] = [];
      for (let item of this.scores) data['scores'].push(item.toJSON());
    }
    return data;
  }
}

export interface IContestScoreListItemDto {
  creatorId?: string | undefined;
  name?: string | undefined;
  institution?: string | undefined;
  totalSolved?: number;
  totalPenalty?: number;
  scores?: ScoreListItemDto[] | undefined;
}

export class ContestScoreResponseDto implements IContestScoreResponseDto {
  items?: ContestScoreListItemDto[] | undefined;
  penaltyScore?: number;
  totalCount?: number;
  isInFreezeTime?: boolean | undefined;

  constructor(data?: IContestScoreResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestScoreListItemDto.fromJS(item));
      }
      this.penaltyScore = _data['penaltyScore'];
      this.totalCount = _data['totalCount'];
      this.isInFreezeTime = _data['isInFreezeTime'];
    }
  }

  static fromJS(data: any): ContestScoreResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestScoreResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['penaltyScore'] = this.penaltyScore;
    data['totalCount'] = this.totalCount;
    data['isInFreezeTime'] = this.isInFreezeTime;
    return data;
  }
}

export interface IContestScoreResponseDto {
  items?: ContestScoreListItemDto[] | undefined;
  penaltyScore?: number;
  totalCount?: number;
  isInFreezeTime?: boolean | undefined;
}

export class ContestScoreUpdateDto implements IContestScoreUpdateDto {
  creatorId?: string;
  contestId?: string;
  problemId?: string;
  name?: string | undefined;
  submissionDate?: Date;
  status?: ContestScoreStatus;

  constructor(data?: IContestScoreUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.creatorId = _data['creatorId'];
      this.contestId = _data['contestId'];
      this.problemId = _data['problemId'];
      this.name = _data['name'];
      this.submissionDate = _data['submissionDate']
        ? new Date(_data['submissionDate'].toString())
        : <any>undefined;
      this.status = _data['status'];
    }
  }

  static fromJS(data: any): ContestScoreUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestScoreUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['creatorId'] = this.creatorId;
    data['contestId'] = this.contestId;
    data['problemId'] = this.problemId;
    data['name'] = this.name;
    data['submissionDate'] = this.submissionDate
      ? this.submissionDate.toISOString()
      : <any>undefined;
    data['status'] = this.status;
    return data;
  }
}

export interface IContestScoreUpdateDto {
  creatorId?: string;
  contestId?: string;
  problemId?: string;
  name?: string | undefined;
  submissionDate?: Date;
  status?: ContestScoreStatus;
}

export class ContestSlugPreviewDto implements IContestSlugPreviewDto {
  slug?: string | undefined;

  constructor(data?: IContestSlugPreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slug = _data['slug'];
    }
  }

  static fromJS(data: any): ContestSlugPreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestSlugPreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['slug'] = this.slug;
    return data;
  }
}

export interface IContestSlugPreviewDto {
  slug?: string | undefined;
}

export class ContestTeamSignUpsCreateDto implements IContestTeamSignUpsCreateDto {
  contestId?: string;
  teamId?: string;

  constructor(data?: IContestTeamSignUpsCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contestId = _data['contestId'];
      this.teamId = _data['teamId'];
    }
  }

  static fromJS(data: any): ContestTeamSignUpsCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestTeamSignUpsCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contestId'] = this.contestId;
    data['teamId'] = this.teamId;
    return data;
  }
}

export interface IContestTeamSignUpsCreateDto {
  contestId?: string;
  teamId?: string;
}

export class ContestTeamSignUpsDto implements IContestTeamSignUpsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  orderIndex?: number;
  relativeSignUpDate?: string | undefined;
  signUpStatus?: SignUpStatus;
  flagUrl?: string | undefined;
  institution?: string | undefined;
  teamId?: string;
  teamName?: string | undefined;
  memberCount?: number;

  constructor(data?: IContestTeamSignUpsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.contestId = _data['contestId'];
      this.orderIndex = _data['orderIndex'];
      this.relativeSignUpDate = _data['relativeSignUpDate'];
      this.signUpStatus = _data['signUpStatus'];
      this.flagUrl = _data['flagUrl'];
      this.institution = _data['institution'];
      this.teamId = _data['teamId'];
      this.teamName = _data['teamName'];
      this.memberCount = _data['memberCount'];
    }
  }

  static fromJS(data: any): ContestTeamSignUpsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestTeamSignUpsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['contestId'] = this.contestId;
    data['orderIndex'] = this.orderIndex;
    data['relativeSignUpDate'] = this.relativeSignUpDate;
    data['signUpStatus'] = this.signUpStatus;
    data['flagUrl'] = this.flagUrl;
    data['institution'] = this.institution;
    data['teamId'] = this.teamId;
    data['teamName'] = this.teamName;
    data['memberCount'] = this.memberCount;
    return data;
  }
}

export interface IContestTeamSignUpsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  orderIndex?: number;
  relativeSignUpDate?: string | undefined;
  signUpStatus?: SignUpStatus;
  flagUrl?: string | undefined;
  institution?: string | undefined;
  teamId?: string;
  teamName?: string | undefined;
  memberCount?: number;
}

export class ContestUpdateDto implements IContestUpdateDto {
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;
  description?: string | undefined;
  status?: ContestStatus;
  contestType?: ContestType;
  contestScoring?: ContestScoring;
  leaderBoardFreezeTime?: number;
  participationType?: ParticipationType;
  penaltyScore?: number;
  approvalRequired?: boolean;

  constructor(data?: IContestUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.landingPageTitle = _data['landingPageTitle'];
      this.coverImage = _data['coverImage'];
      this.description = _data['description'];
      this.status = _data['status'];
      this.contestType = _data['contestType'];
      this.contestScoring = _data['contestScoring'];
      this.leaderBoardFreezeTime = _data['leaderBoardFreezeTime'];
      this.participationType = _data['participationType'];
      this.penaltyScore = _data['penaltyScore'];
      this.approvalRequired = _data['approvalRequired'];
    }
  }

  static fromJS(data: any): ContestUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['landingPageTitle'] = this.landingPageTitle;
    data['coverImage'] = this.coverImage;
    data['description'] = this.description;
    data['status'] = this.status;
    data['contestType'] = this.contestType;
    data['contestScoring'] = this.contestScoring;
    data['leaderBoardFreezeTime'] = this.leaderBoardFreezeTime;
    data['participationType'] = this.participationType;
    data['penaltyScore'] = this.penaltyScore;
    data['approvalRequired'] = this.approvalRequired;
    return data;
  }
}

export interface IContestUpdateDto {
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;
  description?: string | undefined;
  status?: ContestStatus;
  contestType?: ContestType;
  contestScoring?: ContestScoring;
  leaderBoardFreezeTime?: number;
  participationType?: ParticipationType;
  penaltyScore?: number;
  approvalRequired?: boolean;
}

export class ContestUserSignUpsCreateDto implements IContestUserSignUpsCreateDto {
  contestId?: string;
  userId?: string;

  constructor(data?: IContestUserSignUpsCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contestId = _data['contestId'];
      this.userId = _data['userId'];
    }
  }

  static fromJS(data: any): ContestUserSignUpsCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestUserSignUpsCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contestId'] = this.contestId;
    data['userId'] = this.userId;
    return data;
  }
}

export interface IContestUserSignUpsCreateDto {
  contestId?: string;
  userId?: string;
}

export class ContestUserSignUpsDto implements IContestUserSignUpsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  orderIndex?: number;
  relativeSignUpDate?: string | undefined;
  signUpStatus?: SignUpStatus;
  flagUrl?: string | undefined;
  institution?: string | undefined;
  profile?: AppUserPreviewProfileDto;

  constructor(data?: IContestUserSignUpsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.contestId = _data['contestId'];
      this.orderIndex = _data['orderIndex'];
      this.relativeSignUpDate = _data['relativeSignUpDate'];
      this.signUpStatus = _data['signUpStatus'];
      this.flagUrl = _data['flagUrl'];
      this.institution = _data['institution'];
      this.profile = _data['profile']
        ? AppUserPreviewProfileDto.fromJS(_data['profile'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ContestUserSignUpsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestUserSignUpsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['contestId'] = this.contestId;
    data['orderIndex'] = this.orderIndex;
    data['relativeSignUpDate'] = this.relativeSignUpDate;
    data['signUpStatus'] = this.signUpStatus;
    data['flagUrl'] = this.flagUrl;
    data['institution'] = this.institution;
    data['profile'] = this.profile ? this.profile.toJSON() : <any>undefined;
    return data;
  }
}

export interface IContestUserSignUpsDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  contestId?: string;
  orderIndex?: number;
  relativeSignUpDate?: string | undefined;
  signUpStatus?: SignUpStatus;
  flagUrl?: string | undefined;
  institution?: string | undefined;
  profile?: AppUserPreviewProfileDto;
}

export class CoSetterApprovalDto implements ICoSetterApprovalDto {
  userName?: string | undefined;
  createDate?: Date;
  isApproved?: boolean;

  constructor(data?: ICoSetterApprovalDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName'];
      this.createDate = _data['createDate']
        ? new Date(_data['createDate'].toString())
        : <any>undefined;
      this.isApproved = _data['isApproved'];
    }
  }

  static fromJS(data: any): CoSetterApprovalDto {
    data = typeof data === 'object' ? data : {};
    let result = new CoSetterApprovalDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['createDate'] = this.createDate ? this.createDate.toISOString() : <any>undefined;
    data['isApproved'] = this.isApproved;
    return data;
  }
}

export interface ICoSetterApprovalDto {
  userName?: string | undefined;
  createDate?: Date;
  isApproved?: boolean;
}

export class ScoreListItemDto implements IScoreListItemDto {
  problemId?: string;
  penalty?: number;
  retryCount?: number;
  status?: string | undefined;
  time?: number;

  constructor(data?: IScoreListItemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.problemId = _data['problemId'];
      this.penalty = _data['penalty'];
      this.retryCount = _data['retryCount'];
      this.status = _data['status'];
      this.time = _data['time'];
    }
  }

  static fromJS(data: any): ScoreListItemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ScoreListItemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['problemId'] = this.problemId;
    data['penalty'] = this.penalty;
    data['retryCount'] = this.retryCount;
    data['status'] = this.status;
    data['time'] = this.time;
    return data;
  }
}

export interface IScoreListItemDto {
  problemId?: string;
  penalty?: number;
  retryCount?: number;
  status?: string | undefined;
  time?: number;
}

export class TeamContestHistoryDto implements ITeamContestHistoryDto {
  contest?: ContestDto;
  date?: string | undefined;
  solvedProblem?: string | undefined;
  result?: string | undefined;
  numberOfSolvedProblems?: string | undefined;

  constructor(data?: ITeamContestHistoryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contest = _data['contest'] ? ContestDto.fromJS(_data['contest']) : <any>undefined;
      this.date = _data['date'];
      this.solvedProblem = _data['solvedProblem'];
      this.numberOfSolvedProblems = _data['numberOfSolvedProblems'];
      this.result = _data['result'];
    }
  }

  static fromJS(data: any): TeamContestHistoryDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamContestHistoryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contest'] = this.contest ? this.contest.toJSON() : <any>undefined;
    data['date'] = this.date;
    data['solvedProblem'] = this.solvedProblem;
    data['numberOfSolvedProblems'] = this.numberOfSolvedProblems;
    data['result'] = this.result;
    return data;
  }
}

export interface ITeamContestHistoryDto {
  contest?: ContestDto;
  date?: string | undefined;
  solvedProblem?: string | undefined;
  result?: string | undefined;
  numberOfSolvedProblems?: string | undefined;
}

export enum ContestActivity {
  Active = 'Active',
  Archived = 'Archived',
}

export enum ParticipationType {
  Individual = 'Individual',
  Team = 'Team',
}

export enum SignUpStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected',
}

export enum SpecificTargetType {
  User = 'User',
  Team = 'Team',
}

export class DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  implements
    IDataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
{
  value?: string;

  constructor(
    data?: IDataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data['value'];
    }
  }

  static fromJS(
    data: any
  ): DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data = typeof data === 'object' ? data : {};
    let result =
      new DataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['value'] = this.value;
    return data;
  }
}

export interface IDataContainerDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
  value?: string;
}

export class DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  implements
    IDataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
{
  value?: string | undefined;

  constructor(
    data?: IDataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.value = _data['value'];
    }
  }

  static fromJS(
    data: any
  ): DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data = typeof data === 'object' ? data : {};
    let result =
      new DataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['value'] = this.value;
    return data;
  }
}

export interface IDataContainerDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
  value?: string | undefined;
}

export class LeaderBoardUserProfileDto implements ILeaderBoardUserProfileDto {
  id?: string;
  userName?: string | undefined;
  profilePictureUrl?: string | undefined;
  points?: number;

  constructor(data?: ILeaderBoardUserProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.profilePictureUrl = _data['profilePictureUrl'];
      this.points = _data['points'];
    }
  }

  static fromJS(data: any): LeaderBoardUserProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new LeaderBoardUserProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['profilePictureUrl'] = this.profilePictureUrl;
    data['points'] = this.points;
    return data;
  }
}

export interface ILeaderBoardUserProfileDto {
  id?: string;
  userName?: string | undefined;
  profilePictureUrl?: string | undefined;
  points?: number;
}

export class LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  implements
    ILookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
{
  id?: string;
  name?: string | undefined;

  constructor(
    data?: ILookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(
    data: any
  ): LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data = typeof data === 'object' ? data : {};
    let result =
      new LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface ILookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
  id?: string;
  name?: string | undefined;
}

export class LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  implements
    ILookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
{
  id?: string | undefined;
  name?: string | undefined;

  constructor(
    data?: ILookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(
    data: any
  ): LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data = typeof data === 'object' ? data : {};
    let result =
      new LookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface ILookupDto_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
  id?: string | undefined;
  name?: string | undefined;
}

export enum AccessLevel {
  Public = 'Public',
  Private = 'Private',
}

export enum Context {
  GetStarted = 'GetStarted',
  Practice = 'Practice',
  Contest = 'Contest',
  Solution = 'Solution',
  Idle = 'Idle',
}

export class ContestProblemSubmissionDto implements IContestProblemSubmissionDto {
  id?: string;
  problemId?: string;
  contestId?: string;
  problemName?: string | undefined;
  problemSlug?: string | undefined;
  status?: ProblemSubmissionStatus;
  context?: Context;
  accessLevel?: AccessLevel;
  startDate?: Date;
  formattedStartDate?: string | undefined;
  endDate?: Date;
  formattedEndDate?: string | undefined;
  duration?: number;
  programmingLanguage?: ProgrammingLanguageDto;
  userName?: string | undefined;
  duringContest?: string | undefined;
  creatorId?: string;
  team?: SubmissionCreatorDto;

  constructor(data?: IContestProblemSubmissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.problemId = _data['problemId'];
      this.contestId = _data['contestId'];
      this.problemName = _data['problemName'];
      this.problemSlug = _data['problemSlug'];
      this.status = _data['status'];
      this.context = _data['context'];
      this.accessLevel = _data['accessLevel'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.formattedStartDate = _data['formattedStartDate'];
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      this.formattedEndDate = _data['formattedEndDate'];
      this.duration = _data['duration'];
      this.programmingLanguage = _data['programmingLanguage']
        ? ProgrammingLanguageDto.fromJS(_data['programmingLanguage'])
        : <any>undefined;
      this.userName = _data['userName'];
      this.duringContest = _data['duringContest'];
      this.creatorId = _data['creatorId'];
      this.team = _data['team'] ? SubmissionCreatorDto.fromJS(_data['team']) : <any>undefined;
    }
  }

  static fromJS(data: any): ContestProblemSubmissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestProblemSubmissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['problemId'] = this.problemId;
    data['contestId'] = this.contestId;
    data['problemName'] = this.problemName;
    data['problemSlug'] = this.problemSlug;
    data['status'] = this.status;
    data['context'] = this.context;
    data['accessLevel'] = this.accessLevel;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['formattedStartDate'] = this.formattedStartDate;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data['formattedEndDate'] = this.formattedEndDate;
    data['duration'] = this.duration;
    data['programmingLanguage'] = this.programmingLanguage
      ? this.programmingLanguage.toJSON()
      : <any>undefined;
    data['userName'] = this.userName;
    data['duringContest'] = this.duringContest;
    data['creatorId'] = this.creatorId;
    data['team'] = this.team ? this.team.toJSON() : <any>undefined;
    return data;
  }
}

export interface IContestProblemSubmissionDto {
  id?: string;
  problemId?: string;
  contestId?: string;
  problemName?: string | undefined;
  problemSlug?: string | undefined;
  status?: ProblemSubmissionStatus;
  context?: Context;
  accessLevel?: AccessLevel;
  startDate?: Date;
  formattedStartDate?: string | undefined;
  endDate?: Date;
  formattedEndDate?: string | undefined;
  duration?: number;
  programmingLanguage?: ProgrammingLanguageDto;
  userName?: string | undefined;
  duringContest?: string | undefined;
  creatorId?: string;
  team?: SubmissionCreatorDto;
}

export class PracticeProblemDto implements IPracticeProblemDto {
  slug?: string | undefined;
  name?: string | undefined;
  sourceNames?: string | undefined;
  tagNames?: string | undefined;
  successRatio?: number;
  isSolved?: boolean;
  difficulty?: ProblemDifficulty;
  numberOfSolved?: number;

  constructor(data?: IPracticeProblemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slug = _data['slug'];
      this.name = _data['name'];
      this.sourceNames = _data['sourceNames'];
      this.tagNames = _data['tagNames'];
      this.successRatio = _data['successRatio'];
      this.isSolved = _data['isSolved'];
      this.difficulty = _data['difficulty'];
      this.numberOfSolved = _data['numberOfSolved'];
    }
  }

  static fromJS(data: any): PracticeProblemDto {
    data = typeof data === 'object' ? data : {};
    let result = new PracticeProblemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['slug'] = this.slug;
    data['name'] = this.name;
    data['sourceNames'] = this.sourceNames;
    data['tagNames'] = this.tagNames;
    data['successRatio'] = this.successRatio;
    data['isSolved'] = this.isSolved;
    data['difficulty'] = this.difficulty;
    data['numberOfSolved'] = this.numberOfSolved;
    return data;
  }
}

export interface IPracticeProblemDto {
  slug?: string | undefined;
  name?: string | undefined;
  sourceNames?: string | undefined;
  tagNames?: string | undefined;
  successRatio?: number;
  isSolved?: boolean;
  difficulty?: ProblemDifficulty;
  numberOfSolved?: number;
}

export class ProblemContestResponseDto implements IProblemContestResponseDto {
  id?: string;
  name?: string | undefined;
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  description?: string | undefined;
  isEditorialEnabled?: boolean;
  hint?: string;
  isInteractive?: boolean;

  constructor(data?: IProblemContestResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.language = _data['language'];
      this.difficulty = _data['difficulty'];
      this.slug = _data['slug'];
      this.scoringType = _data['scoringType'];
      this.status = _data['status'];
      this.description = _data['description'];
      this.isEditorialEnabled = _data['isEditorialEnabled'];
      this.hint = _data['hint'];
      this.isInteractive = _data['isInteractive'];
    }
  }

  static fromJS(data: any): ProblemContestResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemContestResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['language'] = this.language;
    data['difficulty'] = this.difficulty;
    data['slug'] = this.slug;
    data['scoringType'] = this.scoringType;
    data['status'] = this.status;
    data['description'] = this.description;
    data['isEditorialEnabled'] = this.isEditorialEnabled;
    data['isInteractive'] = this.isInteractive;
    return data;
  }
}

export interface IProblemContestResponseDto {
  id?: string;
  name?: string | undefined;
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  description?: string | undefined;
  isEditorialEnabled?: boolean;
  isInteractive?: boolean;
}

export class ProblemCreatedDto implements IProblemCreatedDto {
  id?: string;
  name?: string | undefined;
  successRatio?: number;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  tagNames?: string | undefined;

  constructor(data?: IProblemCreatedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.successRatio = _data['successRatio'];
      this.difficulty = _data['difficulty'];
      this.slug = _data['slug'];
      this.tagNames = _data['tagNames'];
    }
  }

  static fromJS(data: any): ProblemCreatedDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemCreatedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['successRatio'] = this.successRatio;
    data['difficulty'] = this.difficulty;
    data['slug'] = this.slug;
    data['tagNames'] = this.tagNames;
    return data;
  }
}

export interface IProblemCreatedDto {
  id?: string;
  name?: string | undefined;
  successRatio?: number;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  tagNames?: string | undefined;
}

export class ProblemCreateUpdateDto implements IProblemCreateUpdateDto {
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  name!: string;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  sourceId?: string;
  tags?: string[] | undefined;

  constructor(data?: IProblemCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.language = _data['language'];
      this.difficulty = _data['difficulty'];
      this.name = _data['name'];
      this.slug = _data['slug'];
      this.scoringType = _data['scoringType'];
      this.status = _data['status'];
      this.sourceId = _data['sourceId'];
      if (Array.isArray(_data['tags'])) {
        this.tags = [] as any;
        for (let item of _data['tags']) this.tags!.push(item);
      }
    }
  }

  static fromJS(data: any): ProblemCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['language'] = this.language;
    data['difficulty'] = this.difficulty;
    data['name'] = this.name;
    data['slug'] = this.slug;
    data['scoringType'] = this.scoringType;
    data['status'] = this.status;
    data['sourceId'] = this.sourceId;
    if (Array.isArray(this.tags)) {
      data['tags'] = [];
      for (let item of this.tags) data['tags'].push(item);
    }
    return data;
  }
}

export interface IProblemCreateUpdateDto {
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  name: string;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  sourceId?: string;
  tags?: string[] | undefined;
}

export class ProblemDetailedDto implements IProblemDetailedDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  ownerUserId?: string;
  name?: string | undefined;
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  successRatio?: number;
  ownerUser?: AppUserPreviewProfileDto;
  totalSubmission?: number;
  source?: SourceDto;
  sourceNames?: string | undefined;
  tags?: string[] | undefined;
  tagNames?: string | undefined;
  precisionCheck?: number;
  isPrecisionCheck?: boolean;
  totalSolvedSubmission?: number;
  description?: string | undefined;
  hint?: string | undefined;
  isInteractive?: boolean;

  constructor(data?: IProblemDetailedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.isDeleted = _data['isDeleted'];
      this.deleterId = _data['deleterId'];
      this.deletionTime = _data['deletionTime']
        ? new Date(_data['deletionTime'].toString())
        : <any>undefined;
      this.ownerUserId = _data['ownerUserId'];
      this.name = _data['name'];
      this.language = _data['language'];
      this.difficulty = _data['difficulty'];
      this.slug = _data['slug'];
      this.scoringType = _data['scoringType'];
      this.status = _data['status'];
      this.successRatio = _data['successRatio'];
      this.ownerUser = _data['ownerUser']
        ? AppUserPreviewProfileDto.fromJS(_data['ownerUser'])
        : <any>undefined;
      this.totalSubmission = _data['totalSubmission'];
      this.source = _data['source'] ? SourceDto.fromJS(_data['source']) : <any>undefined;
      this.sourceNames = _data['sourceNames'];
      if (Array.isArray(_data['tags'])) {
        this.tags = [] as any;
        for (let item of _data['tags']) this.tags!.push(item);
      }
      this.tagNames = _data['tagNames'];
      this.precisionCheck = _data['precisionCheck'];
      this.isPrecisionCheck = _data['isPrecisionCheck'];
      this.totalSolvedSubmission = _data['totalSolvedSubmission'];
      this.description = _data['description'];
      this.hint = _data['hint'];
      this.isInteractive = _data['isInteractive'];
    }
  }

  static fromJS(data: any): ProblemDetailedDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDetailedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['isDeleted'] = this.isDeleted;
    data['deleterId'] = this.deleterId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['ownerUserId'] = this.ownerUserId;
    data['name'] = this.name;
    data['language'] = this.language;
    data['difficulty'] = this.difficulty;
    data['slug'] = this.slug;
    data['scoringType'] = this.scoringType;
    data['status'] = this.status;
    data['successRatio'] = this.successRatio;
    data['ownerUser'] = this.ownerUser ? this.ownerUser.toJSON() : <any>undefined;
    data['totalSubmission'] = this.totalSubmission;
    data['source'] = this.source ? this.source.toJSON() : <any>undefined;
    data['sourceNames'] = this.sourceNames;
    if (Array.isArray(this.tags)) {
      data['tags'] = [];
      for (let item of this.tags) data['tags'].push(item);
    }
    data['tagNames'] = this.tagNames;
    data['precisionCheck'] = this.precisionCheck;
    data['isPrecisionCheck'] = this.isPrecisionCheck;
    data['totalSolvedSubmission'] = this.totalSolvedSubmission;
    data['description'] = this.description;
    data['hint'] = this.hint;
    data['isInteractive'] = this.isInteractive;
    return data;
  }
}

export interface IProblemDetailedDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  ownerUserId?: string;
  name?: string | undefined;
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  successRatio?: number;
  ownerUser?: AppUserPreviewProfileDto;
  totalSubmission?: number;
  source?: SourceDto;
  sourceNames?: string | undefined;
  tags?: string[] | undefined;
  tagNames?: string | undefined;
  precisionCheck?: number;
  isPrecisionCheck?: boolean;
  totalSolvedSubmission?: number;
  description?: string | undefined;
  isInteractive?: boolean;
}

export class AppUserScoreDto implements IAppUserScoreDto {
  username?: string | undefined;
  orderScore?: number;
  publicScore?: number;
  education?: string | undefined;
  country?: string | undefined;
  countryFlagUrl?: string | undefined;

  constructor(data?: IAppUserScoreDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.username = _data['username'];
      this.orderScore = _data['orderScore'];
      this.publicScore = _data['publicScore'];
      this.education = _data['education'];
      this.country = _data['country'];
      this.countryFlagUrl = _data['countryFlagUrl'];
    }
  }

  static fromJS(data: any): AppUserScoreDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserScoreDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['username'] = this.username;
    data['orderScore'] = this.orderScore;
    data['publicScore'] = this.publicScore;
    data['education'] = this.education;
    data['country'] = this.country;
    data['countryFlagUrl'] = this.countryFlagUrl;
    return data;
  }
}

export interface IAppUserScoreDto {
  username?: string | undefined;
  orderScore?: number;
  publicScore?: number;
  education?: string | undefined;
  country?: string | undefined;
  countryFlagUrl?: string | undefined;
}

export class CanUserRequestCalculateDto implements ICanUserRequestCalculateDto {
  canUserCalculate?: boolean;

  constructor(data?: ICanUserRequestCalculateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.canUserCalculate = _data['canUserCalculate'];
    }
  }

  static fromJS(data: any): CanUserRequestCalculateDto {
    data = typeof data === 'object' ? data : {};
    let result = new CanUserRequestCalculateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['canUserCalculate'] = this.canUserCalculate;
    return data;
  }
}

export interface ICanUserRequestCalculateDto {
  canUserCalculate?: boolean;
}

export class GLeaderboardCalculateRequestDto implements IGLeaderboardCalculateRequestDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  creator?: AppUserProfileDto;
  lastModifier?: AppUserProfileDto;
  contestId?: string;
  status?: string | undefined;

  constructor(data?: IGLeaderboardCalculateRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.creator = _data['creator'] ? AppUserProfileDto.fromJS(_data['creator']) : <any>undefined;
      this.lastModifier = _data['lastModifier']
        ? AppUserProfileDto.fromJS(_data['lastModifier'])
        : <any>undefined;
      this.contestId = _data['contestId'];
      this.status = _data['status'];
    }
  }

  static fromJS(data: any): GLeaderboardCalculateRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new GLeaderboardCalculateRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['creator'] = this.creator ? this.creator.toJSON() : <any>undefined;
    data['lastModifier'] = this.lastModifier ? this.lastModifier.toJSON() : <any>undefined;
    data['contestId'] = this.contestId;
    data['status'] = this.status;
    return data;
  }
}

export interface IGLeaderboardCalculateRequestDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  creator?: AppUserProfileDto;
  lastModifier?: AppUserProfileDto;
  contestId?: string;
  status?: string | undefined;
}

export class ProblemDto implements IProblemDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  ownerUserId?: string;
  name?: string | undefined;
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  successRatio?: number;
  ownerUser?: AppUserPreviewProfileDto;
  totalSubmission?: number;
  source?: SourceDto;
  sourceNames?: string | undefined;
  tags?: TagDto[] | undefined;
  tagNames?: string | undefined;
  precisionCheck?: number;
  isPrecisionCheck?: boolean;
  totalSolvedSubmission?: number;

  constructor(data?: IProblemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.isDeleted = _data['isDeleted'];
      this.deleterId = _data['deleterId'];
      this.deletionTime = _data['deletionTime']
        ? new Date(_data['deletionTime'].toString())
        : <any>undefined;
      this.ownerUserId = _data['ownerUserId'];
      this.name = _data['name'];
      this.language = _data['language'];
      this.difficulty = _data['difficulty'];
      this.slug = _data['slug'];
      this.scoringType = _data['scoringType'];
      this.status = _data['status'];
      this.successRatio = _data['successRatio'];
      this.ownerUser = _data['ownerUser']
        ? AppUserPreviewProfileDto.fromJS(_data['ownerUser'])
        : <any>undefined;
      this.totalSubmission = _data['totalSubmission'];
      this.source = _data['source'] ? SourceDto.fromJS(_data['source']) : <any>undefined;
      this.sourceNames = _data['sourceNames'];
      if (Array.isArray(_data['tags'])) {
        this.tags = [] as any;
        for (let item of _data['tags']) this.tags!.push(TagDto.fromJS(item));
      }
      this.tagNames = _data['tagNames'];
      this.precisionCheck = _data['precisionCheck'];
      this.isPrecisionCheck = _data['isPrecisionCheck'];
      this.totalSolvedSubmission = _data['totalSolvedSubmission'];
    }
  }

  static fromJS(data: any): ProblemDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['isDeleted'] = this.isDeleted;
    data['deleterId'] = this.deleterId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['ownerUserId'] = this.ownerUserId;
    data['name'] = this.name;
    data['language'] = this.language;
    data['difficulty'] = this.difficulty;
    data['slug'] = this.slug;
    data['scoringType'] = this.scoringType;
    data['status'] = this.status;
    data['successRatio'] = this.successRatio;
    data['ownerUser'] = this.ownerUser ? this.ownerUser.toJSON() : <any>undefined;
    data['totalSubmission'] = this.totalSubmission;
    data['source'] = this.source ? this.source.toJSON() : <any>undefined;
    data['sourceNames'] = this.sourceNames;
    if (Array.isArray(this.tags)) {
      data['tags'] = [];
      for (let item of this.tags) data['tags'].push(item.toJSON());
    }
    data['tagNames'] = this.tagNames;
    data['precisionCheck'] = this.precisionCheck;
    data['isPrecisionCheck'] = this.isPrecisionCheck;
    data['totalSolvedSubmission'] = this.totalSolvedSubmission;
    return data;
  }
}

export interface IProblemDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  ownerUserId?: string;
  name?: string | undefined;
  language?: string | undefined;
  difficulty?: ProblemDifficulty;
  slug?: string | undefined;
  scoringType?: ProblemScoringType;
  status?: ProblemStatus;
  successRatio?: number;
  ownerUser?: AppUserPreviewProfileDto;
  totalSubmission?: number;
  source?: SourceDto;
  sourceNames?: string | undefined;
  tags?: TagDto[] | undefined;
  tagNames?: string | undefined;
  precisionCheck?: number;
  isPrecisionCheck?: boolean;
  totalSolvedSubmission?: number;
}

export class ProblemEditorialCreateUpdateDto implements IProblemEditorialCreateUpdateDto {
  problemId?: string;
  timeComplexity?: string | undefined;
  hint?: string | undefined;
  editorial?: string | undefined;

  constructor(data?: IProblemEditorialCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.problemId = _data['problemId'];
      this.timeComplexity = _data['timeComplexity'];
      this.hint = _data['hint'];
      this.editorial = _data['editorial'];
    }
  }

  static fromJS(data: any): ProblemEditorialCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemEditorialCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['problemId'] = this.problemId;
    data['timeComplexity'] = this.timeComplexity;
    data['hint'] = this.hint;
    data['editorial'] = this.editorial;
    return data;
  }
}

export interface IProblemEditorialCreateUpdateDto {
  problemId?: string;
  timeComplexity?: string | undefined;
  hint?: string | undefined;
  editorial?: string | undefined;
}

export class ProblemEditorialDto implements IProblemEditorialDto {
  id?: string;
  problemId?: string;
  timeComplexity?: string | undefined;
  hint?: string | undefined;
  editorial?: string | undefined;
  isUnlocked?: boolean;

  constructor(data?: IProblemEditorialDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.problemId = _data['problemId'];
      this.timeComplexity = _data['timeComplexity'];
      this.hint = _data['hint'];
      this.editorial = _data['editorial'];
      this.isUnlocked = _data['isUnlocked'];
    }
  }

  static fromJS(data: any): ProblemEditorialDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemEditorialDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['problemId'] = this.problemId;
    data['timeComplexity'] = this.timeComplexity;
    data['hint'] = this.hint;
    data['editorial'] = this.editorial;
    data['isUnlocked'] = this.isUnlocked;
    return data;
  }
}

export interface IProblemEditorialDto {
  id?: string;
  problemId?: string;
  timeComplexity?: string | undefined;
  hint?: string | undefined;
  editorial?: string | undefined;
  isUnlocked?: boolean;
}

export class ProblemPreviewDto implements IProblemPreviewDto {
  detail?: ProblemDetailedDto;
  editorial?: ProblemEditorialDto;
  statement?: ProblemStatementDto;
  programmingLanguages?: ProblemProgrammingLanguageDto[] | undefined;
  testCases?: ProblemTestCaseDto[] | undefined;

  constructor(data?: IProblemPreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.detail = _data['detail'] ? ProblemDetailedDto.fromJS(_data['detail']) : <any>undefined;
      this.editorial = _data['editorial']
        ? ProblemEditorialDto.fromJS(_data['editorial'])
        : <any>undefined;
      this.statement = _data['statement']
        ? ProblemStatementDto.fromJS(_data['statement'])
        : <any>undefined;
      if (Array.isArray(_data['programmingLanguages'])) {
        this.programmingLanguages = [] as any;
        for (let item of _data['programmingLanguages'])
          this.programmingLanguages!.push(ProblemProgrammingLanguageDto.fromJS(item));
      }
      if (Array.isArray(_data['testCases'])) {
        this.testCases = [] as any;
        for (let item of _data['testCases']) this.testCases!.push(ProblemTestCaseDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProblemPreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemPreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['detail'] = this.detail ? this.detail.toJSON() : <any>undefined;
    data['editorial'] = this.editorial ? this.editorial.toJSON() : <any>undefined;
    data['statement'] = this.statement ? this.statement.toJSON() : <any>undefined;
    if (Array.isArray(this.programmingLanguages)) {
      data['programmingLanguages'] = [];
      for (let item of this.programmingLanguages) data['programmingLanguages'].push(item.toJSON());
    }
    if (Array.isArray(this.testCases)) {
      data['testCases'] = [];
      for (let item of this.testCases) data['testCases'].push(item.toJSON());
    }
    return data;
  }
}

export interface IProblemPreviewDto {
  detail?: ProblemDetailedDto;
  editorial?: ProblemEditorialDto;
  statement?: ProblemStatementDto;
  programmingLanguages?: ProblemProgrammingLanguageDto[] | undefined;
  testCases?: ProblemTestCaseDto[] | undefined;
}

export class ProblemProgrammingLanguageCreateDto implements IProblemProgrammingLanguageCreateDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  programmingLanguageId?: string;
  problemId?: string;
  timeLimit?: number;
  memoryLimit?: number;

  constructor(data?: IProblemProgrammingLanguageCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.isDeleted = _data['isDeleted'];
      this.deleterId = _data['deleterId'];
      this.deletionTime = _data['deletionTime']
        ? new Date(_data['deletionTime'].toString())
        : <any>undefined;
      this.programmingLanguageId = _data['programmingLanguageId'];
      this.problemId = _data['problemId'];
      this.timeLimit = _data['timeLimit'];
      this.memoryLimit = _data['memoryLimit'];
    }
  }

  static fromJS(data: any): ProblemProgrammingLanguageCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemProgrammingLanguageCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['isDeleted'] = this.isDeleted;
    data['deleterId'] = this.deleterId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['programmingLanguageId'] = this.programmingLanguageId;
    data['problemId'] = this.problemId;
    data['timeLimit'] = this.timeLimit;
    data['memoryLimit'] = this.memoryLimit;
    return data;
  }
}

export interface IProblemProgrammingLanguageCreateDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  programmingLanguageId?: string;
  problemId?: string;
  timeLimit?: number;
  memoryLimit?: number;
}

export class ProblemProgrammingLanguageDto implements IProblemProgrammingLanguageDto {
  id?: string;
  programmingLanguageId?: string;
  problemId?: string;
  languageName?: string | undefined;
  timeLimit?: number;
  memoryLimit?: number;
  value?: boolean;
  defaultProblemId?: string;

  constructor(data?: IProblemProgrammingLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.programmingLanguageId = _data['programmingLanguageId'];
      this.problemId = _data['problemId'];
      this.languageName = _data['languageName'];
      this.timeLimit = _data['timeLimit'];
      this.memoryLimit = _data['memoryLimit'];
      this.value = _data['value'];
      this.defaultProblemId = _data['defaultProblemId'];
    }
  }

  static fromJS(data: any): ProblemProgrammingLanguageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemProgrammingLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['programmingLanguageId'] = this.programmingLanguageId;
    data['problemId'] = this.problemId;
    data['languageName'] = this.languageName;
    data['timeLimit'] = this.timeLimit;
    data['memoryLimit'] = this.memoryLimit;
    data['value'] = this.value;
    data['defaultProblemId'] = this.defaultProblemId;
    return data;
  }
}

export interface IProblemProgrammingLanguageDto {
  id?: string;
  programmingLanguageId?: string;
  problemId?: string;
  languageName?: string | undefined;
  timeLimit?: number;
  memoryLimit?: number;
  value?: boolean;
  defaultProblemId?: string;
}

export class ProblemProgrammingLanguageUpdateDto implements IProblemProgrammingLanguageUpdateDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  programmingLanguageId?: string;
  problemId?: string;
  timeLimit?: number;
  memoryLimit?: number;

  constructor(data?: IProblemProgrammingLanguageUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.isDeleted = _data['isDeleted'];
      this.deleterId = _data['deleterId'];
      this.deletionTime = _data['deletionTime']
        ? new Date(_data['deletionTime'].toString())
        : <any>undefined;
      this.programmingLanguageId = _data['programmingLanguageId'];
      this.problemId = _data['problemId'];
      this.timeLimit = _data['timeLimit'];
      this.memoryLimit = _data['memoryLimit'];
    }
  }

  static fromJS(data: any): ProblemProgrammingLanguageUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemProgrammingLanguageUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['isDeleted'] = this.isDeleted;
    data['deleterId'] = this.deleterId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['programmingLanguageId'] = this.programmingLanguageId;
    data['problemId'] = this.problemId;
    data['timeLimit'] = this.timeLimit;
    data['memoryLimit'] = this.memoryLimit;
    return data;
  }
}

export interface IProblemProgrammingLanguageUpdateDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  programmingLanguageId?: string;
  problemId?: string;
  timeLimit?: number;
  memoryLimit?: number;
}

export class ProblemSampleTestCaseDto implements IProblemSampleTestCaseDto {
  input?: string | undefined;
  output?: string | undefined;
  explanation?: string | undefined;

  constructor(data?: IProblemSampleTestCaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.input = _data['input'];
      this.output = _data['output'];
      this.explanation = _data['explanation'];
    }
  }

  static fromJS(data: any): ProblemSampleTestCaseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSampleTestCaseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['input'] = this.input;
    data['output'] = this.output;
    data['explanation'] = this.explanation;
    return data;
  }
}

export interface IProblemSampleTestCaseDto {
  input?: string | undefined;
  output?: string | undefined;
  explanation?: string | undefined;
}

export class ProblemSlugPreviewDto implements IProblemSlugPreviewDto {
  slug?: string | undefined;

  constructor(data?: IProblemSlugPreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.slug = _data['slug'];
    }
  }

  static fromJS(data: any): ProblemSlugPreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSlugPreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['slug'] = this.slug;
    return data;
  }
}

export interface IProblemSlugPreviewDto {
  slug?: string | undefined;
}

export class ProblemSolutionCreateDto implements IProblemSolutionCreateDto {
  problemId?: string;
  languageId?: string;
  path?: string | undefined;
  name?: string | undefined;
  expected?: SolutionExpectedType;

  constructor(data?: IProblemSolutionCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.problemId = _data['problemId'];
      this.languageId = _data['languageId'];
      this.path = _data['path'];
      this.name = _data['name'];
      this.expected = _data['expected'];
    }
  }

  static fromJS(data: any): ProblemSolutionCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSolutionCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['problemId'] = this.problemId;
    data['languageId'] = this.languageId;
    data['path'] = this.path;
    data['name'] = this.name;
    data['expected'] = this.expected;
    return data;
  }
}

export interface IProblemSolutionCreateDto {
  problemId?: string;
  languageId?: string;
  path?: string | undefined;
  name?: string | undefined;
  expected?: SolutionExpectedType;
}

export class ProblemSolutionDto implements IProblemSolutionDto {
  id?: string;
  problemId?: string;
  languageId?: string;
  language?: string | undefined;
  author?: string | undefined;
  path?: string | undefined;
  name?: string | undefined;
  expected?: SolutionExpectedType;
  actual?: SolutionExpectedType[] | undefined;
  shortName?: string | undefined;

  constructor(data?: IProblemSolutionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.problemId = _data['problemId'];
      this.languageId = _data['languageId'];
      this.language = _data['language'];
      this.author = _data['author'];
      this.path = _data['path'];
      this.name = _data['name'];
      this.expected = _data['expected'];
      if (Array.isArray(_data['actual'])) {
        this.actual = [] as any;
        for (let item of _data['actual']) this.actual!.push(item);
      }
      this.shortName = _data['shortName'];
    }
  }

  static fromJS(data: any): ProblemSolutionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSolutionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['problemId'] = this.problemId;
    data['languageId'] = this.languageId;
    data['language'] = this.language;
    data['author'] = this.author;
    data['path'] = this.path;
    data['name'] = this.name;
    data['expected'] = this.expected;
    if (Array.isArray(this.actual)) {
      data['actual'] = [];
      for (let item of this.actual) data['actual'].push(item);
    }
    data['shortName'] = this.shortName;
    return data;
  }
}

export interface IProblemSolutionDto {
  id?: string;
  problemId?: string;
  languageId?: string;
  language?: string | undefined;
  author?: string | undefined;
  path?: string | undefined;
  name?: string | undefined;
  expected?: SolutionExpectedType;
  actual?: SolutionExpectedType[] | undefined;
  shortName?: string | undefined;
}

export class ProblemSolutionUpdateDto implements IProblemSolutionUpdateDto {
  problemId?: string;
  languageId?: string;
  path?: string | undefined;
  name?: string | undefined;
  expected?: SolutionExpectedType;

  constructor(data?: IProblemSolutionUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.problemId = _data['problemId'];
      this.languageId = _data['languageId'];
      this.path = _data['path'];
      this.name = _data['name'];
      this.expected = _data['expected'];
    }
  }

  static fromJS(data: any): ProblemSolutionUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSolutionUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['problemId'] = this.problemId;
    data['languageId'] = this.languageId;
    data['path'] = this.path;
    data['name'] = this.name;
    data['expected'] = this.expected;
    return data;
  }
}

export interface IProblemSolutionUpdateDto {
  problemId?: string;
  languageId?: string;
  path?: string | undefined;
  name?: string | undefined;
  expected?: SolutionExpectedType;
}

export class ProblemStatementDto implements IProblemStatementDto {
  id?: string;
  problemId?: string;
  statement?: string | undefined;
  inputFormat?: string | undefined;
  outputFormat?: string | undefined;
  constraints?: string | undefined;
  note?: string | undefined;
  sampleTestCases?: ProblemSampleTestCaseDto[] | undefined;

  constructor(data?: IProblemStatementDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.problemId = _data['problemId'];
      this.statement = _data['statement'];
      this.inputFormat = _data['inputFormat'];
      this.outputFormat = _data['outputFormat'];
      this.constraints = _data['constraints'];
      this.note = _data['note'];
      if (Array.isArray(_data['sampleTestCases'])) {
        this.sampleTestCases = [] as any;
        for (let item of _data['sampleTestCases'])
          this.sampleTestCases!.push(ProblemSampleTestCaseDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ProblemStatementDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemStatementDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['problemId'] = this.problemId;
    data['statement'] = this.statement;
    data['inputFormat'] = this.inputFormat;
    data['outputFormat'] = this.outputFormat;
    data['constraints'] = this.constraints;
    data['note'] = this.note;
    if (Array.isArray(this.sampleTestCases)) {
      data['sampleTestCases'] = [];
      for (let item of this.sampleTestCases) data['sampleTestCases'].push(item.toJSON());
    }
    return data;
  }
}

export interface IProblemStatementDto {
  id?: string;
  problemId?: string;
  statement?: string | undefined;
  inputFormat?: string | undefined;
  outputFormat?: string | undefined;
  constraints?: string | undefined;
  note?: string | undefined;
  sampleTestCases?: ProblemSampleTestCaseDto[] | undefined;
}

export class ProblemStatementSetDto implements IProblemStatementSetDto {
  statement?: string | undefined;
  inputFormat?: string | undefined;
  outputFormat?: string | undefined;
  constraints?: string | undefined;
  note?: string | undefined;

  constructor(data?: IProblemStatementSetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.statement = _data['statement'];
      this.inputFormat = _data['inputFormat'];
      this.outputFormat = _data['outputFormat'];
      this.constraints = _data['constraints'];
      this.note = _data['note'];
    }
  }

  static fromJS(data: any): ProblemStatementSetDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemStatementSetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['statement'] = this.statement;
    data['inputFormat'] = this.inputFormat;
    data['outputFormat'] = this.outputFormat;
    data['constraints'] = this.constraints;
    data['note'] = this.note;
    return data;
  }
}

export interface IProblemStatementSetDto {
  statement?: string | undefined;
  inputFormat?: string | undefined;
  outputFormat?: string | undefined;
  constraints?: string | undefined;
  note?: string | undefined;
}

export class ProblemSubmissionCreateUpdateDto implements IProblemSubmissionCreateUpdateDto {
  problemId?: string;
  programmingLanguageId?: string;
  status?: ProblemSubmissionStatus;
  context?: Context;
  contestId?: string | undefined;
  accessLevel?: AccessLevel;
  submittedCode?: string | undefined;
  submittedCodePath?: string | undefined;

  constructor(data?: IProblemSubmissionCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.problemId = _data['problemId'];
      this.programmingLanguageId = _data['programmingLanguageId'];
      this.status = _data['status'];
      this.context = _data['context'];
      this.contestId = _data['contestId'];
      this.accessLevel = _data['accessLevel'];
      this.submittedCode = _data['submittedCode'];
      this.submittedCodePath = _data['submittedCodePath'];
    }
  }

  static fromJS(data: any): ProblemSubmissionCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSubmissionCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['problemId'] = this.problemId;
    data['programmingLanguageId'] = this.programmingLanguageId;
    data['status'] = this.status;
    data['context'] = this.context;
    data['contestId'] = this.contestId;
    data['accessLevel'] = this.accessLevel;
    data['submittedCode'] = this.submittedCode;
    data['submittedCodePath'] = this.submittedCodePath;
    return data;
  }
}

export interface IProblemSubmissionCreateUpdateDto {
  problemId?: string;
  programmingLanguageId?: string;
  status?: ProblemSubmissionStatus;
  context?: Context;
  contestId?: string | undefined;
  accessLevel?: AccessLevel;
  submittedCode?: string | undefined;
  submittedCodePath?: string | undefined;
}

export class ProblemSubmissionDto implements IProblemSubmissionDto {
  id?: string;
  problemId?: string;
  contestId?: string | undefined;
  problemName?: string | undefined;
  problemSlug?: string | undefined;
  programmingLanguageId?: string;
  status?: ProblemSubmissionStatus;
  context?: Context;
  accessLevel?: AccessLevel;
  submittedCode?: string | undefined;
  submittedCodePath?: string | undefined;
  startDate?: Date;
  formattedStartDate?: string | undefined;
  endDate?: Date;
  formattedEndDate?: string | undefined;
  duration?: number;
  programmingLanguage?: ProgrammingLanguageDto;
  userName?: string | undefined;
  creatorId?: string | undefined;

  constructor(data?: IProblemSubmissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.problemId = _data['problemId'];
      this.contestId = _data['contestId'];
      this.problemName = _data['problemName'];
      this.problemSlug = _data['problemSlug'];
      this.programmingLanguageId = _data['programmingLanguageId'];
      this.status = _data['status'];
      this.context = _data['context'];
      this.accessLevel = _data['accessLevel'];
      this.submittedCode = _data['submittedCode'];
      this.submittedCodePath = _data['submittedCodePath'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.formattedStartDate = _data['formattedStartDate'];
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
      this.formattedEndDate = _data['formattedEndDate'];
      this.duration = _data['duration'];
      this.programmingLanguage = _data['programmingLanguage']
        ? ProgrammingLanguageDto.fromJS(_data['programmingLanguage'])
        : <any>undefined;
      this.userName = _data['userName'];
      this.creatorId = _data['creatorId'];
    }
  }

  static fromJS(data: any): ProblemSubmissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSubmissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['problemId'] = this.problemId;
    data['contestId'] = this.contestId;
    data['problemName'] = this.problemName;
    data['problemSlug'] = this.problemSlug;
    data['programmingLanguageId'] = this.programmingLanguageId;
    data['status'] = this.status;
    data['context'] = this.context;
    data['accessLevel'] = this.accessLevel;
    data['submittedCode'] = this.submittedCode;
    data['submittedCodePath'] = this.submittedCodePath;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['formattedStartDate'] = this.formattedStartDate;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    data['formattedEndDate'] = this.formattedEndDate;
    data['duration'] = this.duration;
    data['programmingLanguage'] = this.programmingLanguage
      ? this.programmingLanguage.toJSON()
      : <any>undefined;
    data['userName'] = this.userName;
    data['creatorId'] = this.creatorId;
    return data;
  }
}

export interface IProblemSubmissionDto {
  id?: string;
  problemId?: string;
  contestId?: string | undefined;
  problemName?: string | undefined;
  problemSlug?: string | undefined;
  programmingLanguageId?: string;
  status?: ProblemSubmissionStatus;
  context?: Context;
  accessLevel?: AccessLevel;
  submittedCode?: string | undefined;
  submittedCodePath?: string | undefined;
  startDate?: Date;
  formattedStartDate?: string | undefined;
  endDate?: Date;
  formattedEndDate?: string | undefined;
  duration?: number;
  programmingLanguage?: ProgrammingLanguageDto;
  userName?: string | undefined;
  creatorId?: string | undefined;
}

export class ProblemSubmissionResultDto implements IProblemSubmissionResultDto {
  problemSubmissionId?: string;
  problemTestCaseId?: string;
  status?: ProblemSubmissionResultStatus;
  plainStatus?: string | undefined;
  output?: string | undefined;
  input?: string | undefined;
  expectedOutput?: string | undefined;
  message?: string | undefined;
  error?: string | undefined;
  usedMemory?: number;
  totalTime?: number;

  constructor(data?: IProblemSubmissionResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.problemSubmissionId = _data['problemSubmissionId'];
      this.problemTestCaseId = _data['problemTestCaseId'];
      this.status = _data['status'];
      this.plainStatus = _data['plainStatus'];
      this.output = _data['output'];
      this.input = _data['input'];
      this.expectedOutput = _data['expectedOutput'];
      this.message = _data['message'];
      this.error = _data['error'];
      this.usedMemory = _data['usedMemory'];
      this.totalTime = _data['totalTime'];
    }
  }

  static fromJS(data: any): ProblemSubmissionResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSubmissionResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['problemSubmissionId'] = this.problemSubmissionId;
    data['problemTestCaseId'] = this.problemTestCaseId;
    data['status'] = this.status;
    data['plainStatus'] = this.plainStatus;
    data['output'] = this.output;
    data['input'] = this.input;
    data['expectedOutput'] = this.expectedOutput;
    data['message'] = this.message;
    data['error'] = this.error;
    data['usedMemory'] = this.usedMemory;
    data['totalTime'] = this.totalTime;
    return data;
  }
}

export interface IProblemSubmissionResultDto {
  problemSubmissionId?: string;
  problemTestCaseId?: string;
  status?: ProblemSubmissionResultStatus;
  plainStatus?: string | undefined;
  output?: string | undefined;
  input?: string | undefined;
  expectedOutput?: string | undefined;
  message?: string | undefined;
  error?: string | undefined;
  usedMemory?: number;
  totalTime?: number;
}

export class ProblemSubmissionResultLimitedDto implements IProblemSubmissionResultLimitedDto {
  status?: ProblemSubmissionResultStatus;
  plainStatus?: string | undefined;
  message?: string | undefined;
  error?: string | undefined;

  constructor(data?: IProblemSubmissionResultLimitedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.status = _data['status'];
      this.plainStatus = _data['plainStatus'];
      this.message = _data['message'];
      this.error = _data['error'];
    }
  }

  static fromJS(data: any): ProblemSubmissionResultLimitedDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSubmissionResultLimitedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['status'] = this.status;
    data['plainStatus'] = this.plainStatus;
    data['message'] = this.message;
    data['error'] = this.error;
    return data;
  }
}

export interface IProblemSubmissionResultLimitedDto {
  status?: ProblemSubmissionResultStatus;
  plainStatus?: string | undefined;
  message?: string | undefined;
  error?: string | undefined;
}

export class ProblemSummaryDto implements IProblemSummaryDto {
  id?: string;
  name?: string | undefined;

  constructor(data?: IProblemSummaryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): ProblemSummaryDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSummaryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IProblemSummaryDto {
  id?: string;
  name?: string | undefined;
}

export class ProblemTestCaseBulkImportDto implements IProblemTestCaseBulkImportDto {
  tagId?: string | undefined;
  strength?: number;
  zipBytes?: string | undefined;

  constructor(data?: IProblemTestCaseBulkImportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tagId = _data['tagId'];
      this.strength = _data['strength'];
      this.zipBytes = _data['zipBytes'];
    }
  }

  static fromJS(data: any): ProblemTestCaseBulkImportDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemTestCaseBulkImportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tagId'] = this.tagId;
    data['strength'] = this.strength;
    data['zipBytes'] = this.zipBytes;
    return data;
  }
}

export interface IProblemTestCaseBulkImportDto {
  tagId?: string | undefined;
  strength?: number;
  zipBytes?: string | undefined;
}

export class ProblemTestCaseCreateUpdateDto implements IProblemTestCaseCreateUpdateDto {
  tagId?: string[] | undefined;
  isSample?: boolean;
  input?: string | undefined;
  output?: string | undefined;
  explanation?: string | undefined;

  constructor(data?: IProblemTestCaseCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['tagId'])) {
        this.tagId = [] as any;
        for (let item of _data['tagId']) this.tagId!.push(item);
      }
      this.isSample = _data['isSample'];
      this.input = _data['input'];
      this.output = _data['output'];
      this.explanation = _data['explanation'];
    }
  }

  static fromJS(data: any): ProblemTestCaseCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemTestCaseCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.tagId)) {
      data['tagId'] = [];
      for (let item of this.tagId) data['tagId'].push(item);
    }
    data['isSample'] = this.isSample;
    data['input'] = this.input;
    data['output'] = this.output;
    data['explanation'] = this.explanation;
    return data;
  }
}

export interface IProblemTestCaseCreateUpdateDto {
  tagId?: string[] | undefined;
  isSample?: boolean;
  input?: string | undefined;
  output?: string | undefined;
  explanation?: string | undefined;
}

export class ProblemTestCaseDto implements IProblemTestCaseDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  problemId?: string;
  tagId?: string[] | undefined;
  isSample?: boolean;
  input?: string | undefined;
  inputPath?: string | undefined;
  inputFileName?: string | undefined;
  inputSizeAndFileName?: string | undefined;
  output?: string | undefined;
  outputPath?: string | undefined;
  outputSize?: number;
  outputFileName?: string | undefined;
  outputSizeAndFileName?: string | undefined;
  inputSize?: number;
  explanation?: string | undefined;
  orderNumber?: number;

  constructor(data?: IProblemTestCaseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.problemId = _data['problemId'];
      if (Array.isArray(_data['tagId'])) {
        this.tagId = [] as any;
        for (let item of _data['tagId']) this.tagId!.push(item);
      }
      this.isSample = _data['isSample'];
      this.input = _data['input'];
      this.inputPath = _data['inputPath'];
      this.inputFileName = _data['inputFileName'];
      this.inputSizeAndFileName = _data['inputSizeAndFileName'];
      this.output = _data['output'];
      this.outputPath = _data['outputPath'];
      this.outputSize = _data['outputSize'];
      this.outputFileName = _data['outputFileName'];
      this.outputSizeAndFileName = _data['outputSizeAndFileName'];
      this.inputSize = _data['inputSize'];
      this.explanation = _data['explanation'];
      this.orderNumber = _data['orderNumber'];
    }
  }

  static fromJS(data: any): ProblemTestCaseDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemTestCaseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['problemId'] = this.problemId;
    if (Array.isArray(this.tagId)) {
      data['tagId'] = [];
      for (let item of this.tagId) data['tagId'].push(item);
    }
    data['isSample'] = this.isSample;
    data['input'] = this.input;
    data['inputPath'] = this.inputPath;
    data['inputFileName'] = this.inputFileName;
    data['inputSizeAndFileName'] = this.inputSizeAndFileName;
    data['output'] = this.output;
    data['outputPath'] = this.outputPath;
    data['outputSize'] = this.outputSize;
    data['outputFileName'] = this.outputFileName;
    data['outputSizeAndFileName'] = this.outputSizeAndFileName;
    data['inputSize'] = this.inputSize;
    data['explanation'] = this.explanation;
    data['orderNumber'] = this.orderNumber;
    return data;
  }
}

export interface IProblemTestCaseDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  problemId?: string;
  tagId?: string[] | undefined;
  isSample?: boolean;
  input?: string | undefined;
  inputPath?: string | undefined;
  inputFileName?: string | undefined;
  inputSizeAndFileName?: string | undefined;
  output?: string | undefined;
  outputPath?: string | undefined;
  outputSize?: number;
  outputFileName?: string | undefined;
  outputSizeAndFileName?: string | undefined;
  inputSize?: number;
  explanation?: string | undefined;
  orderNumber?: number;
}

export class ProblemTestCaseImportDto implements IProblemTestCaseImportDto {
  tagId?: string | undefined;
  strength?: number;
  isSample?: boolean;
  isAdditional?: boolean;
  inputBytes?: string | undefined;
  outputBytes?: string | undefined;
  explanation?: string | undefined;

  constructor(data?: IProblemTestCaseImportDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.tagId = _data['tagId'];
      this.strength = _data['strength'];
      this.isSample = _data['isSample'];
      this.isAdditional = _data['isAdditional'];
      this.inputBytes = _data['inputBytes'];
      this.outputBytes = _data['outputBytes'];
      this.explanation = _data['explanation'];
    }
  }

  static fromJS(data: any): ProblemTestCaseImportDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemTestCaseImportDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['tagId'] = this.tagId;
    data['strength'] = this.strength;
    data['isSample'] = this.isSample;
    data['isAdditional'] = this.isAdditional;
    data['inputBytes'] = this.inputBytes;
    data['outputBytes'] = this.outputBytes;
    data['explanation'] = this.explanation;
    return data;
  }
}

export interface IProblemTestCaseImportDto {
  tagId?: string | undefined;
  strength?: number;
  isSample?: boolean;
  isAdditional?: boolean;
  inputBytes?: string | undefined;
  outputBytes?: string | undefined;
  explanation?: string | undefined;
}

export class SubmissionCreatorDto implements ISubmissionCreatorDto {
  id?: string;
  name?: string | undefined;

  constructor(data?: ISubmissionCreatorDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): SubmissionCreatorDto {
    data = typeof data === 'object' ? data : {};
    let result = new SubmissionCreatorDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface ISubmissionCreatorDto {
  id?: string;
  name?: string | undefined;
}

export enum ProblemDifficulty {
  Level_1 = 'Level_1',
  Level_2 = 'Level_2',
  Level_3 = 'Level_3',
  Level_4 = 'Level_4',
  Level_5 = 'Level_5',
  Level_6 = 'Level_6',
  Level_7 = 'Level_7',
  Level_8 = 'Level_8',
  Level_9 = 'Level_9',
  Level_10 = 'Level_10',
}

export enum ProblemScoringType {
  None = 'None',
  ICPC = 'ICPC',
  IOI = 'IOI',
}

export enum ProblemStatus {
  None = 'None',
  Incomplete = 'Incomplete',
  Pending = 'Pending',
  InReview = 'InReview',
  Rejected = 'Rejected',
  Accepted = 'Accepted',
  Published = 'Published',
}

export enum ProblemSubmissionResultStatus {
  Unknown = 'Unknown',
  Pending = 'Pending',
  Running = 'Running',
  Accepted = 'Accepted',
  WrongAnswer = 'WrongAnswer',
  MemoryLimitExceeded = 'MemoryLimitExceeded',
  TimeLimitExceeded = 'TimeLimitExceeded',
  CompileError = 'CompileError',
  RuntimeError = 'RuntimeError',
  InteractorError = 'InteractorError',
}

export enum ProblemSubmissionStatus {
  Pending = 'Pending',
  Processing = 'Processing',
  CompileError = 'CompileError',
  WrongAnswer = 'WrongAnswer',
  Accepted = 'Accepted',
  InteractorError = 'InteractorError',
}

export enum SolutionExpectedType {
  Correct = 'Correct',
  TimeLimitExceeded = 'TimeLimitExceeded',
  WrongAnswer = 'WrongAnswer',
  MemoryLimitExceeded = 'MemoryLimitExceeded',
  Failed = 'Failed',
}

export class CityCreateUpdateDto implements ICityCreateUpdateDto {
  countryId!: string;
  name!: string;

  constructor(data?: ICityCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.countryId = _data['countryId'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): CityCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new CityCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['countryId'] = this.countryId;
    data['name'] = this.name;
    return data;
  }
}

export interface ICityCreateUpdateDto {
  countryId: string;
  name: string;
}

export class CityDto implements ICityDto {
  id?: string;
  countryId?: string;
  name?: string | undefined;
  countryName?: string | undefined;
  iso2?: string | undefined;

  constructor(data?: ICityDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.countryId = _data['countryId'];
      this.name = _data['name'];
      this.countryName = _data['countryName'];
      this.iso2 = _data['iso2'];
    }
  }

  static fromJS(data: any): CityDto {
    data = typeof data === 'object' ? data : {};
    let result = new CityDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['countryId'] = this.countryId;
    data['name'] = this.name;
    data['countryName'] = this.countryName;
    data['iso2'] = this.iso2;
    return data;
  }
}

export interface ICityDto {
  id?: string;
  countryId?: string;
  name?: string | undefined;
  countryName?: string | undefined;
  iso2?: string | undefined;
}

export class CityLookupDto implements ICityLookupDto {
  id?: string;
  name?: string | undefined;

  constructor(data?: ICityLookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): CityLookupDto {
    data = typeof data === 'object' ? data : {};
    let result = new CityLookupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface ICityLookupDto {
  id?: string;
  name?: string | undefined;
}

export class CountryCreateUpdateDto implements ICountryCreateUpdateDto {
  name!: string;
  iso2!: string;
  iso3?: string | undefined;

  constructor(data?: ICountryCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.iso2 = _data['iso2'];
      this.iso3 = _data['iso3'];
    }
  }

  static fromJS(data: any): CountryCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new CountryCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['iso2'] = this.iso2;
    data['iso3'] = this.iso3;
    return data;
  }
}

export interface ICountryCreateUpdateDto {
  name: string;
  iso2: string;
  iso3?: string | undefined;
}

export class CountryDto implements ICountryDto {
  id?: string;
  name?: string | undefined;
  iso2?: string | undefined;
  iso3?: string | undefined;

  constructor(data?: ICountryDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.iso2 = _data['iso2'];
      this.iso3 = _data['iso3'];
    }
  }

  static fromJS(data: any): CountryDto {
    data = typeof data === 'object' ? data : {};
    let result = new CountryDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['iso2'] = this.iso2;
    data['iso3'] = this.iso3;
    return data;
  }
}

export interface ICountryDto {
  id?: string;
  name?: string | undefined;
  iso2?: string | undefined;
  iso3?: string | undefined;
}

export class ContestProblemStatisticsDto implements IContestProblemStatisticsDto {
  sumOfTotalSubmissions?: number;
  sumOfCorrectSubmissions?: number;
  sumOfWrongSubmissions?: number;
  averageSuccessRatio?: number;
  problemStatistics?: ProblemStatisticsDto[] | undefined;

  constructor(data?: IContestProblemStatisticsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sumOfTotalSubmissions = _data['sumOfTotalSubmissions'];
      this.sumOfCorrectSubmissions = _data['sumOfCorrectSubmissions'];
      this.sumOfWrongSubmissions = _data['sumOfWrongSubmissions'];
      this.averageSuccessRatio = _data['averageSuccessRatio'];
      if (Array.isArray(_data['problemStatistics'])) {
        this.problemStatistics = [] as any;
        for (let item of _data['problemStatistics'])
          this.problemStatistics!.push(ProblemStatisticsDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): ContestProblemStatisticsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestProblemStatisticsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['sumOfTotalSubmissions'] = this.sumOfTotalSubmissions;
    data['sumOfCorrectSubmissions'] = this.sumOfCorrectSubmissions;
    data['sumOfWrongSubmissions'] = this.sumOfWrongSubmissions;
    data['averageSuccessRatio'] = this.averageSuccessRatio;
    if (Array.isArray(this.problemStatistics)) {
      data['problemStatistics'] = [];
      for (let item of this.problemStatistics) data['problemStatistics'].push(item.toJSON());
    }
    return data;
  }
}

export interface IContestProblemStatisticsDto {
  sumOfTotalSubmissions?: number;
  sumOfCorrectSubmissions?: number;
  sumOfWrongSubmissions?: number;
  averageSuccessRatio?: number;
  problemStatistics?: ProblemStatisticsDto[] | undefined;
}

export class ContestSignupsStatisticsDto implements IContestSignupsStatisticsDto {
  signupsCount?: number;
  approvedSignupsCount?: number;
  codeSubmittedUsersCount?: number;
  codeSubmittedUsersConversionRate?: number;

  constructor(data?: IContestSignupsStatisticsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.signupsCount = _data['signupsCount'];
      this.approvedSignupsCount = _data['approvedSignupsCount'];
      this.codeSubmittedUsersCount = _data['codeSubmittedUsersCount'];
      this.codeSubmittedUsersConversionRate = _data['codeSubmittedUsersConversionRate'];
    }
  }

  static fromJS(data: any): ContestSignupsStatisticsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContestSignupsStatisticsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['signupsCount'] = this.signupsCount;
    data['approvedSignupsCount'] = this.approvedSignupsCount;
    data['codeSubmittedUsersCount'] = this.codeSubmittedUsersCount;
    data['codeSubmittedUsersConversionRate'] = this.codeSubmittedUsersConversionRate;
    return data;
  }
}

export interface IContestSignupsStatisticsDto {
  signupsCount?: number;
  approvedSignupsCount?: number;
  codeSubmittedUsersCount?: number;
  codeSubmittedUsersConversionRate?: number;
}

export class CreateOrganizationDto implements ICreateOrganizationDto {
  name?: string | undefined;

  constructor(data?: ICreateOrganizationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): CreateOrganizationDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateOrganizationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface ICreateOrganizationDto {
  name?: string | undefined;
}

export class CreateUpdateSourceDto implements ICreateUpdateSourceDto {
  name!: string;

  constructor(data?: ICreateUpdateSourceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): CreateUpdateSourceDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateUpdateSourceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface ICreateUpdateSourceDto {
  name: string;
}

export class CreateUpdateTagDto implements ICreateUpdateTagDto {
  name!: string;

  constructor(data?: ICreateUpdateTagDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): CreateUpdateTagDto {
    data = typeof data === 'object' ? data : {};
    let result = new CreateUpdateTagDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface ICreateUpdateTagDto {
  name: string;
}

export class EmailDomainCreateUpdateDto implements IEmailDomainCreateUpdateDto {
  name!: string;

  constructor(data?: IEmailDomainCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): EmailDomainCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new EmailDomainCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    return data;
  }
}

export interface IEmailDomainCreateUpdateDto {
  name: string;
}

export class EmailDomainDto implements IEmailDomainDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;

  constructor(data?: IEmailDomainDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): EmailDomainDto {
    data = typeof data === 'object' ? data : {};
    let result = new EmailDomainDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    return data;
  }
}

export interface IEmailDomainDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
}

export class EmailProviderCreateUpdateDto implements IEmailProviderCreateUpdateDto {
  host?: string | undefined;
  port?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
  domain?: string | undefined;
  enableSsl?: string | undefined;
  useDefaultCredentials?: string | undefined;
  defaultFromAddress?: string | undefined;
  defaultFromDisplayName?: string | undefined;
  whiteListDomains?: string[] | undefined;
  isDefault?: boolean;

  constructor(data?: IEmailProviderCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.host = _data['host'];
      this.port = _data['port'];
      this.userName = _data['userName'];
      this.password = _data['password'];
      this.domain = _data['domain'];
      this.enableSsl = _data['enableSsl'];
      this.useDefaultCredentials = _data['useDefaultCredentials'];
      this.defaultFromAddress = _data['defaultFromAddress'];
      this.defaultFromDisplayName = _data['defaultFromDisplayName'];
      if (Array.isArray(_data['whiteListDomains'])) {
        this.whiteListDomains = [] as any;
        for (let item of _data['whiteListDomains']) this.whiteListDomains!.push(item);
      }
      this.isDefault = _data['isDefault'];
    }
  }

  static fromJS(data: any): EmailProviderCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new EmailProviderCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['host'] = this.host;
    data['port'] = this.port;
    data['userName'] = this.userName;
    data['password'] = this.password;
    data['domain'] = this.domain;
    data['enableSsl'] = this.enableSsl;
    data['useDefaultCredentials'] = this.useDefaultCredentials;
    data['defaultFromAddress'] = this.defaultFromAddress;
    data['defaultFromDisplayName'] = this.defaultFromDisplayName;
    if (Array.isArray(this.whiteListDomains)) {
      data['whiteListDomains'] = [];
      for (let item of this.whiteListDomains) data['whiteListDomains'].push(item);
    }
    data['isDefault'] = this.isDefault;
    return data;
  }
}

export interface IEmailProviderCreateUpdateDto {
  host?: string | undefined;
  port?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
  domain?: string | undefined;
  enableSsl?: string | undefined;
  useDefaultCredentials?: string | undefined;
  defaultFromAddress?: string | undefined;
  defaultFromDisplayName?: string | undefined;
  whiteListDomains?: string[] | undefined;
  isDefault?: boolean;
}

export class EmailProviderDto implements IEmailProviderDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  host?: string | undefined;
  port?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
  domain?: string | undefined;
  enableSsl?: string | undefined;
  useDefaultCredentials?: string | undefined;
  defaultFromAddress?: string | undefined;
  defaultFromDisplayName?: string | undefined;
  whiteListDomains?: EmailDomainDto[] | undefined;
  isDefault?: boolean;

  constructor(data?: IEmailProviderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.host = _data['host'];
      this.port = _data['port'];
      this.userName = _data['userName'];
      this.password = _data['password'];
      this.domain = _data['domain'];
      this.enableSsl = _data['enableSsl'];
      this.useDefaultCredentials = _data['useDefaultCredentials'];
      this.defaultFromAddress = _data['defaultFromAddress'];
      this.defaultFromDisplayName = _data['defaultFromDisplayName'];
      if (Array.isArray(_data['whiteListDomains'])) {
        this.whiteListDomains = [] as any;
        for (let item of _data['whiteListDomains'])
          this.whiteListDomains!.push(EmailDomainDto.fromJS(item));
      }
      this.isDefault = _data['isDefault'];
    }
  }

  static fromJS(data: any): EmailProviderDto {
    data = typeof data === 'object' ? data : {};
    let result = new EmailProviderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['host'] = this.host;
    data['port'] = this.port;
    data['userName'] = this.userName;
    data['password'] = this.password;
    data['domain'] = this.domain;
    data['enableSsl'] = this.enableSsl;
    data['useDefaultCredentials'] = this.useDefaultCredentials;
    data['defaultFromAddress'] = this.defaultFromAddress;
    data['defaultFromDisplayName'] = this.defaultFromDisplayName;
    if (Array.isArray(this.whiteListDomains)) {
      data['whiteListDomains'] = [];
      for (let item of this.whiteListDomains) data['whiteListDomains'].push(item.toJSON());
    }
    data['isDefault'] = this.isDefault;
    return data;
  }
}

export interface IEmailProviderDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  host?: string | undefined;
  port?: string | undefined;
  userName?: string | undefined;
  password?: string | undefined;
  domain?: string | undefined;
  enableSsl?: string | undefined;
  useDefaultCredentials?: string | undefined;
  defaultFromAddress?: string | undefined;
  defaultFromDisplayName?: string | undefined;
  whiteListDomains?: EmailDomainDto[] | undefined;
  isDefault?: boolean;
}

export class FeaturedContestCreateUpdateDto implements IFeaturedContestCreateUpdateDto {
  contestId?: string;

  constructor(data?: IFeaturedContestCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contestId = _data['contestId'];
    }
  }

  static fromJS(data: any): FeaturedContestCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeaturedContestCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['contestId'] = this.contestId;
    return data;
  }
}

export interface IFeaturedContestCreateUpdateDto {
  contestId?: string;
}

export class FeaturedContestDto implements IFeaturedContestDto {
  id?: string;
  contestId?: string;
  slug?: string | undefined;
  name?: string | undefined;
  landingPageTitle?: string | undefined;
  problems?: FeaturedContestProblemDto[] | undefined;

  constructor(data?: IFeaturedContestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.contestId = _data['contestId'];
      this.slug = _data['slug'];
      this.name = _data['name'];
      this.landingPageTitle = _data['landingPageTitle'];
      if (Array.isArray(_data['problems'])) {
        this.problems = [] as any;
        for (let item of _data['problems'])
          this.problems!.push(FeaturedContestProblemDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FeaturedContestDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeaturedContestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['contestId'] = this.contestId;
    data['slug'] = this.slug;
    data['name'] = this.name;
    data['landingPageTitle'] = this.landingPageTitle;
    if (Array.isArray(this.problems)) {
      data['problems'] = [];
      for (let item of this.problems) data['problems'].push(item.toJSON());
    }
    return data;
  }
}

export interface IFeaturedContestDto {
  id?: string;
  contestId?: string;
  slug?: string | undefined;
  name?: string | undefined;
  landingPageTitle?: string | undefined;
  problems?: FeaturedContestProblemDto[] | undefined;
}

export class FeaturedContestProblemDto implements IFeaturedContestProblemDto {
  name?: string | undefined;
  totalSolved?: number;

  constructor(data?: IFeaturedContestProblemDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.totalSolved = _data['totalSolved'];
    }
  }

  static fromJS(data: any): FeaturedContestProblemDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeaturedContestProblemDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['totalSolved'] = this.totalSolved;
    return data;
  }
}

export interface IFeaturedContestProblemDto {
  name?: string | undefined;
  totalSolved?: number;
}

export class JudgerCreateUpdateDto implements IJudgerCreateUpdateDto {
  context?: Context;
  apiKey?: string | undefined;
  apiHost?: string | undefined;
  baseUrl?: string | undefined;

  constructor(data?: IJudgerCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.context = _data['context'];
      this.apiKey = _data['apiKey'];
      this.apiHost = _data['apiHost'];
      this.baseUrl = _data['baseUrl'];
    }
  }

  static fromJS(data: any): JudgerCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new JudgerCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['context'] = this.context;
    data['apiKey'] = this.apiKey;
    data['apiHost'] = this.apiHost;
    data['baseUrl'] = this.baseUrl;
    return data;
  }
}

export interface IJudgerCreateUpdateDto {
  context?: Context;
  apiKey?: string | undefined;
  apiHost?: string | undefined;
  baseUrl?: string | undefined;
}

export class JudgerDto implements IJudgerDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  context?: Context;
  apiKey?: string | undefined;
  apiHost?: string | undefined;
  baseUrl?: string | undefined;

  constructor(data?: IJudgerDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.context = _data['context'];
      this.apiKey = _data['apiKey'];
      this.apiHost = _data['apiHost'];
      this.baseUrl = _data['baseUrl'];
    }
  }

  static fromJS(data: any): JudgerDto {
    data = typeof data === 'object' ? data : {};
    let result = new JudgerDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['context'] = this.context;
    data['apiKey'] = this.apiKey;
    data['apiHost'] = this.apiHost;
    data['baseUrl'] = this.baseUrl;
    return data;
  }
}

export interface IJudgerDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  context?: Context;
  apiKey?: string | undefined;
  apiHost?: string | undefined;
  baseUrl?: string | undefined;
}

export class OrganizationDto implements IOrganizationDto {
  id?: string;
  name?: string | undefined;

  constructor(data?: IOrganizationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): OrganizationDto {
    data = typeof data === 'object' ? data : {};
    let result = new OrganizationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface IOrganizationDto {
  id?: string;
  name?: string | undefined;
}

export class PageCreateUpdateDto implements IPageCreateUpdateDto {
  name?: string | undefined;
  type?: PageType;
  content?: string | undefined;

  constructor(data?: IPageCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.type = _data['type'];
      this.content = _data['content'];
    }
  }

  static fromJS(data: any): PageCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['type'] = this.type;
    data['content'] = this.content;
    return data;
  }
}

export interface IPageCreateUpdateDto {
  name?: string | undefined;
  type?: PageType;
  content?: string | undefined;
}

export class PageDto implements IPageDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  type?: PageType;
  content?: string | undefined;

  constructor(data?: IPageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
      this.type = _data['type'];
      this.content = _data['content'];
    }
  }

  static fromJS(data: any): PageDto {
    data = typeof data === 'object' ? data : {};
    let result = new PageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    data['type'] = this.type;
    data['content'] = this.content;
    return data;
  }
}

export interface IPageDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  type?: PageType;
  content?: string | undefined;
}

export class PreviousContestDto implements IPreviousContestDto {
  name?: string | undefined;
  slug?: string | undefined;
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;

  constructor(data?: IPreviousContestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.slug = _data['slug'];
      this.landingPageTitle = _data['landingPageTitle'];
      this.coverImage = _data['coverImage'];
    }
  }

  static fromJS(data: any): PreviousContestDto {
    data = typeof data === 'object' ? data : {};
    let result = new PreviousContestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['slug'] = this.slug;
    data['landingPageTitle'] = this.landingPageTitle;
    data['coverImage'] = this.coverImage;
    return data;
  }
}

export interface IPreviousContestDto {
  name?: string | undefined;
  slug?: string | undefined;
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;
}

export class ProblemSetterDto implements IProblemSetterDto {
  userName?: string | undefined;
  image?: string | undefined;
  createdCount?: number;
  rank?: number;
  rankText?: string | undefined;

  constructor(data?: IProblemSetterDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName'];
      this.image = _data['image'];
      this.createdCount = _data['createdCount'];
      this.rank = _data['rank'];
      this.rankText = _data['rankText'];
    }
  }

  static fromJS(data: any): ProblemSetterDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSetterDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['image'] = this.image;
    data['createdCount'] = this.createdCount;
    data['rank'] = this.rank;
    data['rankText'] = this.rankText;
    return data;
  }
}

export interface IProblemSetterDto {
  userName?: string | undefined;
  image?: string | undefined;
  createdCount?: number;
  rank?: number;
  rankText?: string | undefined;
}

export class ProblemSolverDto implements IProblemSolverDto {
  userName?: string | undefined;
  image?: string | undefined;
  solvedCount?: number;
  rank?: number;
  rankText?: string | undefined;

  constructor(data?: IProblemSolverDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName'];
      this.image = _data['image'];
      this.solvedCount = _data['solvedCount'];
      this.rank = _data['rank'];
      this.rankText = _data['rankText'];
    }
  }

  static fromJS(data: any): ProblemSolverDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemSolverDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['image'] = this.image;
    data['solvedCount'] = this.solvedCount;
    data['rank'] = this.rank;
    data['rankText'] = this.rankText;
    return data;
  }
}

export interface IProblemSolverDto {
  userName?: string | undefined;
  image?: string | undefined;
  solvedCount?: number;
  rank?: number;
  rankText?: string | undefined;
}

export enum ProblemSolverFilter {
  Today = 'Today',
  AllTime = 'AllTime',
}

export class ProblemStatisticsDto implements IProblemStatisticsDto {
  problemId?: string;
  problemSlug?: string | undefined;
  totalSubmissions?: number;
  correctSubmissions?: number;
  wrongSubmissions?: number;
  successRatio?: number;

  constructor(data?: IProblemStatisticsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.problemId = _data['problemId'];
      this.problemSlug = _data['problemSlug'];
      this.totalSubmissions = _data['totalSubmissions'];
      this.correctSubmissions = _data['correctSubmissions'];
      this.wrongSubmissions = _data['wrongSubmissions'];
      this.successRatio = _data['successRatio'];
    }
  }

  static fromJS(data: any): ProblemStatisticsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProblemStatisticsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['problemId'] = this.problemId;
    data['problemSlug'] = this.problemSlug;
    data['totalSubmissions'] = this.totalSubmissions;
    data['correctSubmissions'] = this.correctSubmissions;
    data['wrongSubmissions'] = this.wrongSubmissions;
    data['successRatio'] = this.successRatio;
    return data;
  }
}

export interface IProblemStatisticsDto {
  problemId?: string;
  problemSlug?: string | undefined;
  totalSubmissions?: number;
  correctSubmissions?: number;
  wrongSubmissions?: number;
  successRatio?: number;
}

export class ProgrammingLanguageLookupDto implements IProgrammingLanguageLookupDto {
  id?: string;
  name?: string | undefined;
  shortName?: string | undefined;

  constructor(data?: IProgrammingLanguageLookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.shortName = _data['shortName'];
    }
  }

  static fromJS(data: any): ProgrammingLanguageLookupDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgrammingLanguageLookupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['shortName'] = this.shortName;
    return data;
  }
}

export interface IProgrammingLanguageLookupDto {
  id?: string;
  name?: string | undefined;
  shortName?: string | undefined;
}

export class SourceDto implements ISourceDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;

  constructor(data?: ISourceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): SourceDto {
    data = typeof data === 'object' ? data : {};
    let result = new SourceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    return data;
  }
}

export interface ISourceDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
}

export class TagDto implements ITagDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;

  constructor(data?: ITagDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): TagDto {
    data = typeof data === 'object' ? data : {};
    let result = new TagDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    return data;
  }
}

export interface ITagDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
}

export class TemplateCreateUpdateDto implements ITemplateCreateUpdateDto {
  name?: string | undefined;
  type?: TemplateType;
  content?: string | undefined;

  constructor(data?: ITemplateCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.type = _data['type'];
      this.content = _data['content'];
    }
  }

  static fromJS(data: any): TemplateCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['type'] = this.type;
    data['content'] = this.content;
    return data;
  }
}

export interface ITemplateCreateUpdateDto {
  name?: string | undefined;
  type?: TemplateType;
  content?: string | undefined;
}

export class TemplateDto implements ITemplateDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  type?: TemplateType;
  content?: string | undefined;

  constructor(data?: ITemplateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
      this.type = _data['type'];
      this.content = _data['content'];
    }
  }

  static fromJS(data: any): TemplateDto {
    data = typeof data === 'object' ? data : {};
    let result = new TemplateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    data['type'] = this.type;
    data['content'] = this.content;
    return data;
  }
}

export interface ITemplateDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  type?: TemplateType;
  content?: string | undefined;
}

export class UpcomingContestDto implements IUpcomingContestDto {
  name?: string | undefined;
  slug?: string | undefined;
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;
  startDate?: Date;
  currentTime?: Date;
  endDate?: Date;

  constructor(data?: IUpcomingContestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.slug = _data['slug'];
      this.landingPageTitle = _data['landingPageTitle'];
      this.coverImage = _data['coverImage'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.currentTime = _data['currentTime']
        ? new Date(_data['currentTime'].toString())
        : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): UpcomingContestDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpcomingContestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['slug'] = this.slug;
    data['landingPageTitle'] = this.landingPageTitle;
    data['coverImage'] = this.coverImage;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['currentTime'] = this.currentTime ? this.currentTime.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IUpcomingContestDto {
  name?: string | undefined;
  slug?: string | undefined;
  landingPageTitle?: string | undefined;
  coverImage?: string | undefined;
  startDate?: Date;
  currentTime?: Date;
  endDate?: Date;
}

export enum OrganizationType {
  StudentClub = 'StudentClub',
  University = 'University',
  Company = 'Company',
  NonGovernmentalOrganization = 'NonGovernmentalOrganization',
}

export enum PageType {
  RulesAndRegulations = 'RulesAndRegulations',
  DPP = 'DPP',
  About = 'About',
  Contact = 'Contact',
  PrivacyPolicy = 'PrivacyPolicy',
  TermsOfConditions = 'TermsOfConditions',
  Legal = 'Legal',
  Help = 'Help',
  Faq = 'Faq',
}

export class ProgrammingLanguageCreateUpdateDto implements IProgrammingLanguageCreateUpdateDto {
  name!: string;
  shortName?: string | undefined;
  defaultTimeLimit!: number;
  defaultMemoryLimit!: number;
  judgerMappingId?: number | undefined;
  isDefault?: boolean;

  constructor(data?: IProgrammingLanguageCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.shortName = _data['shortName'];
      this.defaultTimeLimit = _data['defaultTimeLimit'];
      this.defaultMemoryLimit = _data['defaultMemoryLimit'];
      this.judgerMappingId = _data['judgerMappingId'];
      this.isDefault = _data['isDefault'];
    }
  }

  static fromJS(data: any): ProgrammingLanguageCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgrammingLanguageCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['shortName'] = this.shortName;
    data['defaultTimeLimit'] = this.defaultTimeLimit;
    data['defaultMemoryLimit'] = this.defaultMemoryLimit;
    data['judgerMappingId'] = this.judgerMappingId;
    data['isDefault'] = this.isDefault;
    return data;
  }
}

export interface IProgrammingLanguageCreateUpdateDto {
  name: string;
  shortName?: string | undefined;
  defaultTimeLimit: number;
  defaultMemoryLimit: number;
  judgerMappingId?: number | undefined;
  isDefault?: boolean;
}

export class ProgrammingLanguageDto implements IProgrammingLanguageDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  shortName?: string | undefined;
  defaultTimeLimit?: number;
  defaultMemoryLimit?: number;
  judgerMappingId?: number | undefined;
  isDefault?: boolean;

  constructor(data?: IProgrammingLanguageDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
      this.shortName = _data['shortName'];
      this.defaultTimeLimit = _data['defaultTimeLimit'];
      this.defaultMemoryLimit = _data['defaultMemoryLimit'];
      this.judgerMappingId = _data['judgerMappingId'];
      this.isDefault = _data['isDefault'];
    }
  }

  static fromJS(data: any): ProgrammingLanguageDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProgrammingLanguageDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    data['shortName'] = this.shortName;
    data['defaultTimeLimit'] = this.defaultTimeLimit;
    data['defaultMemoryLimit'] = this.defaultMemoryLimit;
    data['judgerMappingId'] = this.judgerMappingId;
    data['isDefault'] = this.isDefault;
    return data;
  }
}

export interface IProgrammingLanguageDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  shortName?: string | undefined;
  defaultTimeLimit?: number;
  defaultMemoryLimit?: number;
  judgerMappingId?: number | undefined;
  isDefault?: boolean;
}

export enum SchoolType {
  None = 'None',
  HighSchool = 'HighSchool',
  University = 'University',
}

export class SocialAccountCreateUpdateDto implements ISocialAccountCreateUpdateDto {
  name?: string | undefined;
  icon?: string | undefined;
  baseUrl?: string | undefined;
  regexValidation?: string | undefined;

  constructor(data?: ISocialAccountCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.icon = _data['icon'];
      this.baseUrl = _data['baseUrl'];
      this.regexValidation = _data['regexValidation'];
    }
  }

  static fromJS(data: any): SocialAccountCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new SocialAccountCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['icon'] = this.icon;
    data['baseUrl'] = this.baseUrl;
    data['regexValidation'] = this.regexValidation;
    return data;
  }
}

export interface ISocialAccountCreateUpdateDto {
  name?: string | undefined;
  icon?: string | undefined;
  baseUrl?: string | undefined;
  regexValidation?: string | undefined;
}

export class SocialAccountDto implements ISocialAccountDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  icon?: string | undefined;
  baseUrl?: string | undefined;
  regexValidation?: string | undefined;

  constructor(data?: ISocialAccountDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
      this.icon = _data['icon'];
      this.baseUrl = _data['baseUrl'];
      this.regexValidation = _data['regexValidation'];
    }
  }

  static fromJS(data: any): SocialAccountDto {
    data = typeof data === 'object' ? data : {};
    let result = new SocialAccountDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    data['icon'] = this.icon;
    data['baseUrl'] = this.baseUrl;
    data['regexValidation'] = this.regexValidation;
    return data;
  }
}

export interface ISocialAccountDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  icon?: string | undefined;
  baseUrl?: string | undefined;
  regexValidation?: string | undefined;
}

export enum TemplateType {
  Compete = 'Compete',
  Confirmation = 'Confirmation',
  ResetPassword = 'ResetPassword',
  ContestTeamRegister = 'ContestTeamRegister',
  ContestManageAccess = 'ContestManageAccess',
  ContestAdminApproval = 'ContestAdminApproval',
  ContestReminder = 'ContestReminder',
  ContestUserRegister = 'ContestUserRegister',
  ContestAnnouncementNotification = 'ContestAnnouncementNotification',
}

export class TeamCreateUpdateRequestDto implements ITeamCreateUpdateRequestDto {
  name?: string | undefined;
  userIds?: string[] | undefined;

  constructor(data?: ITeamCreateUpdateRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      if (Array.isArray(_data['userIds'])) {
        this.userIds = [] as any;
        for (let item of _data['userIds']) this.userIds!.push(item);
      }
    }
  }

  static fromJS(data: any): TeamCreateUpdateRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamCreateUpdateRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    if (Array.isArray(this.userIds)) {
      data['userIds'] = [];
      for (let item of this.userIds) data['userIds'].push(item);
    }
    return data;
  }
}

export interface ITeamCreateUpdateRequestDto {
  name?: string | undefined;
  userIds?: string[] | undefined;
}

export class TeamDto implements ITeamDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  leadUser?: AppUserPreviewProfileDto;
  name?: string | undefined;
  currentUserId?: string;
  memberCount?: number;
  members?: TeamMemberDetailedDto[] | undefined;

  constructor(data?: ITeamDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.leadUser = _data['leadUser']
        ? AppUserPreviewProfileDto.fromJS(_data['leadUser'])
        : <any>undefined;
      this.name = _data['name'];
      this.currentUserId = _data['currentUserId'];
      this.memberCount = _data['memberCount'];
      if (Array.isArray(_data['members'])) {
        this.members = [] as any;
        for (let item of _data['members']) this.members!.push(TeamMemberDetailedDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TeamDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['leadUser'] = this.leadUser ? this.leadUser.toJSON() : <any>undefined;
    data['name'] = this.name;
    data['currentUserId'] = this.currentUserId;
    data['memberCount'] = this.memberCount;
    if (Array.isArray(this.members)) {
      data['members'] = [];
      for (let item of this.members) data['members'].push(item.toJSON());
    }
    return data;
  }
}

export interface ITeamDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  leadUser?: AppUserPreviewProfileDto;
  name?: string | undefined;
  currentUserId?: string;
  memberCount?: number;
  members?: TeamMemberDetailedDto[] | undefined;
}

export class TeamMemberDetailedDto implements ITeamMemberDetailedDto {
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  userId?: string;
  image?: string | undefined;
  joinedDate?: Date;

  constructor(data?: ITeamMemberDetailedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.userId = _data['userId'];
      this.image = _data['image'];
      this.joinedDate = _data['joinedDate']
        ? new Date(_data['joinedDate'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): TeamMemberDetailedDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamMemberDetailedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['userId'] = this.userId;
    data['image'] = this.image;
    data['joinedDate'] = this.joinedDate ? this.joinedDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface ITeamMemberDetailedDto {
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  userId?: string;
  image?: string | undefined;
  joinedDate?: Date;
}

export class TeamMemberDto implements ITeamMemberDto {
  id?: string;
  teamId?: string;
  userIds?: string[] | undefined;

  constructor(data?: ITeamMemberDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.teamId = _data['teamId'];
      if (Array.isArray(_data['userIds'])) {
        this.userIds = [] as any;
        for (let item of _data['userIds']) this.userIds!.push(item);
      }
    }
  }

  static fromJS(data: any): TeamMemberDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamMemberDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['teamId'] = this.teamId;
    if (Array.isArray(this.userIds)) {
      data['userIds'] = [];
      for (let item of this.userIds) data['userIds'].push(item);
    }
    return data;
  }
}

export interface ITeamMemberDto {
  id?: string;
  teamId?: string;
  userIds?: string[] | undefined;
}

export class TeamMemberPreviewDto implements ITeamMemberPreviewDto {
  id?: string;
  fullName?: string | undefined;
  userName?: string | undefined;
  email?: string | undefined;

  constructor(data?: ITeamMemberPreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.fullName = _data['fullName'];
      this.userName = _data['userName'];
      this.email = _data['email'];
    }
  }

  static fromJS(data: any): TeamMemberPreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamMemberPreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['fullName'] = this.fullName;
    data['userName'] = this.userName;
    data['email'] = this.email;
    return data;
  }
}

export interface ITeamMemberPreviewDto {
  id?: string;
  fullName?: string | undefined;
  userName?: string | undefined;
  email?: string | undefined;
}

export class TeamMemberRequestDto implements ITeamMemberRequestDto {
  teamId?: string;
  userIds?: string[] | undefined;

  constructor(data?: ITeamMemberRequestDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.teamId = _data['teamId'];
      if (Array.isArray(_data['userIds'])) {
        this.userIds = [] as any;
        for (let item of _data['userIds']) this.userIds!.push(item);
      }
    }
  }

  static fromJS(data: any): TeamMemberRequestDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamMemberRequestDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['teamId'] = this.teamId;
    if (Array.isArray(this.userIds)) {
      data['userIds'] = [];
      for (let item of this.userIds) data['userIds'].push(item);
    }
    return data;
  }
}

export interface ITeamMemberRequestDto {
  teamId?: string;
  userIds?: string[] | undefined;
}

export class TeamPreviewDto implements ITeamPreviewDto {
  id?: string;
  name?: string | undefined;
  leadUser?: TeamMemberPreviewDto;
  members?: TeamMemberPreviewDto[] | undefined;

  constructor(data?: ITeamPreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.leadUser = _data['leadUser']
        ? TeamMemberPreviewDto.fromJS(_data['leadUser'])
        : <any>undefined;
      if (Array.isArray(_data['members'])) {
        this.members = [] as any;
        for (let item of _data['members']) this.members!.push(TeamMemberPreviewDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TeamPreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new TeamPreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['leadUser'] = this.leadUser ? this.leadUser.toJSON() : <any>undefined;
    if (Array.isArray(this.members)) {
      data['members'] = [];
      for (let item of this.members) data['members'].push(item.toJSON());
    }
    return data;
  }
}

export interface ITeamPreviewDto {
  id?: string;
  name?: string | undefined;
  leadUser?: TeamMemberPreviewDto;
  members?: TeamMemberPreviewDto[] | undefined;
}

export class AppUserEducationCreateUpdateDto implements IAppUserEducationCreateUpdateDto {
  schoolId?: string;
  department?: string | undefined;
  degree?: AppUserEducationDegree;
  startDate?: Date;
  endDate?: Date | undefined;

  constructor(data?: IAppUserEducationCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.schoolId = _data['schoolId'];
      this.department = _data['department'];
      this.degree = _data['degree'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): AppUserEducationCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserEducationCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['schoolId'] = this.schoolId;
    data['department'] = this.department;
    data['degree'] = this.degree;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IAppUserEducationCreateUpdateDto {
  schoolId?: string;
  department?: string | undefined;
  degree?: AppUserEducationDegree;
  startDate?: Date;
  endDate?: Date | undefined;
}

export enum AppUserEducationDegree {
  Associate = 'Associate',
  Bachelor = 'Bachelor',
  Master = 'Master',
  Doctoral = 'Doctoral',
  HighSchool = 'HighSchool',
}

export class AppUserEducationDto implements IAppUserEducationDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  schoolId?: string;
  department?: string | undefined;
  graduationYear?: number;
  schoolName?: string | undefined;
  degree?: AppUserEducationDegree;
  startDate?: Date;
  endDate?: Date | undefined;

  constructor(data?: IAppUserEducationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.schoolId = _data['schoolId'];
      this.department = _data['department'];
      this.graduationYear = _data['graduationYear'];
      this.schoolName = _data['schoolName'];
      this.degree = _data['degree'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): AppUserEducationDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserEducationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['schoolId'] = this.schoolId;
    data['department'] = this.department;
    data['graduationYear'] = this.graduationYear;
    data['schoolName'] = this.schoolName;
    data['degree'] = this.degree;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IAppUserEducationDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  schoolId?: string;
  department?: string | undefined;
  graduationYear?: number;
  schoolName?: string | undefined;
  degree?: AppUserEducationDegree;
  startDate?: Date;
  endDate?: Date | undefined;
}

export class AppUserPreviewDto implements IAppUserPreviewDto {
  profile?: AppUserPreviewProfileDto;
  flagUrl?: string | undefined;
  education?: AppUserEducationDto[] | undefined;
  workExperience?: AppUserWorkExperienceDto[] | undefined;

  constructor(data?: IAppUserPreviewDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.profile = _data['profile']
        ? AppUserPreviewProfileDto.fromJS(_data['profile'])
        : <any>undefined;
      this.flagUrl = _data['flagUrl'];
      if (Array.isArray(_data['education'])) {
        this.education = [] as any;
        for (let item of _data['education']) this.education!.push(AppUserEducationDto.fromJS(item));
      }
      if (Array.isArray(_data['workExperience'])) {
        this.workExperience = [] as any;
        for (let item of _data['workExperience'])
          this.workExperience!.push(AppUserWorkExperienceDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppUserPreviewDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserPreviewDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['profile'] = this.profile ? this.profile.toJSON() : <any>undefined;
    data['flagUrl'] = this.flagUrl;
    if (Array.isArray(this.education)) {
      data['education'] = [];
      for (let item of this.education) data['education'].push(item.toJSON());
    }
    if (Array.isArray(this.workExperience)) {
      data['workExperience'] = [];
      for (let item of this.workExperience) data['workExperience'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppUserPreviewDto {
  profile?: AppUserPreviewProfileDto;
  flagUrl?: string | undefined;
  education?: AppUserEducationDto[] | undefined;
  workExperience?: AppUserWorkExperienceDto[] | undefined;
}

export class AppUserPreviewProfileDto implements IAppUserPreviewProfileDto {
  userId?: string | undefined;
  userName?: string | undefined;
  fullName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  image?: string | undefined;
  location?: string | undefined;
  about?: string | undefined;
  gender?: Gender;
  city?: CityDto;
  isOnline?: boolean;
  creationTime?: Date;
  lastOnlineDate?: Date | undefined;
  socialAccounts?: AppUserSocialAccountDto[] | undefined;
  publicScore?: string | undefined;

  constructor(data?: IAppUserPreviewProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.userName = _data['userName'];
      this.fullName = _data['fullName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.image = _data['image'];
      this.location = _data['location'];
      this.about = _data['about'];
      this.gender = _data['gender'];
      this.city = _data['city'] ? CityDto.fromJS(_data['city']) : <any>undefined;
      this.isOnline = _data['isOnline'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.lastOnlineDate = _data['lastOnlineDate']
        ? new Date(_data['lastOnlineDate'].toString())
        : <any>undefined;
      this.publicScore = _data['publicScore'];
      if (Array.isArray(_data['socialAccounts'])) {
        this.socialAccounts = [] as any;
        for (let item of _data['socialAccounts'])
          this.socialAccounts!.push(AppUserSocialAccountDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppUserPreviewProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserPreviewProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['userName'] = this.userName;
    data['fullName'] = this.fullName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['image'] = this.image;
    data['location'] = this.location;
    data['about'] = this.about;
    data['gender'] = this.gender;
    data['city'] = this.city ? this.city.toJSON() : <any>undefined;
    data['isOnline'] = this.isOnline;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['lastOnlineDate'] = this.lastOnlineDate
      ? this.lastOnlineDate.toISOString()
      : <any>undefined;
    data['publicScore'] = this.publicScore;
    if (Array.isArray(this.socialAccounts)) {
      data['socialAccounts'] = [];
      for (let item of this.socialAccounts) data['socialAccounts'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppUserPreviewProfileDto {
  userId?: string | undefined;
  userName?: string | undefined;
  fullName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  image?: string | undefined;
  location?: string | undefined;
  about?: string | undefined;
  gender?: Gender;
  city?: CityDto;
  isOnline?: boolean;
  creationTime?: Date;
  lastOnlineDate?: Date | undefined;
  socialAccounts?: AppUserSocialAccountDto[] | undefined;
  publicScore?: string | undefined;
}

export class AppUserPrivacySettingDto implements IAppUserPrivacySettingDto {
  id?: string;
  userId?: string;
  entityType?: PrivacyEntityType;
  scope?: PrivacyEntityScope;
  value?: PrivacyEntityValue;
  entityValue?: boolean;

  constructor(data?: IAppUserPrivacySettingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.entityType = _data['entityType'];
      this.scope = _data['scope'];
      this.value = _data['value'];
      this.entityValue = _data['entityValue'];
    }
  }

  static fromJS(data: any): AppUserPrivacySettingDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserPrivacySettingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['entityType'] = this.entityType;
    data['scope'] = this.scope;
    data['value'] = this.value;
    data['entityValue'] = this.entityValue;
    return data;
  }
}

export interface IAppUserPrivacySettingDto {
  id?: string;
  userId?: string;
  entityType?: PrivacyEntityType;
  scope?: PrivacyEntityScope;
  value?: PrivacyEntityValue;
  entityValue?: boolean;
}

export class AppUserPrivacySettingUpdateDto implements IAppUserPrivacySettingUpdateDto {
  id?: string;
  userId?: string;
  entityType?: PrivacyEntityType;
  scope?: PrivacyEntityScope;
  value?: PrivacyEntityValue;
  entityValue?: boolean;

  constructor(data?: IAppUserPrivacySettingUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.entityType = _data['entityType'];
      this.scope = _data['scope'];
      this.value = _data['value'];
      this.entityValue = _data['entityValue'];
    }
  }

  static fromJS(data: any): AppUserPrivacySettingUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserPrivacySettingUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['entityType'] = this.entityType;
    data['scope'] = this.scope;
    data['value'] = this.value;
    data['entityValue'] = this.entityValue;
    return data;
  }
}

export interface IAppUserPrivacySettingUpdateDto {
  id?: string;
  userId?: string;
  entityType?: PrivacyEntityType;
  scope?: PrivacyEntityScope;
  value?: PrivacyEntityValue;
  entityValue?: boolean;
}

export class AppUserNotificationSettingDto implements IAppUserNotificationSettingDto {
  scope?: NotificationSettingScope;
  channel?: NotificationChannel;
  isEnabled?: boolean;

  constructor(data?: IAppUserNotificationSettingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scope = _data['scope'];
      this.channel = _data['channel'];
      this.isEnabled = _data['isEnabled'];
    }
  }

  static fromJS(data: any): AppUserNotificationSettingDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserNotificationSettingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['scope'] = this.scope;
    data['channel'] = this.channel;
    data['isEnabled'] = this.isEnabled;
    return data;
  }
}

export interface IAppUserNotificationSettingDto {
  scope?: NotificationSettingScope;
  channel?: NotificationChannel;
  isEnabled?: boolean;
}

export class AppUserNotificationSettingUpdateDto implements IAppUserNotificationSettingUpdateDto {
  scope?: NotificationSettingScope;
  channel?: NotificationChannel;
  isEnabled?: boolean;

  constructor(data?: IAppUserNotificationSettingUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.scope = _data['scope'];
      this.channel = _data['channel'];
      this.isEnabled = _data['isEnabled'];
    }
  }

  static fromJS(data: any): AppUserNotificationSettingUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserNotificationSettingUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['scope'] = this.scope;
    data['channel'] = this.channel;
    data['isEnabled'] = this.isEnabled;
    return data;
  }
}

export interface IAppUserNotificationSettingUpdateDto {
  scope?: NotificationSettingScope;
  channel?: NotificationChannel;
  isEnabled?: boolean;
}

export class AppUserProfileCreateUpdateDto implements IAppUserProfileCreateUpdateDto {
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  image?: string | undefined;
  location?: string | undefined;
  about?: string | undefined;
  tshirtSize?: TshirtSize;
  gender?: Gender;
  birthDate?: Date;
  preferredProgrammingLanguageId?: string | undefined;
  cityId?: string | undefined;
  socialAccounts?: AppUserSocialAccountsCreateUpdateDto[] | undefined;

  constructor(data?: IAppUserProfileCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.image = _data['image'];
      this.location = _data['location'];
      this.about = _data['about'];
      this.tshirtSize = _data['tshirtSize'];
      this.gender = _data['gender'];
      this.birthDate = _data['birthDate']
        ? new Date(_data['birthDate'].toString())
        : <any>undefined;
      this.preferredProgrammingLanguageId = _data['preferredProgrammingLanguageId'];
      this.cityId = _data['cityId'];
      if (Array.isArray(_data['socialAccounts'])) {
        this.socialAccounts = [] as any;
        for (let item of _data['socialAccounts'])
          this.socialAccounts!.push(AppUserSocialAccountsCreateUpdateDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppUserProfileCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserProfileCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['image'] = this.image;
    data['location'] = this.location;
    data['about'] = this.about;
    data['tshirtSize'] = this.tshirtSize;
    data['gender'] = this.gender;
    data['birthDate'] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
    data['preferredProgrammingLanguageId'] = this.preferredProgrammingLanguageId;
    data['cityId'] = this.cityId;
    if (Array.isArray(this.socialAccounts)) {
      data['socialAccounts'] = [];
      for (let item of this.socialAccounts) data['socialAccounts'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppUserProfileCreateUpdateDto {
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  image?: string | undefined;
  location?: string | undefined;
  about?: string | undefined;
  tshirtSize?: TshirtSize;
  gender?: Gender;
  birthDate?: Date;
  preferredProgrammingLanguageId?: string | undefined;
  cityId?: string | undefined;
  socialAccounts?: AppUserSocialAccountsCreateUpdateDto[] | undefined;
}

export class AppUserProfileDto implements IAppUserProfileDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  fullName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  image?: string | undefined;
  location?: string | undefined;
  about?: string | undefined;
  tshirtSize?: TshirtSize;
  gender?: Gender;
  birthDate?: Date;
  preferredProgrammingLanguageId?: string | undefined;
  preferredProgrammingLanguage?: ProgrammingLanguageDto;
  cityId?: string | undefined;
  city?: CityDto;
  userName?: string | undefined;
  isOnline?: boolean;
  lastOnlineDate?: Date | undefined;
  socialAccounts?: AppUserSocialAccountDto[] | undefined;

  constructor(data?: IAppUserProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.isDeleted = _data['isDeleted'];
      this.deleterId = _data['deleterId'];
      this.deletionTime = _data['deletionTime']
        ? new Date(_data['deletionTime'].toString())
        : <any>undefined;
      this.fullName = _data['fullName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.image = _data['image'];
      this.location = _data['location'];
      this.about = _data['about'];
      this.tshirtSize = _data['tshirtSize'];
      this.gender = _data['gender'];
      this.birthDate = _data['birthDate']
        ? new Date(_data['birthDate'].toString())
        : <any>undefined;
      this.preferredProgrammingLanguageId = _data['preferredProgrammingLanguageId'];
      this.preferredProgrammingLanguage = _data['preferredProgrammingLanguage']
        ? ProgrammingLanguageDto.fromJS(_data['preferredProgrammingLanguage'])
        : <any>undefined;
      this.cityId = _data['cityId'];
      this.city = _data['city'] ? CityDto.fromJS(_data['city']) : <any>undefined;
      this.userName = _data['userName'];
      this.isOnline = _data['isOnline'];
      this.lastOnlineDate = _data['lastOnlineDate']
        ? new Date(_data['lastOnlineDate'].toString())
        : <any>undefined;
      if (Array.isArray(_data['socialAccounts'])) {
        this.socialAccounts = [] as any;
        for (let item of _data['socialAccounts'])
          this.socialAccounts!.push(AppUserSocialAccountDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): AppUserProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['isDeleted'] = this.isDeleted;
    data['deleterId'] = this.deleterId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['fullName'] = this.fullName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['image'] = this.image;
    data['location'] = this.location;
    data['about'] = this.about;
    data['tshirtSize'] = this.tshirtSize;
    data['gender'] = this.gender;
    data['birthDate'] = this.birthDate ? this.birthDate.toISOString() : <any>undefined;
    data['preferredProgrammingLanguageId'] = this.preferredProgrammingLanguageId;
    data['preferredProgrammingLanguage'] = this.preferredProgrammingLanguage
      ? this.preferredProgrammingLanguage.toJSON()
      : <any>undefined;
    data['cityId'] = this.cityId;
    data['city'] = this.city ? this.city.toJSON() : <any>undefined;
    data['userName'] = this.userName;
    data['isOnline'] = this.isOnline;
    data['lastOnlineDate'] = this.lastOnlineDate
      ? this.lastOnlineDate.toISOString()
      : <any>undefined;
    if (Array.isArray(this.socialAccounts)) {
      data['socialAccounts'] = [];
      for (let item of this.socialAccounts) data['socialAccounts'].push(item.toJSON());
    }
    return data;
  }
}

export interface IAppUserProfileDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  fullName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  image?: string | undefined;
  location?: string | undefined;
  about?: string | undefined;
  tshirtSize?: TshirtSize;
  gender?: Gender;
  birthDate?: Date;
  preferredProgrammingLanguageId?: string | undefined;
  preferredProgrammingLanguage?: ProgrammingLanguageDto;
  cityId?: string | undefined;
  city?: CityDto;
  userName?: string | undefined;
  isOnline?: boolean;
  lastOnlineDate?: Date | undefined;
  socialAccounts?: AppUserSocialAccountDto[] | undefined;
}

export class AppUserProfileLastPasswordChangeDateDto
  implements IAppUserProfileLastPasswordChangeDateDto
{
  lastPasswordChangeDate?: Date | undefined;

  constructor(data?: IAppUserProfileLastPasswordChangeDateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.lastPasswordChangeDate = _data['lastPasswordChangeDate']
        ? new Date(_data['lastPasswordChangeDate'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): AppUserProfileLastPasswordChangeDateDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserProfileLastPasswordChangeDateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['lastPasswordChangeDate'] = this.lastPasswordChangeDate
      ? this.lastPasswordChangeDate.toISOString()
      : <any>undefined;
    return data;
  }
}

export interface IAppUserProfileLastPasswordChangeDateDto {
  lastPasswordChangeDate?: Date | undefined;
}

export class AppUserSocialAccountDto implements IAppUserSocialAccountDto {
  id?: string;
  userId?: string;
  socialAccountId?: string;
  socialMediaName?: string | undefined;
  regexValidation?: string | undefined;
  baseUrl?: string | undefined;
  icon?: string | undefined;
  uri?: string | undefined;

  constructor(data?: IAppUserSocialAccountDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.socialAccountId = _data['socialAccountId'];
      this.socialMediaName = _data['socialMediaName'];
      this.regexValidation = _data['regexValidation'];
      this.baseUrl = _data['baseUrl'];
      this.icon = _data['icon'];
      this.uri = _data['uri'];
    }
  }

  static fromJS(data: any): AppUserSocialAccountDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserSocialAccountDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['socialAccountId'] = this.socialAccountId;
    data['socialMediaName'] = this.socialMediaName;
    data['regexValidation'] = this.regexValidation;
    data['baseUrl'] = this.baseUrl;
    data['icon'] = this.icon;
    data['uri'] = this.uri;
    return data;
  }
}

export interface IAppUserSocialAccountDto {
  id?: string;
  userId?: string;
  socialAccountId?: string;
  socialMediaName?: string | undefined;
  regexValidation?: string | undefined;
  baseUrl?: string | undefined;
  icon?: string | undefined;
  uri?: string | undefined;
}

export class AppUserSocialAccountsCreateUpdateDto implements IAppUserSocialAccountsCreateUpdateDto {
  id?: string | undefined;
  userId?: string;
  socialAccountId?: string;
  socialMediaName?: string | undefined;
  regexValidation?: string | undefined;
  baseUrl?: string | undefined;
  icon?: string | undefined;
  uri?: string | undefined;

  constructor(data?: IAppUserSocialAccountsCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userId = _data['userId'];
      this.socialAccountId = _data['socialAccountId'];
      this.socialMediaName = _data['socialMediaName'];
      this.regexValidation = _data['regexValidation'];
      this.baseUrl = _data['baseUrl'];
      this.icon = _data['icon'];
      this.uri = _data['uri'];
    }
  }

  static fromJS(data: any): AppUserSocialAccountsCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserSocialAccountsCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userId'] = this.userId;
    data['socialAccountId'] = this.socialAccountId;
    data['socialMediaName'] = this.socialMediaName;
    data['regexValidation'] = this.regexValidation;
    data['baseUrl'] = this.baseUrl;
    data['icon'] = this.icon;
    data['uri'] = this.uri;
    return data;
  }
}

export interface IAppUserSocialAccountsCreateUpdateDto {
  id?: string | undefined;
  userId?: string;
  socialAccountId?: string;
  socialMediaName?: string | undefined;
  regexValidation?: string | undefined;
  baseUrl?: string | undefined;
  icon?: string | undefined;
  uri?: string | undefined;
}

export class AppUserWorkExperienceCreateUpdateDto implements IAppUserWorkExperienceCreateUpdateDto {
  companyName!: string;
  positionTitle?: string | undefined;
  startDate!: Date;
  endDate?: Date | undefined;

  constructor(data?: IAppUserWorkExperienceCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.companyName = _data['companyName'];
      this.positionTitle = _data['positionTitle'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): AppUserWorkExperienceCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserWorkExperienceCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['companyName'] = this.companyName;
    data['positionTitle'] = this.positionTitle;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IAppUserWorkExperienceCreateUpdateDto {
  companyName: string;
  positionTitle?: string | undefined;
  startDate: Date;
  endDate?: Date | undefined;
}

export class AppUserWorkExperienceDto implements IAppUserWorkExperienceDto {
  id?: string;
  companyName?: string | undefined;
  positionTitle?: string | undefined;
  startDate?: Date;
  endDate?: Date | undefined;

  constructor(data?: IAppUserWorkExperienceDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.companyName = _data['companyName'];
      this.positionTitle = _data['positionTitle'];
      this.startDate = _data['startDate']
        ? new Date(_data['startDate'].toString())
        : <any>undefined;
      this.endDate = _data['endDate'] ? new Date(_data['endDate'].toString()) : <any>undefined;
    }
  }

  static fromJS(data: any): AppUserWorkExperienceDto {
    data = typeof data === 'object' ? data : {};
    let result = new AppUserWorkExperienceDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['companyName'] = this.companyName;
    data['positionTitle'] = this.positionTitle;
    data['startDate'] = this.startDate ? this.startDate.toISOString() : <any>undefined;
    data['endDate'] = this.endDate ? this.endDate.toISOString() : <any>undefined;
    return data;
  }
}

export interface IAppUserWorkExperienceDto {
  id?: string;
  companyName?: string | undefined;
  positionTitle?: string | undefined;
  startDate?: Date;
  endDate?: Date | undefined;
}

export class CanUserChangeUserNameDto implements ICanUserChangeUserNameDto {
  changable?: boolean;
  changeLeft?: number;
  untilWhen?: Date | undefined;

  constructor(data?: ICanUserChangeUserNameDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.changable = _data['changable'];
      this.changeLeft = _data['changeLeft'];
      this.untilWhen = _data['untilWhen']
        ? new Date(_data['untilWhen'].toString())
        : <any>undefined;
    }
  }

  static fromJS(data: any): CanUserChangeUserNameDto {
    data = typeof data === 'object' ? data : {};
    let result = new CanUserChangeUserNameDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['changable'] = this.changable;
    data['changeLeft'] = this.changeLeft;
    data['untilWhen'] = this.untilWhen ? this.untilWhen.toISOString() : <any>undefined;
    return data;
  }
}

export interface ICanUserChangeUserNameDto {
  changable?: boolean;
  changeLeft?: number;
  untilWhen?: Date | undefined;
}

export class ContactUsDto implements IContactUsDto {
  name?: string | undefined;
  email?: string | undefined;
  subject?: string | undefined;
  message?: string | undefined;
  captchaResponseCode?: string | undefined;

  constructor(data?: IContactUsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.email = _data['email'];
      this.subject = _data['subject'];
      this.message = _data['message'];
      this.captchaResponseCode = _data['captchaResponseCode'];
    }
  }

  static fromJS(data: any): ContactUsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ContactUsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['email'] = this.email;
    data['subject'] = this.subject;
    data['message'] = this.message;
    data['captchaResponseCode'] = this.captchaResponseCode;
    return data;
  }
}

export interface IContactUsDto {
  name?: string | undefined;
  email?: string | undefined;
  subject?: string | undefined;
  message?: string | undefined;
  captchaResponseCode?: string | undefined;
}

export enum Gender {
  Undefined = 'Undefined',
  Male = 'Male',
  Female = 'Female',
}

export enum GetStartedProblemStatus {
  Skipped = 'Skipped',
  Solved = 'Solved',
}

export class GetStartedProblemStatusResponseDto implements IGetStartedProblemStatusResponseDto {
  getStartedProblemStatus?: GetStartedProblemStatus;

  constructor(data?: IGetStartedProblemStatusResponseDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.getStartedProblemStatus = _data['getStartedProblemStatus'];
    }
  }

  static fromJS(data: any): GetStartedProblemStatusResponseDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetStartedProblemStatusResponseDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['getStartedProblemStatus'] = this.getStartedProblemStatus;
    return data;
  }
}

export interface IGetStartedProblemStatusResponseDto {
  getStartedProblemStatus?: GetStartedProblemStatus;
}

export class IdentityUserExtendedDto implements IIdentityUserExtendedDto {
  id?: string;
  creationTime?: Date;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  university?: string | undefined;
  roles?: string | undefined;

  constructor(data?: IIdentityUserExtendedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.university = _data['university'];
      this.roles = _data['roles'];
    }
  }

  static fromJS(data: any): IdentityUserExtendedDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityUserExtendedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['university'] = this.university;
    data['roles'] = this.roles;
    return data;
  }
}

export interface IIdentityUserExtendedDto {
  id?: string;
  creationTime?: Date;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  university?: string | undefined;
  roles?: string | undefined;
}

export class IdentityUserRestrictedDto implements IIdentityUserRestrictedDto {
  id?: string;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;

  constructor(data?: IIdentityUserRestrictedDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
    }
  }

  static fromJS(data: any): IdentityUserRestrictedDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityUserRestrictedDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    return data;
  }
}

export interface IIdentityUserRestrictedDto {
  id?: string;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
}

export enum PrivacyEntityScope {
  FullName = 'FullName',
  Gender = 'Gender',
  SocialMediaAccounts = 'SocialMediaAccounts',
  ShortBio = 'ShortBio',
  CityAndCountry = 'CityAndCountry',
}

export enum PrivacyEntityType {
  UserProfile = 'UserProfile',
  Problem = 'Problem',
  Contest = 'Contest',
}

export enum NotificationSettingScope {
  Global = 'Global',
  ContestUpdatesAndReminders = 'ContestUpdatesAndReminders',
  ContestAnnouncements = 'ContestAnnouncements',
  ContestClarifications = 'ContestClarifications',
  ContestNewProblem = 'ContestNewProblem',
  ContestStatusUpdates = 'ContestStatusUpdates',
  DiscussionUpdates = 'DiscussionUpdates',
}

export enum NotificationChannel {
  InApp = 'InApp',
  Email = 'Email',
}

export enum PrivacyEntityValue {
  Public = 'Public',
  Private = 'Private',
}

export class ResponseUserNameIsUniqueDto implements IResponseUserNameIsUniqueDto {
  isUnique?: boolean;

  constructor(data?: IResponseUserNameIsUniqueDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isUnique = _data['isUnique'];
    }
  }

  static fromJS(data: any): ResponseUserNameIsUniqueDto {
    data = typeof data === 'object' ? data : {};
    let result = new ResponseUserNameIsUniqueDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isUnique'] = this.isUnique;
    return data;
  }
}

export interface IResponseUserNameIsUniqueDto {
  isUnique?: boolean;
}

export class SchoolCreateUpdateDto implements ISchoolCreateUpdateDto {
  name!: string;
  domainUrl!: string;
  website?: string | undefined;
  type?: SchoolType;
  cityId!: string;

  constructor(data?: ISchoolCreateUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.domainUrl = _data['domainUrl'];
      this.website = _data['website'];
      this.type = _data['type'];
      this.cityId = _data['cityId'];
    }
  }

  static fromJS(data: any): SchoolCreateUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new SchoolCreateUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['domainUrl'] = this.domainUrl;
    data['website'] = this.website;
    data['type'] = this.type;
    data['cityId'] = this.cityId;
    return data;
  }
}

export interface ISchoolCreateUpdateDto {
  name: string;
  domainUrl: string;
  website?: string | undefined;
  type?: SchoolType;
  cityId: string;
}

export class SchoolDto implements ISchoolDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  domainUrl?: string | undefined;
  website?: string | undefined;
  type?: SchoolType;
  cityId?: string;

  constructor(data?: ISchoolDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.name = _data['name'];
      this.domainUrl = _data['domainUrl'];
      this.website = _data['website'];
      this.type = _data['type'];
      this.cityId = _data['cityId'];
    }
  }

  static fromJS(data: any): SchoolDto {
    data = typeof data === 'object' ? data : {};
    let result = new SchoolDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['name'] = this.name;
    data['domainUrl'] = this.domainUrl;
    data['website'] = this.website;
    data['type'] = this.type;
    data['cityId'] = this.cityId;
    return data;
  }
}

export interface ISchoolDto {
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  name?: string | undefined;
  domainUrl?: string | undefined;
  website?: string | undefined;
  type?: SchoolType;
  cityId?: string;
}

export enum TshirtSize {
  Undefined = 'Undefined',
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
  XXXL = 'XXXL',
}

export class TimeSpan implements ITimeSpan {
  readonly ticks?: number;
  readonly days?: number;
  readonly hours?: number;
  readonly milliseconds?: number;
  readonly minutes?: number;
  readonly seconds?: number;
  readonly totalDays?: number;
  readonly totalHours?: number;
  readonly totalMilliseconds?: number;
  readonly totalMinutes?: number;
  readonly totalSeconds?: number;

  constructor(data?: ITimeSpan) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).ticks = _data['ticks'];
      (<any>this).days = _data['days'];
      (<any>this).hours = _data['hours'];
      (<any>this).milliseconds = _data['milliseconds'];
      (<any>this).minutes = _data['minutes'];
      (<any>this).seconds = _data['seconds'];
      (<any>this).totalDays = _data['totalDays'];
      (<any>this).totalHours = _data['totalHours'];
      (<any>this).totalMilliseconds = _data['totalMilliseconds'];
      (<any>this).totalMinutes = _data['totalMinutes'];
      (<any>this).totalSeconds = _data['totalSeconds'];
    }
  }

  static fromJS(data: any): TimeSpan {
    data = typeof data === 'object' ? data : {};
    let result = new TimeSpan();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['ticks'] = this.ticks;
    data['days'] = this.days;
    data['hours'] = this.hours;
    data['milliseconds'] = this.milliseconds;
    data['minutes'] = this.minutes;
    data['seconds'] = this.seconds;
    data['totalDays'] = this.totalDays;
    data['totalHours'] = this.totalHours;
    data['totalMilliseconds'] = this.totalMilliseconds;
    data['totalMinutes'] = this.totalMinutes;
    data['totalSeconds'] = this.totalSeconds;
    return data;
  }
}

export interface ITimeSpan {
  ticks?: number;
  days?: number;
  hours?: number;
  milliseconds?: number;
  minutes?: number;
  seconds?: number;
  totalDays?: number;
  totalHours?: number;
  totalMilliseconds?: number;
  totalMinutes?: number;
  totalSeconds?: number;
}

export class RegisterDto2 implements IRegisterDto2 {
  readonly extraProperties?: { [key: string]: any } | undefined;
  userName!: string;
  emailAddress!: string;
  password!: string;
  appName!: string;

  constructor(data?: IRegisterDto2) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.userName = _data['userName'];
      this.emailAddress = _data['emailAddress'];
      this.password = _data['password'];
      this.appName = _data['appName'];
    }
  }

  static fromJS(data: any): RegisterDto2 {
    data = typeof data === 'object' ? data : {};
    let result = new RegisterDto2();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['userName'] = this.userName;
    data['emailAddress'] = this.emailAddress;
    data['password'] = this.password;
    data['appName'] = this.appName;
    return data;
  }
}

export interface IRegisterDto2 {
  extraProperties?: { [key: string]: any } | undefined;
  userName: string;
  emailAddress: string;
  password: string;
  appName: string;
}

export class ResetPasswordDto implements IResetPasswordDto {
  userId?: string;
  resetToken!: string;
  password!: string;

  constructor(data?: IResetPasswordDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.userId = _data['userId'];
      this.resetToken = _data['resetToken'];
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): ResetPasswordDto {
    data = typeof data === 'object' ? data : {};
    let result = new ResetPasswordDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['userId'] = this.userId;
    data['resetToken'] = this.resetToken;
    data['password'] = this.password;
    return data;
  }
}

export interface IResetPasswordDto {
  userId?: string;
  resetToken: string;
  password: string;
}

export class SendPasswordResetCodeDto implements ISendPasswordResetCodeDto {
  email!: string;
  appName!: string;
  returnUrl?: string | undefined;
  returnUrlHash?: string | undefined;

  constructor(data?: ISendPasswordResetCodeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.email = _data['email'];
      this.appName = _data['appName'];
      this.returnUrl = _data['returnUrl'];
      this.returnUrlHash = _data['returnUrlHash'];
    }
  }

  static fromJS(data: any): SendPasswordResetCodeDto {
    data = typeof data === 'object' ? data : {};
    let result = new SendPasswordResetCodeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['email'] = this.email;
    data['appName'] = this.appName;
    data['returnUrl'] = this.returnUrl;
    data['returnUrlHash'] = this.returnUrlHash;
    return data;
  }
}

export interface ISendPasswordResetCodeDto {
  email: string;
  appName: string;
  returnUrl?: string | undefined;
  returnUrlHash?: string | undefined;
}

export class ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestProblemInfoDto[] | undefined;

  constructor(
    data?: IListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestProblemInfoDto.fromJS(item));
      }
    }
  }

  static fromJS(
    data: any
  ): ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new ListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDto_1OfOfContestProblemInfoDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestProblemInfoDto[] | undefined;
}

export class ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: CountryDto[] | undefined;

  constructor(
    data?: IListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CountryDto.fromJS(item));
      }
    }
  }

  static fromJS(
    data: any
  ): ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new ListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: CountryDto[] | undefined;
}

export class ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: IdentityRoleDto[] | undefined;

  constructor(
    data?: IListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(IdentityRoleDto.fromJS(item));
      }
    }
  }

  static fromJS(
    data: any
  ): ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new ListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: IdentityRoleDto[] | undefined;
}

export class ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: UserData[] | undefined;

  constructor(
    data?: IListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(UserData.fromJS(item));
      }
    }
  }

  static fromJS(
    data: any
  ): ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new ListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    return data;
  }
}

export interface IListResultDto_1OfOfUserDataAndAbstractionsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: UserData[] | undefined;
}

export class PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: AuditLogActionDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AuditLogActionDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfAuditLogActionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: AuditLogActionDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: AuditLogDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AuditLogDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfAuditLogDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: AuditLogDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestAnnouncementFullDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestAnnouncementFullDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestAnnouncementFullDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestAnnouncementFullDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestAnnouncementListOutputDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(ContestAnnouncementListOutputDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestAnnouncementListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestAnnouncementListOutputDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestClarificationDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestClarificationDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestClarificationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestClarificationDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestClarificationListOutputDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(ContestClarificationListOutputDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestClarificationListOutputDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestClarificationListOutputDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestCoSetterDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestCoSetterDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestCoSetterDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestCoSetterDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestFullProfileUserSignUpsDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(ContestFullProfileUserSignUpsDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestFullProfileUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestFullProfileUserSignUpsDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestHistoryDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestHistoryDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestHistoryDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestProblemDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestProblemDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestProblemDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestTeamSignUpsDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestTeamSignUpsDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestTeamSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestTeamSignUpsDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestUserSignUpsDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestUserSignUpsDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestUserSignUpsDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestUserSignUpsDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: TeamContestHistoryDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TeamContestHistoryDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfTeamContestHistoryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: TeamContestHistoryDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: LeaderBoardUserProfileDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(LeaderBoardUserProfileDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfLeaderBoardUserProfileDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: LeaderBoardUserProfileDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?:
    | LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(
            LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(
              item
            )
          );
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfLookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?:
    | LookupDto_1OfOfGuidAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e[]
    | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ContestProblemSubmissionDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ContestProblemSubmissionDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfContestProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ContestProblemSubmissionDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: PracticeProblemDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(PracticeProblemDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfPracticeProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: PracticeProblemDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProblemCreatedDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ProblemCreatedDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProblemCreatedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProblemCreatedDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProblemDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ProblemDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProblemDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProblemDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProblemEditorialDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ProblemEditorialDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProblemEditorialDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProblemEditorialDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProblemProgrammingLanguageDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(ProblemProgrammingLanguageDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProblemProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProblemProgrammingLanguageDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProblemSubmissionDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ProblemSubmissionDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProblemSubmissionDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProblemSubmissionDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProblemSummaryDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ProblemSummaryDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProblemSummaryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProblemSummaryDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProblemTestCaseDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ProblemTestCaseDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProblemTestCaseDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProblemTestCaseDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements IPagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: CityDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CityDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfCityDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: CityDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: CountryDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(CountryDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfCountryDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: CountryDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: EmailDomainDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(EmailDomainDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfEmailDomainDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: EmailDomainDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: EmailProviderDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(EmailProviderDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfEmailProviderDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: EmailProviderDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: FeaturedContestDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(FeaturedContestDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfFeaturedContestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: FeaturedContestDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: AppUserScoreDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AppUserScoreDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfAppUserScoreDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: AppUserScoreDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: GLeaderboardCalculateRequestDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items'])
          this.items!.push(GLeaderboardCalculateRequestDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfGLeaderboardCalculateRequestDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: GLeaderboardCalculateRequestDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: JudgerDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(JudgerDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfJudgerDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: JudgerDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: OrganizationDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(OrganizationDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfOrganizationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: OrganizationDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements IPagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: PageDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(PageDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfPageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: PageDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: SourceDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(SourceDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfSourceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: SourceDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements IPagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: TagDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TagDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfTagDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: TagDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: TemplateDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TemplateDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfTemplateDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: TemplateDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: ProgrammingLanguageDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(ProgrammingLanguageDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfProgrammingLanguageDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: ProgrammingLanguageDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: SocialAccountDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(SocialAccountDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfSocialAccountDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: SocialAccountDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements IPagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: TeamDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TeamDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfTeamDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: TeamDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: TeamMemberDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TeamMemberDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfTeamMemberDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: TeamMemberDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: AppUserEducationDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AppUserEducationDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfAppUserEducationDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: AppUserEducationDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: AppUserWorkExperienceDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(AppUserWorkExperienceDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfAppUserWorkExperienceDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: AppUserWorkExperienceDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: IdentityUserExtendedDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(IdentityUserExtendedDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfIdentityUserExtendedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: IdentityUserExtendedDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: IdentityUserRestrictedDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(IdentityUserRestrictedDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfIdentityUserRestrictedDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: IdentityUserRestrictedDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: SchoolDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(SchoolDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfSchoolDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: SchoolDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: IdentityRoleDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(IdentityRoleDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfIdentityRoleDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: IdentityRoleDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: IdentityUserDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(IdentityUserDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfIdentityUserDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: IdentityUserDto[] | undefined;
  totalCount?: number;
}

export class PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  implements
    IPagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
{
  items?: TenantDto[] | undefined;
  totalCount?: number;

  constructor(
    data?: IPagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null
  ) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['items'])) {
        this.items = [] as any;
        for (let item of _data['items']) this.items!.push(TenantDto.fromJS(item));
      }
      this.totalCount = _data['totalCount'];
    }
  }

  static fromJS(
    data: any
  ): PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data = typeof data === 'object' ? data : {};
    let result =
      new PagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.items)) {
      data['items'] = [];
      for (let item of this.items) data['items'].push(item.toJSON());
    }
    data['totalCount'] = this.totalCount;
    return data;
  }
}

export interface IPagedResultDto_1OfOfTenantDtoAndContractsAnd_0AndCulture_neutralAndPublicKeyToken_null {
  items?: TenantDto[] | undefined;
  totalCount?: number;
}

export class ApplicationAuthConfigurationDto implements IApplicationAuthConfigurationDto {
  policies?: { [key: string]: boolean } | undefined;
  grantedPolicies?: { [key: string]: boolean } | undefined;

  constructor(data?: IApplicationAuthConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['policies']) {
        this.policies = {} as any;
        for (let key in _data['policies']) {
          if (_data['policies'].hasOwnProperty(key))
            (<any>this.policies)![key] = _data['policies'][key];
        }
      }
      if (_data['grantedPolicies']) {
        this.grantedPolicies = {} as any;
        for (let key in _data['grantedPolicies']) {
          if (_data['grantedPolicies'].hasOwnProperty(key))
            (<any>this.grantedPolicies)![key] = _data['grantedPolicies'][key];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationAuthConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationAuthConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.policies) {
      data['policies'] = {};
      for (let key in this.policies) {
        if (this.policies.hasOwnProperty(key)) (<any>data['policies'])[key] = this.policies[key];
      }
    }
    if (this.grantedPolicies) {
      data['grantedPolicies'] = {};
      for (let key in this.grantedPolicies) {
        if (this.grantedPolicies.hasOwnProperty(key))
          (<any>data['grantedPolicies'])[key] = this.grantedPolicies[key];
      }
    }
    return data;
  }
}

export interface IApplicationAuthConfigurationDto {
  policies?: { [key: string]: boolean } | undefined;
  grantedPolicies?: { [key: string]: boolean } | undefined;
}

export class ApplicationConfigurationDto implements IApplicationConfigurationDto {
  localization?: ApplicationLocalizationConfigurationDto;
  auth?: ApplicationAuthConfigurationDto;
  setting?: ApplicationSettingConfigurationDto;
  currentUser?: CurrentUserDto;
  features?: ApplicationFeatureConfigurationDto;
  multiTenancy?: MultiTenancyInfoDto;
  currentTenant?: CurrentTenantDto;
  timing?: TimingDto;
  clock?: ClockDto;
  objectExtensions?: ObjectExtensionsDto;

  constructor(data?: IApplicationConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.localization = _data['localization']
        ? ApplicationLocalizationConfigurationDto.fromJS(_data['localization'])
        : <any>undefined;
      this.auth = _data['auth']
        ? ApplicationAuthConfigurationDto.fromJS(_data['auth'])
        : <any>undefined;
      this.setting = _data['setting']
        ? ApplicationSettingConfigurationDto.fromJS(_data['setting'])
        : <any>undefined;
      this.currentUser = _data['currentUser']
        ? CurrentUserDto.fromJS(_data['currentUser'])
        : <any>undefined;
      this.features = _data['features']
        ? ApplicationFeatureConfigurationDto.fromJS(_data['features'])
        : <any>undefined;
      this.multiTenancy = _data['multiTenancy']
        ? MultiTenancyInfoDto.fromJS(_data['multiTenancy'])
        : <any>undefined;
      this.currentTenant = _data['currentTenant']
        ? CurrentTenantDto.fromJS(_data['currentTenant'])
        : <any>undefined;
      this.timing = _data['timing'] ? TimingDto.fromJS(_data['timing']) : <any>undefined;
      this.clock = _data['clock'] ? ClockDto.fromJS(_data['clock']) : <any>undefined;
      this.objectExtensions = _data['objectExtensions']
        ? ObjectExtensionsDto.fromJS(_data['objectExtensions'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ApplicationConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['localization'] = this.localization ? this.localization.toJSON() : <any>undefined;
    data['auth'] = this.auth ? this.auth.toJSON() : <any>undefined;
    data['setting'] = this.setting ? this.setting.toJSON() : <any>undefined;
    data['currentUser'] = this.currentUser ? this.currentUser.toJSON() : <any>undefined;
    data['features'] = this.features ? this.features.toJSON() : <any>undefined;
    data['multiTenancy'] = this.multiTenancy ? this.multiTenancy.toJSON() : <any>undefined;
    data['currentTenant'] = this.currentTenant ? this.currentTenant.toJSON() : <any>undefined;
    data['timing'] = this.timing ? this.timing.toJSON() : <any>undefined;
    data['clock'] = this.clock ? this.clock.toJSON() : <any>undefined;
    data['objectExtensions'] = this.objectExtensions
      ? this.objectExtensions.toJSON()
      : <any>undefined;
    return data;
  }
}

export interface IApplicationConfigurationDto {
  localization?: ApplicationLocalizationConfigurationDto;
  auth?: ApplicationAuthConfigurationDto;
  setting?: ApplicationSettingConfigurationDto;
  currentUser?: CurrentUserDto;
  features?: ApplicationFeatureConfigurationDto;
  multiTenancy?: MultiTenancyInfoDto;
  currentTenant?: CurrentTenantDto;
  timing?: TimingDto;
  clock?: ClockDto;
  objectExtensions?: ObjectExtensionsDto;
}

export class ApplicationFeatureConfigurationDto implements IApplicationFeatureConfigurationDto {
  values?: { [key: string]: string } | undefined;

  constructor(data?: IApplicationFeatureConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['values']) {
        this.values = {} as any;
        for (let key in _data['values']) {
          if (_data['values'].hasOwnProperty(key)) (<any>this.values)![key] = _data['values'][key];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationFeatureConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationFeatureConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.values) {
      data['values'] = {};
      for (let key in this.values) {
        if (this.values.hasOwnProperty(key)) (<any>data['values'])[key] = this.values[key];
      }
    }
    return data;
  }
}

export interface IApplicationFeatureConfigurationDto {
  values?: { [key: string]: string } | undefined;
}

export class ApplicationLocalizationConfigurationDto
  implements IApplicationLocalizationConfigurationDto
{
  values?: { [key: string]: { [key: string]: string } } | undefined;
  languages?: LanguageInfo[] | undefined;
  currentCulture?: CurrentCultureDto;
  defaultResourceNames?: string | undefined;
  languagesMap?: { [key: string]: NameValue[] } | undefined;
  languageFilesMap?: { [key: string]: NameValue[] } | undefined;

  constructor(data?: IApplicationLocalizationConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['values']) {
        this.values = {} as any;
        for (let key in _data['values']) {
          if (_data['values'].hasOwnProperty(key))
            (<any>this.values)![key] =
              _data['values'][key] !== undefined ? _data['values'][key] : {};
        }
      }
      if (Array.isArray(_data['languages'])) {
        this.languages = [] as any;
        for (let item of _data['languages']) this.languages!.push(LanguageInfo.fromJS(item));
      }
      this.currentCulture = _data['currentCulture']
        ? CurrentCultureDto.fromJS(_data['currentCulture'])
        : <any>undefined;
      this.defaultResourceNames = _data['defaultResourceNames'];
      if (_data['languagesMap']) {
        this.languagesMap = {} as any;
        for (let key in _data['languagesMap']) {
          if (_data['languagesMap'].hasOwnProperty(key))
            (<any>this.languagesMap)![key] = _data['languagesMap'][key]
              ? _data['languagesMap'][key].map((i: any) => NameValue.fromJS(i))
              : [];
        }
      }
      if (_data['languageFilesMap']) {
        this.languageFilesMap = {} as any;
        for (let key in _data['languageFilesMap']) {
          if (_data['languageFilesMap'].hasOwnProperty(key))
            (<any>this.languageFilesMap)![key] = _data['languageFilesMap'][key]
              ? _data['languageFilesMap'][key].map((i: any) => NameValue.fromJS(i))
              : [];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationLocalizationConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationLocalizationConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.values) {
      data['values'] = {};
      for (let key in this.values) {
        if (this.values.hasOwnProperty(key)) (<any>data['values'])[key] = this.values[key];
      }
    }
    if (Array.isArray(this.languages)) {
      data['languages'] = [];
      for (let item of this.languages) data['languages'].push(item.toJSON());
    }
    data['currentCulture'] = this.currentCulture ? this.currentCulture.toJSON() : <any>undefined;
    data['defaultResourceNames'] = this.defaultResourceNames;
    if (this.languagesMap) {
      data['languagesMap'] = {};
      for (let key in this.languagesMap) {
        if (this.languagesMap.hasOwnProperty(key))
          (<any>data['languagesMap'])[key] = this.languagesMap[key];
      }
    }
    if (this.languageFilesMap) {
      data['languageFilesMap'] = {};
      for (let key in this.languageFilesMap) {
        if (this.languageFilesMap.hasOwnProperty(key))
          (<any>data['languageFilesMap'])[key] = this.languageFilesMap[key];
      }
    }
    return data;
  }
}

export interface IApplicationLocalizationConfigurationDto {
  values?: { [key: string]: { [key: string]: string } } | undefined;
  languages?: LanguageInfo[] | undefined;
  currentCulture?: CurrentCultureDto;
  defaultResourceNames?: string | undefined;
  languagesMap?: { [key: string]: NameValue[] } | undefined;
  languageFilesMap?: { [key: string]: NameValue[] } | undefined;
}

export class ApplicationSettingConfigurationDto implements IApplicationSettingConfigurationDto {
  values?: { [key: string]: string } | undefined;

  constructor(data?: IApplicationSettingConfigurationDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['values']) {
        this.values = {} as any;
        for (let key in _data['values']) {
          if (_data['values'].hasOwnProperty(key)) (<any>this.values)![key] = _data['values'][key];
        }
      }
    }
  }

  static fromJS(data: any): ApplicationSettingConfigurationDto {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationSettingConfigurationDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.values) {
      data['values'] = {};
      for (let key in this.values) {
        if (this.values.hasOwnProperty(key)) (<any>data['values'])[key] = this.values[key];
      }
    }
    return data;
  }
}

export interface IApplicationSettingConfigurationDto {
  values?: { [key: string]: string } | undefined;
}

export class ClockDto implements IClockDto {
  kind?: string | undefined;

  constructor(data?: IClockDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.kind = _data['kind'];
    }
  }

  static fromJS(data: any): ClockDto {
    data = typeof data === 'object' ? data : {};
    let result = new ClockDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['kind'] = this.kind;
    return data;
  }
}

export interface IClockDto {
  kind?: string | undefined;
}

export class CurrentCultureDto implements ICurrentCultureDto {
  displayName?: string | undefined;
  englishName?: string | undefined;
  threeLetterIsoLanguageName?: string | undefined;
  twoLetterIsoLanguageName?: string | undefined;
  isRightToLeft?: boolean;
  cultureName?: string | undefined;
  name?: string | undefined;
  nativeName?: string | undefined;
  dateTimeFormat?: DateTimeFormatDto;

  constructor(data?: ICurrentCultureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.displayName = _data['displayName'];
      this.englishName = _data['englishName'];
      this.threeLetterIsoLanguageName = _data['threeLetterIsoLanguageName'];
      this.twoLetterIsoLanguageName = _data['twoLetterIsoLanguageName'];
      this.isRightToLeft = _data['isRightToLeft'];
      this.cultureName = _data['cultureName'];
      this.name = _data['name'];
      this.nativeName = _data['nativeName'];
      this.dateTimeFormat = _data['dateTimeFormat']
        ? DateTimeFormatDto.fromJS(_data['dateTimeFormat'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): CurrentCultureDto {
    data = typeof data === 'object' ? data : {};
    let result = new CurrentCultureDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['displayName'] = this.displayName;
    data['englishName'] = this.englishName;
    data['threeLetterIsoLanguageName'] = this.threeLetterIsoLanguageName;
    data['twoLetterIsoLanguageName'] = this.twoLetterIsoLanguageName;
    data['isRightToLeft'] = this.isRightToLeft;
    data['cultureName'] = this.cultureName;
    data['name'] = this.name;
    data['nativeName'] = this.nativeName;
    data['dateTimeFormat'] = this.dateTimeFormat ? this.dateTimeFormat.toJSON() : <any>undefined;
    return data;
  }
}

export interface ICurrentCultureDto {
  displayName?: string | undefined;
  englishName?: string | undefined;
  threeLetterIsoLanguageName?: string | undefined;
  twoLetterIsoLanguageName?: string | undefined;
  isRightToLeft?: boolean;
  cultureName?: string | undefined;
  name?: string | undefined;
  nativeName?: string | undefined;
  dateTimeFormat?: DateTimeFormatDto;
}

export class CurrentUserDto implements ICurrentUserDto {
  isAuthenticated?: boolean;
  id?: string | undefined;
  tenantId?: string | undefined;
  impersonatorUserId?: string | undefined;
  impersonatorTenantId?: string | undefined;
  userName?: string | undefined;
  name?: string | undefined;
  surName?: string | undefined;
  email?: string | undefined;
  emailVerified?: boolean;
  phoneNumber?: string | undefined;
  phoneNumberVerified?: boolean;
  roles?: string[] | undefined;

  constructor(data?: ICurrentUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isAuthenticated = _data['isAuthenticated'];
      this.id = _data['id'];
      this.tenantId = _data['tenantId'];
      this.impersonatorUserId = _data['impersonatorUserId'];
      this.impersonatorTenantId = _data['impersonatorTenantId'];
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surName = _data['surName'];
      this.email = _data['email'];
      this.emailVerified = _data['emailVerified'];
      this.phoneNumber = _data['phoneNumber'];
      this.phoneNumberVerified = _data['phoneNumberVerified'];
      if (Array.isArray(_data['roles'])) {
        this.roles = [] as any;
        for (let item of _data['roles']) this.roles!.push(item);
      }
    }
  }

  static fromJS(data: any): CurrentUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new CurrentUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isAuthenticated'] = this.isAuthenticated;
    data['id'] = this.id;
    data['tenantId'] = this.tenantId;
    data['impersonatorUserId'] = this.impersonatorUserId;
    data['impersonatorTenantId'] = this.impersonatorTenantId;
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surName'] = this.surName;
    data['email'] = this.email;
    data['emailVerified'] = this.emailVerified;
    data['phoneNumber'] = this.phoneNumber;
    data['phoneNumberVerified'] = this.phoneNumberVerified;
    if (Array.isArray(this.roles)) {
      data['roles'] = [];
      for (let item of this.roles) data['roles'].push(item);
    }
    return data;
  }
}

export interface ICurrentUserDto {
  isAuthenticated?: boolean;
  id?: string | undefined;
  tenantId?: string | undefined;
  impersonatorUserId?: string | undefined;
  impersonatorTenantId?: string | undefined;
  userName?: string | undefined;
  name?: string | undefined;
  surName?: string | undefined;
  email?: string | undefined;
  emailVerified?: boolean;
  phoneNumber?: string | undefined;
  phoneNumberVerified?: boolean;
  roles?: string[] | undefined;
}

export class DateTimeFormatDto implements IDateTimeFormatDto {
  calendarAlgorithmType?: string | undefined;
  dateTimeFormatLong?: string | undefined;
  shortDatePattern?: string | undefined;
  fullDateTimePattern?: string | undefined;
  dateSeparator?: string | undefined;
  shortTimePattern?: string | undefined;
  longTimePattern?: string | undefined;

  constructor(data?: IDateTimeFormatDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.calendarAlgorithmType = _data['calendarAlgorithmType'];
      this.dateTimeFormatLong = _data['dateTimeFormatLong'];
      this.shortDatePattern = _data['shortDatePattern'];
      this.fullDateTimePattern = _data['fullDateTimePattern'];
      this.dateSeparator = _data['dateSeparator'];
      this.shortTimePattern = _data['shortTimePattern'];
      this.longTimePattern = _data['longTimePattern'];
    }
  }

  static fromJS(data: any): DateTimeFormatDto {
    data = typeof data === 'object' ? data : {};
    let result = new DateTimeFormatDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['calendarAlgorithmType'] = this.calendarAlgorithmType;
    data['dateTimeFormatLong'] = this.dateTimeFormatLong;
    data['shortDatePattern'] = this.shortDatePattern;
    data['fullDateTimePattern'] = this.fullDateTimePattern;
    data['dateSeparator'] = this.dateSeparator;
    data['shortTimePattern'] = this.shortTimePattern;
    data['longTimePattern'] = this.longTimePattern;
    return data;
  }
}

export interface IDateTimeFormatDto {
  calendarAlgorithmType?: string | undefined;
  dateTimeFormatLong?: string | undefined;
  shortDatePattern?: string | undefined;
  fullDateTimePattern?: string | undefined;
  dateSeparator?: string | undefined;
  shortTimePattern?: string | undefined;
  longTimePattern?: string | undefined;
}

export class IanaTimeZone implements IIanaTimeZone {
  timeZoneName?: string | undefined;

  constructor(data?: IIanaTimeZone) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.timeZoneName = _data['timeZoneName'];
    }
  }

  static fromJS(data: any): IanaTimeZone {
    data = typeof data === 'object' ? data : {};
    let result = new IanaTimeZone();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['timeZoneName'] = this.timeZoneName;
    return data;
  }
}

export interface IIanaTimeZone {
  timeZoneName?: string | undefined;
}

export class EntityExtensionDto implements IEntityExtensionDto {
  properties?: { [key: string]: ExtensionPropertyDto } | undefined;
  configuration?: { [key: string]: any } | undefined;

  constructor(data?: IEntityExtensionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['properties']) {
        this.properties = {} as any;
        for (let key in _data['properties']) {
          if (_data['properties'].hasOwnProperty(key))
            (<any>this.properties)![key] = _data['properties'][key]
              ? ExtensionPropertyDto.fromJS(_data['properties'][key])
              : new ExtensionPropertyDto();
        }
      }
      if (_data['configuration']) {
        this.configuration = {} as any;
        for (let key in _data['configuration']) {
          if (_data['configuration'].hasOwnProperty(key))
            (<any>this.configuration)![key] = _data['configuration'][key];
        }
      }
    }
  }

  static fromJS(data: any): EntityExtensionDto {
    data = typeof data === 'object' ? data : {};
    let result = new EntityExtensionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.properties) {
      data['properties'] = {};
      for (let key in this.properties) {
        if (this.properties.hasOwnProperty(key))
          (<any>data['properties'])[key] = this.properties[key]
            ? this.properties[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.configuration) {
      data['configuration'] = {};
      for (let key in this.configuration) {
        if (this.configuration.hasOwnProperty(key))
          (<any>data['configuration'])[key] = this.configuration[key];
      }
    }
    return data;
  }
}

export interface IEntityExtensionDto {
  properties?: { [key: string]: ExtensionPropertyDto } | undefined;
  configuration?: { [key: string]: any } | undefined;
}

export class ExtensionEnumDto implements IExtensionEnumDto {
  fields?: ExtensionEnumFieldDto[] | undefined;
  localizationResource?: string | undefined;

  constructor(data?: IExtensionEnumDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['fields'])) {
        this.fields = [] as any;
        for (let item of _data['fields']) this.fields!.push(ExtensionEnumFieldDto.fromJS(item));
      }
      this.localizationResource = _data['localizationResource'];
    }
  }

  static fromJS(data: any): ExtensionEnumDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionEnumDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.fields)) {
      data['fields'] = [];
      for (let item of this.fields) data['fields'].push(item.toJSON());
    }
    data['localizationResource'] = this.localizationResource;
    return data;
  }
}

export interface IExtensionEnumDto {
  fields?: ExtensionEnumFieldDto[] | undefined;
  localizationResource?: string | undefined;
}

export class ExtensionEnumFieldDto implements IExtensionEnumFieldDto {
  name?: string | undefined;
  value?: any | undefined;

  constructor(data?: IExtensionEnumFieldDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): ExtensionEnumFieldDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionEnumFieldDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['value'] = this.value;
    return data;
  }
}

export interface IExtensionEnumFieldDto {
  name?: string | undefined;
  value?: any | undefined;
}

export class ExtensionPropertyApiCreateDto implements IExtensionPropertyApiCreateDto {
  isAvailable?: boolean;

  constructor(data?: IExtensionPropertyApiCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isAvailable = _data['isAvailable'];
    }
  }

  static fromJS(data: any): ExtensionPropertyApiCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyApiCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isAvailable'] = this.isAvailable;
    return data;
  }
}

export interface IExtensionPropertyApiCreateDto {
  isAvailable?: boolean;
}

export class ExtensionPropertyApiDto implements IExtensionPropertyApiDto {
  onGet?: ExtensionPropertyApiGetDto;
  onCreate?: ExtensionPropertyApiCreateDto;
  onUpdate?: ExtensionPropertyApiUpdateDto;

  constructor(data?: IExtensionPropertyApiDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.onGet = _data['onGet']
        ? ExtensionPropertyApiGetDto.fromJS(_data['onGet'])
        : <any>undefined;
      this.onCreate = _data['onCreate']
        ? ExtensionPropertyApiCreateDto.fromJS(_data['onCreate'])
        : <any>undefined;
      this.onUpdate = _data['onUpdate']
        ? ExtensionPropertyApiUpdateDto.fromJS(_data['onUpdate'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ExtensionPropertyApiDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyApiDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['onGet'] = this.onGet ? this.onGet.toJSON() : <any>undefined;
    data['onCreate'] = this.onCreate ? this.onCreate.toJSON() : <any>undefined;
    data['onUpdate'] = this.onUpdate ? this.onUpdate.toJSON() : <any>undefined;
    return data;
  }
}

export interface IExtensionPropertyApiDto {
  onGet?: ExtensionPropertyApiGetDto;
  onCreate?: ExtensionPropertyApiCreateDto;
  onUpdate?: ExtensionPropertyApiUpdateDto;
}

export class ExtensionPropertyApiGetDto implements IExtensionPropertyApiGetDto {
  isAvailable?: boolean;

  constructor(data?: IExtensionPropertyApiGetDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isAvailable = _data['isAvailable'];
    }
  }

  static fromJS(data: any): ExtensionPropertyApiGetDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyApiGetDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isAvailable'] = this.isAvailable;
    return data;
  }
}

export interface IExtensionPropertyApiGetDto {
  isAvailable?: boolean;
}

export class ExtensionPropertyApiUpdateDto implements IExtensionPropertyApiUpdateDto {
  isAvailable?: boolean;

  constructor(data?: IExtensionPropertyApiUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isAvailable = _data['isAvailable'];
    }
  }

  static fromJS(data: any): ExtensionPropertyApiUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyApiUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isAvailable'] = this.isAvailable;
    return data;
  }
}

export interface IExtensionPropertyApiUpdateDto {
  isAvailable?: boolean;
}

export class ExtensionPropertyAttributeDto implements IExtensionPropertyAttributeDto {
  typeSimple?: string | undefined;
  config?: { [key: string]: any } | undefined;

  constructor(data?: IExtensionPropertyAttributeDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.typeSimple = _data['typeSimple'];
      if (_data['config']) {
        this.config = {} as any;
        for (let key in _data['config']) {
          if (_data['config'].hasOwnProperty(key)) (<any>this.config)![key] = _data['config'][key];
        }
      }
    }
  }

  static fromJS(data: any): ExtensionPropertyAttributeDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyAttributeDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['typeSimple'] = this.typeSimple;
    if (this.config) {
      data['config'] = {};
      for (let key in this.config) {
        if (this.config.hasOwnProperty(key)) (<any>data['config'])[key] = this.config[key];
      }
    }
    return data;
  }
}

export interface IExtensionPropertyAttributeDto {
  typeSimple?: string | undefined;
  config?: { [key: string]: any } | undefined;
}

export class ExtensionPropertyDto implements IExtensionPropertyDto {
  type?: string | undefined;
  typeSimple?: string | undefined;
  displayName?: LocalizableStringDto;
  api?: ExtensionPropertyApiDto;
  ui?: ExtensionPropertyUiDto;
  attributes?: ExtensionPropertyAttributeDto[] | undefined;
  configuration?: { [key: string]: any } | undefined;
  defaultValue?: any | undefined;

  constructor(data?: IExtensionPropertyDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.typeSimple = _data['typeSimple'];
      this.displayName = _data['displayName']
        ? LocalizableStringDto.fromJS(_data['displayName'])
        : <any>undefined;
      this.api = _data['api'] ? ExtensionPropertyApiDto.fromJS(_data['api']) : <any>undefined;
      this.ui = _data['ui'] ? ExtensionPropertyUiDto.fromJS(_data['ui']) : <any>undefined;
      if (Array.isArray(_data['attributes'])) {
        this.attributes = [] as any;
        for (let item of _data['attributes'])
          this.attributes!.push(ExtensionPropertyAttributeDto.fromJS(item));
      }
      if (_data['configuration']) {
        this.configuration = {} as any;
        for (let key in _data['configuration']) {
          if (_data['configuration'].hasOwnProperty(key))
            (<any>this.configuration)![key] = _data['configuration'][key];
        }
      }
      this.defaultValue = _data['defaultValue'];
    }
  }

  static fromJS(data: any): ExtensionPropertyDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['typeSimple'] = this.typeSimple;
    data['displayName'] = this.displayName ? this.displayName.toJSON() : <any>undefined;
    data['api'] = this.api ? this.api.toJSON() : <any>undefined;
    data['ui'] = this.ui ? this.ui.toJSON() : <any>undefined;
    if (Array.isArray(this.attributes)) {
      data['attributes'] = [];
      for (let item of this.attributes) data['attributes'].push(item.toJSON());
    }
    if (this.configuration) {
      data['configuration'] = {};
      for (let key in this.configuration) {
        if (this.configuration.hasOwnProperty(key))
          (<any>data['configuration'])[key] = this.configuration[key];
      }
    }
    data['defaultValue'] = this.defaultValue;
    return data;
  }
}

export interface IExtensionPropertyDto {
  type?: string | undefined;
  typeSimple?: string | undefined;
  displayName?: LocalizableStringDto;
  api?: ExtensionPropertyApiDto;
  ui?: ExtensionPropertyUiDto;
  attributes?: ExtensionPropertyAttributeDto[] | undefined;
  configuration?: { [key: string]: any } | undefined;
  defaultValue?: any | undefined;
}

export class ExtensionPropertyUiDto implements IExtensionPropertyUiDto {
  onTable?: ExtensionPropertyUiTableDto;
  onCreateForm?: ExtensionPropertyUiFormDto;
  onEditForm?: ExtensionPropertyUiFormDto;
  lookup?: ExtensionPropertyUiLookupDto;

  constructor(data?: IExtensionPropertyUiDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.onTable = _data['onTable']
        ? ExtensionPropertyUiTableDto.fromJS(_data['onTable'])
        : <any>undefined;
      this.onCreateForm = _data['onCreateForm']
        ? ExtensionPropertyUiFormDto.fromJS(_data['onCreateForm'])
        : <any>undefined;
      this.onEditForm = _data['onEditForm']
        ? ExtensionPropertyUiFormDto.fromJS(_data['onEditForm'])
        : <any>undefined;
      this.lookup = _data['lookup']
        ? ExtensionPropertyUiLookupDto.fromJS(_data['lookup'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): ExtensionPropertyUiDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyUiDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['onTable'] = this.onTable ? this.onTable.toJSON() : <any>undefined;
    data['onCreateForm'] = this.onCreateForm ? this.onCreateForm.toJSON() : <any>undefined;
    data['onEditForm'] = this.onEditForm ? this.onEditForm.toJSON() : <any>undefined;
    data['lookup'] = this.lookup ? this.lookup.toJSON() : <any>undefined;
    return data;
  }
}

export interface IExtensionPropertyUiDto {
  onTable?: ExtensionPropertyUiTableDto;
  onCreateForm?: ExtensionPropertyUiFormDto;
  onEditForm?: ExtensionPropertyUiFormDto;
  lookup?: ExtensionPropertyUiLookupDto;
}

export class ExtensionPropertyUiFormDto implements IExtensionPropertyUiFormDto {
  isVisible?: boolean;

  constructor(data?: IExtensionPropertyUiFormDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isVisible = _data['isVisible'];
    }
  }

  static fromJS(data: any): ExtensionPropertyUiFormDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyUiFormDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isVisible'] = this.isVisible;
    return data;
  }
}

export interface IExtensionPropertyUiFormDto {
  isVisible?: boolean;
}

export class ExtensionPropertyUiLookupDto implements IExtensionPropertyUiLookupDto {
  url?: string | undefined;
  resultListPropertyName?: string | undefined;
  displayPropertyName?: string | undefined;
  valuePropertyName?: string | undefined;
  filterParamName?: string | undefined;

  constructor(data?: IExtensionPropertyUiLookupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.url = _data['url'];
      this.resultListPropertyName = _data['resultListPropertyName'];
      this.displayPropertyName = _data['displayPropertyName'];
      this.valuePropertyName = _data['valuePropertyName'];
      this.filterParamName = _data['filterParamName'];
    }
  }

  static fromJS(data: any): ExtensionPropertyUiLookupDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyUiLookupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['url'] = this.url;
    data['resultListPropertyName'] = this.resultListPropertyName;
    data['displayPropertyName'] = this.displayPropertyName;
    data['valuePropertyName'] = this.valuePropertyName;
    data['filterParamName'] = this.filterParamName;
    return data;
  }
}

export interface IExtensionPropertyUiLookupDto {
  url?: string | undefined;
  resultListPropertyName?: string | undefined;
  displayPropertyName?: string | undefined;
  valuePropertyName?: string | undefined;
  filterParamName?: string | undefined;
}

export class ExtensionPropertyUiTableDto implements IExtensionPropertyUiTableDto {
  isVisible?: boolean;

  constructor(data?: IExtensionPropertyUiTableDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isVisible = _data['isVisible'];
    }
  }

  static fromJS(data: any): ExtensionPropertyUiTableDto {
    data = typeof data === 'object' ? data : {};
    let result = new ExtensionPropertyUiTableDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isVisible'] = this.isVisible;
    return data;
  }
}

export interface IExtensionPropertyUiTableDto {
  isVisible?: boolean;
}

export class LocalizableStringDto implements ILocalizableStringDto {
  readonly name?: string | undefined;
  resource?: string | undefined;

  constructor(data?: ILocalizableStringDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).name = _data['name'];
      this.resource = _data['resource'];
    }
  }

  static fromJS(data: any): LocalizableStringDto {
    data = typeof data === 'object' ? data : {};
    let result = new LocalizableStringDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['resource'] = this.resource;
    return data;
  }
}

export interface ILocalizableStringDto {
  name?: string | undefined;
  resource?: string | undefined;
}

export class ModuleExtensionDto implements IModuleExtensionDto {
  entities?: { [key: string]: EntityExtensionDto } | undefined;
  configuration?: { [key: string]: any } | undefined;

  constructor(data?: IModuleExtensionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['entities']) {
        this.entities = {} as any;
        for (let key in _data['entities']) {
          if (_data['entities'].hasOwnProperty(key))
            (<any>this.entities)![key] = _data['entities'][key]
              ? EntityExtensionDto.fromJS(_data['entities'][key])
              : new EntityExtensionDto();
        }
      }
      if (_data['configuration']) {
        this.configuration = {} as any;
        for (let key in _data['configuration']) {
          if (_data['configuration'].hasOwnProperty(key))
            (<any>this.configuration)![key] = _data['configuration'][key];
        }
      }
    }
  }

  static fromJS(data: any): ModuleExtensionDto {
    data = typeof data === 'object' ? data : {};
    let result = new ModuleExtensionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.entities) {
      data['entities'] = {};
      for (let key in this.entities) {
        if (this.entities.hasOwnProperty(key))
          (<any>data['entities'])[key] = this.entities[key]
            ? this.entities[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.configuration) {
      data['configuration'] = {};
      for (let key in this.configuration) {
        if (this.configuration.hasOwnProperty(key))
          (<any>data['configuration'])[key] = this.configuration[key];
      }
    }
    return data;
  }
}

export interface IModuleExtensionDto {
  entities?: { [key: string]: EntityExtensionDto } | undefined;
  configuration?: { [key: string]: any } | undefined;
}

export class ObjectExtensionsDto implements IObjectExtensionsDto {
  modules?: { [key: string]: ModuleExtensionDto } | undefined;
  enums?: { [key: string]: ExtensionEnumDto } | undefined;

  constructor(data?: IObjectExtensionsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['modules']) {
        this.modules = {} as any;
        for (let key in _data['modules']) {
          if (_data['modules'].hasOwnProperty(key))
            (<any>this.modules)![key] = _data['modules'][key]
              ? ModuleExtensionDto.fromJS(_data['modules'][key])
              : new ModuleExtensionDto();
        }
      }
      if (_data['enums']) {
        this.enums = {} as any;
        for (let key in _data['enums']) {
          if (_data['enums'].hasOwnProperty(key))
            (<any>this.enums)![key] = _data['enums'][key]
              ? ExtensionEnumDto.fromJS(_data['enums'][key])
              : new ExtensionEnumDto();
        }
      }
    }
  }

  static fromJS(data: any): ObjectExtensionsDto {
    data = typeof data === 'object' ? data : {};
    let result = new ObjectExtensionsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.modules) {
      data['modules'] = {};
      for (let key in this.modules) {
        if (this.modules.hasOwnProperty(key))
          (<any>data['modules'])[key] = this.modules[key]
            ? this.modules[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.enums) {
      data['enums'] = {};
      for (let key in this.enums) {
        if (this.enums.hasOwnProperty(key))
          (<any>data['enums'])[key] = this.enums[key] ? this.enums[key].toJSON() : <any>undefined;
      }
    }
    return data;
  }
}

export interface IObjectExtensionsDto {
  modules?: { [key: string]: ModuleExtensionDto } | undefined;
  enums?: { [key: string]: ExtensionEnumDto } | undefined;
}

export class TimeZone implements ITimeZone {
  iana?: IanaTimeZone;
  windows?: WindowsTimeZone;

  constructor(data?: ITimeZone) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.iana = _data['iana'] ? IanaTimeZone.fromJS(_data['iana']) : <any>undefined;
      this.windows = _data['windows'] ? WindowsTimeZone.fromJS(_data['windows']) : <any>undefined;
    }
  }

  static fromJS(data: any): TimeZone {
    data = typeof data === 'object' ? data : {};
    let result = new TimeZone();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['iana'] = this.iana ? this.iana.toJSON() : <any>undefined;
    data['windows'] = this.windows ? this.windows.toJSON() : <any>undefined;
    return data;
  }
}

export interface ITimeZone {
  iana?: IanaTimeZone;
  windows?: WindowsTimeZone;
}

export class TimingDto implements ITimingDto {
  timeZone?: TimeZone;

  constructor(data?: ITimingDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.timeZone = _data['timeZone'] ? TimeZone.fromJS(_data['timeZone']) : <any>undefined;
    }
  }

  static fromJS(data: any): TimingDto {
    data = typeof data === 'object' ? data : {};
    let result = new TimingDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['timeZone'] = this.timeZone ? this.timeZone.toJSON() : <any>undefined;
    return data;
  }
}

export interface ITimingDto {
  timeZone?: TimeZone;
}

export class WindowsTimeZone implements IWindowsTimeZone {
  timeZoneId?: string | undefined;

  constructor(data?: IWindowsTimeZone) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.timeZoneId = _data['timeZoneId'];
    }
  }

  static fromJS(data: any): WindowsTimeZone {
    data = typeof data === 'object' ? data : {};
    let result = new WindowsTimeZone();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['timeZoneId'] = this.timeZoneId;
    return data;
  }
}

export interface IWindowsTimeZone {
  timeZoneId?: string | undefined;
}

export class CurrentTenantDto implements ICurrentTenantDto {
  id?: string | undefined;
  name?: string | undefined;
  isAvailable?: boolean;

  constructor(data?: ICurrentTenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.name = _data['name'];
      this.isAvailable = _data['isAvailable'];
    }
  }

  static fromJS(data: any): CurrentTenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new CurrentTenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['name'] = this.name;
    data['isAvailable'] = this.isAvailable;
    return data;
  }
}

export interface ICurrentTenantDto {
  id?: string | undefined;
  name?: string | undefined;
  isAvailable?: boolean;
}

export class FindTenantResultDto implements IFindTenantResultDto {
  success?: boolean;
  tenantId?: string | undefined;
  name?: string | undefined;
  isActive?: boolean;

  constructor(data?: IFindTenantResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.success = _data['success'];
      this.tenantId = _data['tenantId'];
      this.name = _data['name'];
      this.isActive = _data['isActive'];
    }
  }

  static fromJS(data: any): FindTenantResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new FindTenantResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['success'] = this.success;
    data['tenantId'] = this.tenantId;
    data['name'] = this.name;
    data['isActive'] = this.isActive;
    return data;
  }
}

export interface IFindTenantResultDto {
  success?: boolean;
  tenantId?: string | undefined;
  name?: string | undefined;
  isActive?: boolean;
}

export class MultiTenancyInfoDto implements IMultiTenancyInfoDto {
  isEnabled?: boolean;

  constructor(data?: IMultiTenancyInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.isEnabled = _data['isEnabled'];
    }
  }

  static fromJS(data: any): MultiTenancyInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new MultiTenancyInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['isEnabled'] = this.isEnabled;
    return data;
  }
}

export interface IMultiTenancyInfoDto {
  isEnabled?: boolean;
}

export class FeatureDto implements IFeatureDto {
  name?: string | undefined;
  displayName?: string | undefined;
  value?: string | undefined;
  provider?: FeatureProviderDto;
  description?: string | undefined;
  valueType?: IStringValueType;
  depth?: number;
  parentName?: string | undefined;

  constructor(data?: IFeatureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.displayName = _data['displayName'];
      this.value = _data['value'];
      this.provider = _data['provider']
        ? FeatureProviderDto.fromJS(_data['provider'])
        : <any>undefined;
      this.description = _data['description'];
      this.valueType = _data['valueType']
        ? IStringValueType.fromJS(_data['valueType'])
        : <any>undefined;
      this.depth = _data['depth'];
      this.parentName = _data['parentName'];
    }
  }

  static fromJS(data: any): FeatureDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeatureDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['value'] = this.value;
    data['provider'] = this.provider ? this.provider.toJSON() : <any>undefined;
    data['description'] = this.description;
    data['valueType'] = this.valueType ? this.valueType.toJSON() : <any>undefined;
    data['depth'] = this.depth;
    data['parentName'] = this.parentName;
    return data;
  }
}

export interface IFeatureDto {
  name?: string | undefined;
  displayName?: string | undefined;
  value?: string | undefined;
  provider?: FeatureProviderDto;
  description?: string | undefined;
  valueType?: IStringValueType;
  depth?: number;
  parentName?: string | undefined;
}

export class FeatureGroupDto implements IFeatureGroupDto {
  name?: string | undefined;
  displayName?: string | undefined;
  features?: FeatureDto[] | undefined;

  constructor(data?: IFeatureGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.displayName = _data['displayName'];
      if (Array.isArray(_data['features'])) {
        this.features = [] as any;
        for (let item of _data['features']) this.features!.push(FeatureDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): FeatureGroupDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeatureGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    if (Array.isArray(this.features)) {
      data['features'] = [];
      for (let item of this.features) data['features'].push(item.toJSON());
    }
    return data;
  }
}

export interface IFeatureGroupDto {
  name?: string | undefined;
  displayName?: string | undefined;
  features?: FeatureDto[] | undefined;
}

export class FeatureProviderDto implements IFeatureProviderDto {
  name?: string | undefined;
  key?: string | undefined;

  constructor(data?: IFeatureProviderDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.key = _data['key'];
    }
  }

  static fromJS(data: any): FeatureProviderDto {
    data = typeof data === 'object' ? data : {};
    let result = new FeatureProviderDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['key'] = this.key;
    return data;
  }
}

export interface IFeatureProviderDto {
  name?: string | undefined;
  key?: string | undefined;
}

export class GetFeatureListResultDto implements IGetFeatureListResultDto {
  groups?: FeatureGroupDto[] | undefined;

  constructor(data?: IGetFeatureListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['groups'])) {
        this.groups = [] as any;
        for (let item of _data['groups']) this.groups!.push(FeatureGroupDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetFeatureListResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetFeatureListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.groups)) {
      data['groups'] = [];
      for (let item of this.groups) data['groups'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetFeatureListResultDto {
  groups?: FeatureGroupDto[] | undefined;
}

export class UpdateFeatureDto implements IUpdateFeatureDto {
  name?: string | undefined;
  value?: string | undefined;

  constructor(data?: IUpdateFeatureDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): UpdateFeatureDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateFeatureDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['value'] = this.value;
    return data;
  }
}

export interface IUpdateFeatureDto {
  name?: string | undefined;
  value?: string | undefined;
}

export class UpdateFeaturesDto implements IUpdateFeaturesDto {
  features?: UpdateFeatureDto[] | undefined;

  constructor(data?: IUpdateFeaturesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['features'])) {
        this.features = [] as any;
        for (let item of _data['features']) this.features!.push(UpdateFeatureDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdateFeaturesDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateFeaturesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.features)) {
      data['features'] = [];
      for (let item of this.features) data['features'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdateFeaturesDto {
  features?: UpdateFeatureDto[] | undefined;
}

export class ActionApiDescriptionModel implements IActionApiDescriptionModel {
  uniqueName?: string | undefined;
  name?: string | undefined;
  httpMethod?: string | undefined;
  url?: string | undefined;
  supportedVersions?: string[] | undefined;
  parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
  parameters?: ParameterApiDescriptionModel[] | undefined;
  returnValue?: ReturnValueApiDescriptionModel;
  allowAnonymous?: boolean | undefined;

  constructor(data?: IActionApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.uniqueName = _data['uniqueName'];
      this.name = _data['name'];
      this.httpMethod = _data['httpMethod'];
      this.url = _data['url'];
      if (Array.isArray(_data['supportedVersions'])) {
        this.supportedVersions = [] as any;
        for (let item of _data['supportedVersions']) this.supportedVersions!.push(item);
      }
      if (Array.isArray(_data['parametersOnMethod'])) {
        this.parametersOnMethod = [] as any;
        for (let item of _data['parametersOnMethod'])
          this.parametersOnMethod!.push(MethodParameterApiDescriptionModel.fromJS(item));
      }
      if (Array.isArray(_data['parameters'])) {
        this.parameters = [] as any;
        for (let item of _data['parameters'])
          this.parameters!.push(ParameterApiDescriptionModel.fromJS(item));
      }
      this.returnValue = _data['returnValue']
        ? ReturnValueApiDescriptionModel.fromJS(_data['returnValue'])
        : <any>undefined;
      this.allowAnonymous = _data['allowAnonymous'];
    }
  }

  static fromJS(data: any): ActionApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ActionApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['uniqueName'] = this.uniqueName;
    data['name'] = this.name;
    data['httpMethod'] = this.httpMethod;
    data['url'] = this.url;
    if (Array.isArray(this.supportedVersions)) {
      data['supportedVersions'] = [];
      for (let item of this.supportedVersions) data['supportedVersions'].push(item);
    }
    if (Array.isArray(this.parametersOnMethod)) {
      data['parametersOnMethod'] = [];
      for (let item of this.parametersOnMethod) data['parametersOnMethod'].push(item.toJSON());
    }
    if (Array.isArray(this.parameters)) {
      data['parameters'] = [];
      for (let item of this.parameters) data['parameters'].push(item.toJSON());
    }
    data['returnValue'] = this.returnValue ? this.returnValue.toJSON() : <any>undefined;
    data['allowAnonymous'] = this.allowAnonymous;
    return data;
  }
}

export interface IActionApiDescriptionModel {
  uniqueName?: string | undefined;
  name?: string | undefined;
  httpMethod?: string | undefined;
  url?: string | undefined;
  supportedVersions?: string[] | undefined;
  parametersOnMethod?: MethodParameterApiDescriptionModel[] | undefined;
  parameters?: ParameterApiDescriptionModel[] | undefined;
  returnValue?: ReturnValueApiDescriptionModel;
  allowAnonymous?: boolean | undefined;
}

export class ApplicationApiDescriptionModel implements IApplicationApiDescriptionModel {
  modules?: { [key: string]: ModuleApiDescriptionModel } | undefined;
  types?: { [key: string]: TypeApiDescriptionModel } | undefined;

  constructor(data?: IApplicationApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['modules']) {
        this.modules = {} as any;
        for (let key in _data['modules']) {
          if (_data['modules'].hasOwnProperty(key))
            (<any>this.modules)![key] = _data['modules'][key]
              ? ModuleApiDescriptionModel.fromJS(_data['modules'][key])
              : new ModuleApiDescriptionModel();
        }
      }
      if (_data['types']) {
        this.types = {} as any;
        for (let key in _data['types']) {
          if (_data['types'].hasOwnProperty(key))
            (<any>this.types)![key] = _data['types'][key]
              ? TypeApiDescriptionModel.fromJS(_data['types'][key])
              : new TypeApiDescriptionModel();
        }
      }
    }
  }

  static fromJS(data: any): ApplicationApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ApplicationApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.modules) {
      data['modules'] = {};
      for (let key in this.modules) {
        if (this.modules.hasOwnProperty(key))
          (<any>data['modules'])[key] = this.modules[key]
            ? this.modules[key].toJSON()
            : <any>undefined;
      }
    }
    if (this.types) {
      data['types'] = {};
      for (let key in this.types) {
        if (this.types.hasOwnProperty(key))
          (<any>data['types'])[key] = this.types[key] ? this.types[key].toJSON() : <any>undefined;
      }
    }
    return data;
  }
}

export interface IApplicationApiDescriptionModel {
  modules?: { [key: string]: ModuleApiDescriptionModel } | undefined;
  types?: { [key: string]: TypeApiDescriptionModel } | undefined;
}

export class ControllerApiDescriptionModel implements IControllerApiDescriptionModel {
  controllerName?: string | undefined;
  type?: string | undefined;
  interfaces?: ControllerInterfaceApiDescriptionModel[] | undefined;
  actions?: { [key: string]: ActionApiDescriptionModel } | undefined;

  constructor(data?: IControllerApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.controllerName = _data['controllerName'];
      this.type = _data['type'];
      if (Array.isArray(_data['interfaces'])) {
        this.interfaces = [] as any;
        for (let item of _data['interfaces'])
          this.interfaces!.push(ControllerInterfaceApiDescriptionModel.fromJS(item));
      }
      if (_data['actions']) {
        this.actions = {} as any;
        for (let key in _data['actions']) {
          if (_data['actions'].hasOwnProperty(key))
            (<any>this.actions)![key] = _data['actions'][key]
              ? ActionApiDescriptionModel.fromJS(_data['actions'][key])
              : new ActionApiDescriptionModel();
        }
      }
    }
  }

  static fromJS(data: any): ControllerApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ControllerApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['controllerName'] = this.controllerName;
    data['type'] = this.type;
    if (Array.isArray(this.interfaces)) {
      data['interfaces'] = [];
      for (let item of this.interfaces) data['interfaces'].push(item.toJSON());
    }
    if (this.actions) {
      data['actions'] = {};
      for (let key in this.actions) {
        if (this.actions.hasOwnProperty(key))
          (<any>data['actions'])[key] = this.actions[key]
            ? this.actions[key].toJSON()
            : <any>undefined;
      }
    }
    return data;
  }
}

export interface IControllerApiDescriptionModel {
  controllerName?: string | undefined;
  type?: string | undefined;
  interfaces?: ControllerInterfaceApiDescriptionModel[] | undefined;
  actions?: { [key: string]: ActionApiDescriptionModel } | undefined;
}

export class ControllerInterfaceApiDescriptionModel
  implements IControllerInterfaceApiDescriptionModel
{
  type?: string | undefined;

  constructor(data?: IControllerInterfaceApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
    }
  }

  static fromJS(data: any): ControllerInterfaceApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ControllerInterfaceApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    return data;
  }
}

export interface IControllerInterfaceApiDescriptionModel {
  type?: string | undefined;
}

export class MethodParameterApiDescriptionModel implements IMethodParameterApiDescriptionModel {
  name?: string | undefined;
  typeAsString?: string | undefined;
  type?: string | undefined;
  typeSimple?: string | undefined;
  isOptional?: boolean;
  defaultValue?: any | undefined;

  constructor(data?: IMethodParameterApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.typeAsString = _data['typeAsString'];
      this.type = _data['type'];
      this.typeSimple = _data['typeSimple'];
      this.isOptional = _data['isOptional'];
      this.defaultValue = _data['defaultValue'];
    }
  }

  static fromJS(data: any): MethodParameterApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new MethodParameterApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['typeAsString'] = this.typeAsString;
    data['type'] = this.type;
    data['typeSimple'] = this.typeSimple;
    data['isOptional'] = this.isOptional;
    data['defaultValue'] = this.defaultValue;
    return data;
  }
}

export interface IMethodParameterApiDescriptionModel {
  name?: string | undefined;
  typeAsString?: string | undefined;
  type?: string | undefined;
  typeSimple?: string | undefined;
  isOptional?: boolean;
  defaultValue?: any | undefined;
}

export class ModuleApiDescriptionModel implements IModuleApiDescriptionModel {
  rootPath?: string | undefined;
  remoteServiceName?: string | undefined;
  controllers?: { [key: string]: ControllerApiDescriptionModel } | undefined;

  constructor(data?: IModuleApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.rootPath = _data['rootPath'];
      this.remoteServiceName = _data['remoteServiceName'];
      if (_data['controllers']) {
        this.controllers = {} as any;
        for (let key in _data['controllers']) {
          if (_data['controllers'].hasOwnProperty(key))
            (<any>this.controllers)![key] = _data['controllers'][key]
              ? ControllerApiDescriptionModel.fromJS(_data['controllers'][key])
              : new ControllerApiDescriptionModel();
        }
      }
    }
  }

  static fromJS(data: any): ModuleApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ModuleApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['rootPath'] = this.rootPath;
    data['remoteServiceName'] = this.remoteServiceName;
    if (this.controllers) {
      data['controllers'] = {};
      for (let key in this.controllers) {
        if (this.controllers.hasOwnProperty(key))
          (<any>data['controllers'])[key] = this.controllers[key]
            ? this.controllers[key].toJSON()
            : <any>undefined;
      }
    }
    return data;
  }
}

export interface IModuleApiDescriptionModel {
  rootPath?: string | undefined;
  remoteServiceName?: string | undefined;
  controllers?: { [key: string]: ControllerApiDescriptionModel } | undefined;
}

export class ParameterApiDescriptionModel implements IParameterApiDescriptionModel {
  nameOnMethod?: string | undefined;
  name?: string | undefined;
  jsonName?: string | undefined;
  type?: string | undefined;
  typeSimple?: string | undefined;
  isOptional?: boolean;
  defaultValue?: any | undefined;
  constraintTypes?: string[] | undefined;
  bindingSourceId?: string | undefined;
  descriptorName?: string | undefined;

  constructor(data?: IParameterApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.nameOnMethod = _data['nameOnMethod'];
      this.name = _data['name'];
      this.jsonName = _data['jsonName'];
      this.type = _data['type'];
      this.typeSimple = _data['typeSimple'];
      this.isOptional = _data['isOptional'];
      this.defaultValue = _data['defaultValue'];
      if (Array.isArray(_data['constraintTypes'])) {
        this.constraintTypes = [] as any;
        for (let item of _data['constraintTypes']) this.constraintTypes!.push(item);
      }
      this.bindingSourceId = _data['bindingSourceId'];
      this.descriptorName = _data['descriptorName'];
    }
  }

  static fromJS(data: any): ParameterApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ParameterApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['nameOnMethod'] = this.nameOnMethod;
    data['name'] = this.name;
    data['jsonName'] = this.jsonName;
    data['type'] = this.type;
    data['typeSimple'] = this.typeSimple;
    data['isOptional'] = this.isOptional;
    data['defaultValue'] = this.defaultValue;
    if (Array.isArray(this.constraintTypes)) {
      data['constraintTypes'] = [];
      for (let item of this.constraintTypes) data['constraintTypes'].push(item);
    }
    data['bindingSourceId'] = this.bindingSourceId;
    data['descriptorName'] = this.descriptorName;
    return data;
  }
}

export interface IParameterApiDescriptionModel {
  nameOnMethod?: string | undefined;
  name?: string | undefined;
  jsonName?: string | undefined;
  type?: string | undefined;
  typeSimple?: string | undefined;
  isOptional?: boolean;
  defaultValue?: any | undefined;
  constraintTypes?: string[] | undefined;
  bindingSourceId?: string | undefined;
  descriptorName?: string | undefined;
}

export class PropertyApiDescriptionModel implements IPropertyApiDescriptionModel {
  name?: string | undefined;
  jsonName?: string | undefined;
  type?: string | undefined;
  typeSimple?: string | undefined;
  isRequired?: boolean;

  constructor(data?: IPropertyApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.jsonName = _data['jsonName'];
      this.type = _data['type'];
      this.typeSimple = _data['typeSimple'];
      this.isRequired = _data['isRequired'];
    }
  }

  static fromJS(data: any): PropertyApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new PropertyApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['jsonName'] = this.jsonName;
    data['type'] = this.type;
    data['typeSimple'] = this.typeSimple;
    data['isRequired'] = this.isRequired;
    return data;
  }
}

export interface IPropertyApiDescriptionModel {
  name?: string | undefined;
  jsonName?: string | undefined;
  type?: string | undefined;
  typeSimple?: string | undefined;
  isRequired?: boolean;
}

export class ReturnValueApiDescriptionModel implements IReturnValueApiDescriptionModel {
  type?: string | undefined;
  typeSimple?: string | undefined;

  constructor(data?: IReturnValueApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.type = _data['type'];
      this.typeSimple = _data['typeSimple'];
    }
  }

  static fromJS(data: any): ReturnValueApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new ReturnValueApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['type'] = this.type;
    data['typeSimple'] = this.typeSimple;
    return data;
  }
}

export interface IReturnValueApiDescriptionModel {
  type?: string | undefined;
  typeSimple?: string | undefined;
}

export class TypeApiDescriptionModel implements ITypeApiDescriptionModel {
  baseType?: string | undefined;
  isEnum?: boolean;
  enumNames?: string[] | undefined;
  enumValues?: any[] | undefined;
  genericArguments?: string[] | undefined;
  properties?: PropertyApiDescriptionModel[] | undefined;

  constructor(data?: ITypeApiDescriptionModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.baseType = _data['baseType'];
      this.isEnum = _data['isEnum'];
      if (Array.isArray(_data['enumNames'])) {
        this.enumNames = [] as any;
        for (let item of _data['enumNames']) this.enumNames!.push(item);
      }
      if (Array.isArray(_data['enumValues'])) {
        this.enumValues = [] as any;
        for (let item of _data['enumValues']) this.enumValues!.push(item);
      }
      if (Array.isArray(_data['genericArguments'])) {
        this.genericArguments = [] as any;
        for (let item of _data['genericArguments']) this.genericArguments!.push(item);
      }
      if (Array.isArray(_data['properties'])) {
        this.properties = [] as any;
        for (let item of _data['properties'])
          this.properties!.push(PropertyApiDescriptionModel.fromJS(item));
      }
    }
  }

  static fromJS(data: any): TypeApiDescriptionModel {
    data = typeof data === 'object' ? data : {};
    let result = new TypeApiDescriptionModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['baseType'] = this.baseType;
    data['isEnum'] = this.isEnum;
    if (Array.isArray(this.enumNames)) {
      data['enumNames'] = [];
      for (let item of this.enumNames) data['enumNames'].push(item);
    }
    if (Array.isArray(this.enumValues)) {
      data['enumValues'] = [];
      for (let item of this.enumValues) data['enumValues'].push(item);
    }
    if (Array.isArray(this.genericArguments)) {
      data['genericArguments'] = [];
      for (let item of this.genericArguments) data['genericArguments'].push(item);
    }
    if (Array.isArray(this.properties)) {
      data['properties'] = [];
      for (let item of this.properties) data['properties'].push(item.toJSON());
    }
    return data;
  }
}

export interface ITypeApiDescriptionModel {
  baseType?: string | undefined;
  isEnum?: boolean;
  enumNames?: string[] | undefined;
  enumValues?: any[] | undefined;
  genericArguments?: string[] | undefined;
  properties?: PropertyApiDescriptionModel[] | undefined;
}

export class RemoteServiceErrorInfo implements IRemoteServiceErrorInfo {
  code?: string | undefined;
  message?: string | undefined;
  details?: string | undefined;
  data?: { [key: string]: any } | undefined;
  validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;

  constructor(data?: IRemoteServiceErrorInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.code = _data['code'];
      this.message = _data['message'];
      this.details = _data['details'];
      if (_data['data']) {
        this.data = {} as any;
        for (let key in _data['data']) {
          if (_data['data'].hasOwnProperty(key)) (<any>this.data)![key] = _data['data'][key];
        }
      }
      if (Array.isArray(_data['validationErrors'])) {
        this.validationErrors = [] as any;
        for (let item of _data['validationErrors'])
          this.validationErrors!.push(RemoteServiceValidationErrorInfo.fromJS(item));
      }
    }
  }

  static fromJS(data: any): RemoteServiceErrorInfo {
    data = typeof data === 'object' ? data : {};
    let result = new RemoteServiceErrorInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['code'] = this.code;
    data['message'] = this.message;
    data['details'] = this.details;
    if (this.data) {
      data['data'] = {};
      for (let key in this.data) {
        if (this.data.hasOwnProperty(key)) (<any>data['data'])[key] = this.data[key];
      }
    }
    if (Array.isArray(this.validationErrors)) {
      data['validationErrors'] = [];
      for (let item of this.validationErrors) data['validationErrors'].push(item.toJSON());
    }
    return data;
  }
}

export interface IRemoteServiceErrorInfo {
  code?: string | undefined;
  message?: string | undefined;
  details?: string | undefined;
  data?: { [key: string]: any } | undefined;
  validationErrors?: RemoteServiceValidationErrorInfo[] | undefined;
}

export class RemoteServiceErrorResponse implements IRemoteServiceErrorResponse {
  error?: RemoteServiceErrorInfo;

  constructor(data?: IRemoteServiceErrorResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.error = _data['error'] ? RemoteServiceErrorInfo.fromJS(_data['error']) : <any>undefined;
    }
  }

  static fromJS(data: any): RemoteServiceErrorResponse {
    data = typeof data === 'object' ? data : {};
    let result = new RemoteServiceErrorResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['error'] = this.error ? this.error.toJSON() : <any>undefined;
    return data;
  }
}

export interface IRemoteServiceErrorResponse {
  error?: RemoteServiceErrorInfo;
}

export class RemoteServiceValidationErrorInfo implements IRemoteServiceValidationErrorInfo {
  message?: string | undefined;
  members?: string[] | undefined;

  constructor(data?: IRemoteServiceValidationErrorInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.message = _data['message'];
      if (Array.isArray(_data['members'])) {
        this.members = [] as any;
        for (let item of _data['members']) this.members!.push(item);
      }
    }
  }

  static fromJS(data: any): RemoteServiceValidationErrorInfo {
    data = typeof data === 'object' ? data : {};
    let result = new RemoteServiceValidationErrorInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['message'] = this.message;
    if (Array.isArray(this.members)) {
      data['members'] = [];
      for (let item of this.members) data['members'].push(item);
    }
    return data;
  }
}

export interface IRemoteServiceValidationErrorInfo {
  message?: string | undefined;
  members?: string[] | undefined;
}

export class ChangePasswordInput implements IChangePasswordInput {
  currentPassword?: string | undefined;
  newPassword!: string;

  constructor(data?: IChangePasswordInput) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.currentPassword = _data['currentPassword'];
      this.newPassword = _data['newPassword'];
    }
  }

  static fromJS(data: any): ChangePasswordInput {
    data = typeof data === 'object' ? data : {};
    let result = new ChangePasswordInput();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['currentPassword'] = this.currentPassword;
    data['newPassword'] = this.newPassword;
    return data;
  }
}

export interface IChangePasswordInput {
  currentPassword?: string | undefined;
  newPassword: string;
}

export class IdentityRoleCreateDto implements IIdentityRoleCreateDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  name!: string;
  isDefault?: boolean;
  isPublic?: boolean;

  constructor(data?: IIdentityRoleCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.name = _data['name'];
      this.isDefault = _data['isDefault'];
      this.isPublic = _data['isPublic'];
    }
  }

  static fromJS(data: any): IdentityRoleCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityRoleCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['name'] = this.name;
    data['isDefault'] = this.isDefault;
    data['isPublic'] = this.isPublic;
    return data;
  }
}

export interface IIdentityRoleCreateDto {
  extraProperties?: { [key: string]: any } | undefined;
  name: string;
  isDefault?: boolean;
  isPublic?: boolean;
}

export class IdentityRoleDto implements IIdentityRoleDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  id?: string;
  name?: string | undefined;
  isDefault?: boolean;
  isStatic?: boolean;
  isPublic?: boolean;
  concurrencyStamp?: string | undefined;

  constructor(data?: IIdentityRoleDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.id = _data['id'];
      this.name = _data['name'];
      this.isDefault = _data['isDefault'];
      this.isStatic = _data['isStatic'];
      this.isPublic = _data['isPublic'];
      this.concurrencyStamp = _data['concurrencyStamp'];
    }
  }

  static fromJS(data: any): IdentityRoleDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityRoleDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['id'] = this.id;
    data['name'] = this.name;
    data['isDefault'] = this.isDefault;
    data['isStatic'] = this.isStatic;
    data['isPublic'] = this.isPublic;
    data['concurrencyStamp'] = this.concurrencyStamp;
    return data;
  }
}

export interface IIdentityRoleDto {
  extraProperties?: { [key: string]: any } | undefined;
  id?: string;
  name?: string | undefined;
  isDefault?: boolean;
  isStatic?: boolean;
  isPublic?: boolean;
  concurrencyStamp?: string | undefined;
}

export class IdentityRoleUpdateDto implements IIdentityRoleUpdateDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  name!: string;
  isDefault?: boolean;
  isPublic?: boolean;
  concurrencyStamp?: string | undefined;

  constructor(data?: IIdentityRoleUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.name = _data['name'];
      this.isDefault = _data['isDefault'];
      this.isPublic = _data['isPublic'];
      this.concurrencyStamp = _data['concurrencyStamp'];
    }
  }

  static fromJS(data: any): IdentityRoleUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityRoleUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['name'] = this.name;
    data['isDefault'] = this.isDefault;
    data['isPublic'] = this.isPublic;
    data['concurrencyStamp'] = this.concurrencyStamp;
    return data;
  }
}

export interface IIdentityRoleUpdateDto {
  extraProperties?: { [key: string]: any } | undefined;
  name: string;
  isDefault?: boolean;
  isPublic?: boolean;
  concurrencyStamp?: string | undefined;
}

export class IdentityUserCreateDto implements IIdentityUserCreateDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  userName!: string;
  name?: string | undefined;
  surname?: string | undefined;
  email!: string;
  phoneNumber?: string | undefined;
  lockoutEnabled?: boolean;
  roleNames?: string[] | undefined;
  password!: string;

  constructor(data?: IIdentityUserCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.phoneNumber = _data['phoneNumber'];
      this.lockoutEnabled = _data['lockoutEnabled'];
      if (Array.isArray(_data['roleNames'])) {
        this.roleNames = [] as any;
        for (let item of _data['roleNames']) this.roleNames!.push(item);
      }
      this.password = _data['password'];
    }
  }

  static fromJS(data: any): IdentityUserCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityUserCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['phoneNumber'] = this.phoneNumber;
    data['lockoutEnabled'] = this.lockoutEnabled;
    if (Array.isArray(this.roleNames)) {
      data['roleNames'] = [];
      for (let item of this.roleNames) data['roleNames'].push(item);
    }
    data['password'] = this.password;
    return data;
  }
}

export interface IIdentityUserCreateDto {
  extraProperties?: { [key: string]: any } | undefined;
  userName: string;
  name?: string | undefined;
  surname?: string | undefined;
  email: string;
  phoneNumber?: string | undefined;
  lockoutEnabled?: boolean;
  roleNames?: string[] | undefined;
  password: string;
}

export class IdentityUserDto implements IIdentityUserDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  tenantId?: string | undefined;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
  lockoutEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  concurrencyStamp?: string | undefined;

  constructor(data?: IIdentityUserDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.id = _data['id'];
      this.creationTime = _data['creationTime']
        ? new Date(_data['creationTime'].toString())
        : <any>undefined;
      this.creatorId = _data['creatorId'];
      this.lastModificationTime = _data['lastModificationTime']
        ? new Date(_data['lastModificationTime'].toString())
        : <any>undefined;
      this.lastModifierId = _data['lastModifierId'];
      this.isDeleted = _data['isDeleted'];
      this.deleterId = _data['deleterId'];
      this.deletionTime = _data['deletionTime']
        ? new Date(_data['deletionTime'].toString())
        : <any>undefined;
      this.tenantId = _data['tenantId'];
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.emailConfirmed = _data['emailConfirmed'];
      this.phoneNumber = _data['phoneNumber'];
      this.phoneNumberConfirmed = _data['phoneNumberConfirmed'];
      this.lockoutEnabled = _data['lockoutEnabled'];
      this.lockoutEnd = _data['lockoutEnd']
        ? new Date(_data['lockoutEnd'].toString())
        : <any>undefined;
      this.concurrencyStamp = _data['concurrencyStamp'];
    }
  }

  static fromJS(data: any): IdentityUserDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityUserDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['id'] = this.id;
    data['creationTime'] = this.creationTime ? this.creationTime.toISOString() : <any>undefined;
    data['creatorId'] = this.creatorId;
    data['lastModificationTime'] = this.lastModificationTime
      ? this.lastModificationTime.toISOString()
      : <any>undefined;
    data['lastModifierId'] = this.lastModifierId;
    data['isDeleted'] = this.isDeleted;
    data['deleterId'] = this.deleterId;
    data['deletionTime'] = this.deletionTime ? this.deletionTime.toISOString() : <any>undefined;
    data['tenantId'] = this.tenantId;
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['emailConfirmed'] = this.emailConfirmed;
    data['phoneNumber'] = this.phoneNumber;
    data['phoneNumberConfirmed'] = this.phoneNumberConfirmed;
    data['lockoutEnabled'] = this.lockoutEnabled;
    data['lockoutEnd'] = this.lockoutEnd ? this.lockoutEnd.toISOString() : <any>undefined;
    data['concurrencyStamp'] = this.concurrencyStamp;
    return data;
  }
}

export interface IIdentityUserDto {
  extraProperties?: { [key: string]: any } | undefined;
  id?: string;
  creationTime?: Date;
  creatorId?: string | undefined;
  lastModificationTime?: Date | undefined;
  lastModifierId?: string | undefined;
  isDeleted?: boolean;
  deleterId?: string | undefined;
  deletionTime?: Date | undefined;
  tenantId?: string | undefined;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
  lockoutEnabled?: boolean;
  lockoutEnd?: Date | undefined;
  concurrencyStamp?: string | undefined;
}

export class IdentityUserUpdateDto implements IIdentityUserUpdateDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  userName!: string;
  name?: string | undefined;
  surname?: string | undefined;
  email!: string;
  phoneNumber?: string | undefined;
  lockoutEnabled?: boolean;
  roleNames?: string[] | undefined;
  password?: string | undefined;
  concurrencyStamp?: string | undefined;

  constructor(data?: IIdentityUserUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.phoneNumber = _data['phoneNumber'];
      this.lockoutEnabled = _data['lockoutEnabled'];
      if (Array.isArray(_data['roleNames'])) {
        this.roleNames = [] as any;
        for (let item of _data['roleNames']) this.roleNames!.push(item);
      }
      this.password = _data['password'];
      this.concurrencyStamp = _data['concurrencyStamp'];
    }
  }

  static fromJS(data: any): IdentityUserUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityUserUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['phoneNumber'] = this.phoneNumber;
    data['lockoutEnabled'] = this.lockoutEnabled;
    if (Array.isArray(this.roleNames)) {
      data['roleNames'] = [];
      for (let item of this.roleNames) data['roleNames'].push(item);
    }
    data['password'] = this.password;
    data['concurrencyStamp'] = this.concurrencyStamp;
    return data;
  }
}

export interface IIdentityUserUpdateDto {
  extraProperties?: { [key: string]: any } | undefined;
  userName: string;
  name?: string | undefined;
  surname?: string | undefined;
  email: string;
  phoneNumber?: string | undefined;
  lockoutEnabled?: boolean;
  roleNames?: string[] | undefined;
  password?: string | undefined;
  concurrencyStamp?: string | undefined;
}

export class IdentityUserUpdateRolesDto implements IIdentityUserUpdateRolesDto {
  roleNames!: string[];

  constructor(data?: IIdentityUserUpdateRolesDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
    if (!data) {
      this.roleNames = [];
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['roleNames'])) {
        this.roleNames = [] as any;
        for (let item of _data['roleNames']) this.roleNames!.push(item);
      }
    }
  }

  static fromJS(data: any): IdentityUserUpdateRolesDto {
    data = typeof data === 'object' ? data : {};
    let result = new IdentityUserUpdateRolesDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.roleNames)) {
      data['roleNames'] = [];
      for (let item of this.roleNames) data['roleNames'].push(item);
    }
    return data;
  }
}

export interface IIdentityUserUpdateRolesDto {
  roleNames: string[];
}

export class ProfileDto implements IProfileDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  phoneNumber?: string | undefined;
  isExternal?: boolean;
  hasPassword?: boolean;

  constructor(data?: IProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.userName = _data['userName'];
      this.email = _data['email'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.phoneNumber = _data['phoneNumber'];
      this.isExternal = _data['isExternal'];
      this.hasPassword = _data['hasPassword'];
    }
  }

  static fromJS(data: any): ProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['userName'] = this.userName;
    data['email'] = this.email;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['phoneNumber'] = this.phoneNumber;
    data['isExternal'] = this.isExternal;
    data['hasPassword'] = this.hasPassword;
    return data;
  }
}

export interface IProfileDto {
  extraProperties?: { [key: string]: any } | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  phoneNumber?: string | undefined;
  isExternal?: boolean;
  hasPassword?: boolean;
}

export class UpdateProfileDto implements IUpdateProfileDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  phoneNumber?: string | undefined;

  constructor(data?: IUpdateProfileDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.userName = _data['userName'];
      this.email = _data['email'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.phoneNumber = _data['phoneNumber'];
    }
  }

  static fromJS(data: any): UpdateProfileDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdateProfileDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['userName'] = this.userName;
    data['email'] = this.email;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['phoneNumber'] = this.phoneNumber;
    return data;
  }
}

export interface IUpdateProfileDto {
  extraProperties?: { [key: string]: any } | undefined;
  userName?: string | undefined;
  email?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  phoneNumber?: string | undefined;
}

export class LanguageInfo implements ILanguageInfo {
  readonly cultureName?: string | undefined;
  readonly uiCultureName?: string | undefined;
  readonly displayName?: string | undefined;
  flagIcon?: string | undefined;

  constructor(data?: ILanguageInfo) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).cultureName = _data['cultureName'];
      (<any>this).uiCultureName = _data['uiCultureName'];
      (<any>this).displayName = _data['displayName'];
      this.flagIcon = _data['flagIcon'];
    }
  }

  static fromJS(data: any): LanguageInfo {
    data = typeof data === 'object' ? data : {};
    let result = new LanguageInfo();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['cultureName'] = this.cultureName;
    data['uiCultureName'] = this.uiCultureName;
    data['displayName'] = this.displayName;
    data['flagIcon'] = this.flagIcon;
    return data;
  }
}

export interface ILanguageInfo {
  cultureName?: string | undefined;
  uiCultureName?: string | undefined;
  displayName?: string | undefined;
  flagIcon?: string | undefined;
}

export class NameValue implements INameValue {
  name?: string | undefined;
  value?: string | undefined;

  constructor(data?: INameValue) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.value = _data['value'];
    }
  }

  static fromJS(data: any): NameValue {
    data = typeof data === 'object' ? data : {};
    let result = new NameValue();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['value'] = this.value;
    return data;
  }
}

export interface INameValue {
  name?: string | undefined;
  value?: string | undefined;
}

export class GetPermissionListResultDto implements IGetPermissionListResultDto {
  entityDisplayName?: string | undefined;
  groups?: PermissionGroupDto[] | undefined;

  constructor(data?: IGetPermissionListResultDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.entityDisplayName = _data['entityDisplayName'];
      if (Array.isArray(_data['groups'])) {
        this.groups = [] as any;
        for (let item of _data['groups']) this.groups!.push(PermissionGroupDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetPermissionListResultDto {
    data = typeof data === 'object' ? data : {};
    let result = new GetPermissionListResultDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['entityDisplayName'] = this.entityDisplayName;
    if (Array.isArray(this.groups)) {
      data['groups'] = [];
      for (let item of this.groups) data['groups'].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetPermissionListResultDto {
  entityDisplayName?: string | undefined;
  groups?: PermissionGroupDto[] | undefined;
}

export class PermissionGrantInfoDto implements IPermissionGrantInfoDto {
  name?: string | undefined;
  displayName?: string | undefined;
  parentName?: string | undefined;
  isGranted?: boolean;
  allowedProviders?: string[] | undefined;
  grantedProviders?: ProviderInfoDto[] | undefined;

  constructor(data?: IPermissionGrantInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.displayName = _data['displayName'];
      this.parentName = _data['parentName'];
      this.isGranted = _data['isGranted'];
      if (Array.isArray(_data['allowedProviders'])) {
        this.allowedProviders = [] as any;
        for (let item of _data['allowedProviders']) this.allowedProviders!.push(item);
      }
      if (Array.isArray(_data['grantedProviders'])) {
        this.grantedProviders = [] as any;
        for (let item of _data['grantedProviders'])
          this.grantedProviders!.push(ProviderInfoDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PermissionGrantInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionGrantInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    data['parentName'] = this.parentName;
    data['isGranted'] = this.isGranted;
    if (Array.isArray(this.allowedProviders)) {
      data['allowedProviders'] = [];
      for (let item of this.allowedProviders) data['allowedProviders'].push(item);
    }
    if (Array.isArray(this.grantedProviders)) {
      data['grantedProviders'] = [];
      for (let item of this.grantedProviders) data['grantedProviders'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPermissionGrantInfoDto {
  name?: string | undefined;
  displayName?: string | undefined;
  parentName?: string | undefined;
  isGranted?: boolean;
  allowedProviders?: string[] | undefined;
  grantedProviders?: ProviderInfoDto[] | undefined;
}

export class PermissionGroupDto implements IPermissionGroupDto {
  name?: string | undefined;
  displayName?: string | undefined;
  permissions?: PermissionGrantInfoDto[] | undefined;

  constructor(data?: IPermissionGroupDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.displayName = _data['displayName'];
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions'])
          this.permissions!.push(PermissionGrantInfoDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): PermissionGroupDto {
    data = typeof data === 'object' ? data : {};
    let result = new PermissionGroupDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['displayName'] = this.displayName;
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item.toJSON());
    }
    return data;
  }
}

export interface IPermissionGroupDto {
  name?: string | undefined;
  displayName?: string | undefined;
  permissions?: PermissionGrantInfoDto[] | undefined;
}

export class ProviderInfoDto implements IProviderInfoDto {
  providerName?: string | undefined;
  providerKey?: string | undefined;

  constructor(data?: IProviderInfoDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.providerName = _data['providerName'];
      this.providerKey = _data['providerKey'];
    }
  }

  static fromJS(data: any): ProviderInfoDto {
    data = typeof data === 'object' ? data : {};
    let result = new ProviderInfoDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['providerName'] = this.providerName;
    data['providerKey'] = this.providerKey;
    return data;
  }
}

export interface IProviderInfoDto {
  providerName?: string | undefined;
  providerKey?: string | undefined;
}

export class UpdatePermissionDto implements IUpdatePermissionDto {
  name?: string | undefined;
  isGranted?: boolean;

  constructor(data?: IUpdatePermissionDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data['name'];
      this.isGranted = _data['isGranted'];
    }
  }

  static fromJS(data: any): UpdatePermissionDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdatePermissionDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    data['isGranted'] = this.isGranted;
    return data;
  }
}

export interface IUpdatePermissionDto {
  name?: string | undefined;
  isGranted?: boolean;
}

export class UpdatePermissionsDto implements IUpdatePermissionsDto {
  permissions?: UpdatePermissionDto[] | undefined;

  constructor(data?: IUpdatePermissionsDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (Array.isArray(_data['permissions'])) {
        this.permissions = [] as any;
        for (let item of _data['permissions'])
          this.permissions!.push(UpdatePermissionDto.fromJS(item));
      }
    }
  }

  static fromJS(data: any): UpdatePermissionsDto {
    data = typeof data === 'object' ? data : {};
    let result = new UpdatePermissionsDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (Array.isArray(this.permissions)) {
      data['permissions'] = [];
      for (let item of this.permissions) data['permissions'].push(item.toJSON());
    }
    return data;
  }
}

export interface IUpdatePermissionsDto {
  permissions?: UpdatePermissionDto[] | undefined;
}

export class TenantCreateDto implements ITenantCreateDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  name!: string;
  adminEmailAddress!: string;
  adminPassword!: string;

  constructor(data?: ITenantCreateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.name = _data['name'];
      this.adminEmailAddress = _data['adminEmailAddress'];
      this.adminPassword = _data['adminPassword'];
    }
  }

  static fromJS(data: any): TenantCreateDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantCreateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['name'] = this.name;
    data['adminEmailAddress'] = this.adminEmailAddress;
    data['adminPassword'] = this.adminPassword;
    return data;
  }
}

export interface ITenantCreateDto {
  extraProperties?: { [key: string]: any } | undefined;
  name: string;
  adminEmailAddress: string;
  adminPassword: string;
}

export class TenantDto implements ITenantDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  id?: string;
  name?: string | undefined;

  constructor(data?: ITenantDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.id = _data['id'];
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): TenantDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['id'] = this.id;
    data['name'] = this.name;
    return data;
  }
}

export interface ITenantDto {
  extraProperties?: { [key: string]: any } | undefined;
  id?: string;
  name?: string | undefined;
}

export class TenantUpdateDto implements ITenantUpdateDto {
  readonly extraProperties?: { [key: string]: any } | undefined;
  name!: string;

  constructor(data?: ITenantUpdateDto) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      if (_data['extraProperties']) {
        (<any>this).extraProperties = {} as any;
        for (let key in _data['extraProperties']) {
          if (_data['extraProperties'].hasOwnProperty(key))
            (<any>(<any>this).extraProperties)![key] = _data['extraProperties'][key];
        }
      }
      this.name = _data['name'];
    }
  }

  static fromJS(data: any): TenantUpdateDto {
    data = typeof data === 'object' ? data : {};
    let result = new TenantUpdateDto();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    if (this.extraProperties) {
      data['extraProperties'] = {};
      for (let key in this.extraProperties) {
        if (this.extraProperties.hasOwnProperty(key))
          (<any>data['extraProperties'])[key] = this.extraProperties[key];
      }
    }
    data['name'] = this.name;
    return data;
  }
}

export interface ITenantUpdateDto {
  extraProperties?: { [key: string]: any } | undefined;
  name: string;
}

export class UserData implements IUserData {
  id?: string;
  tenantId?: string | undefined;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;

  constructor(data?: IUserData) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.id = _data['id'];
      this.tenantId = _data['tenantId'];
      this.userName = _data['userName'];
      this.name = _data['name'];
      this.surname = _data['surname'];
      this.email = _data['email'];
      this.emailConfirmed = _data['emailConfirmed'];
      this.phoneNumber = _data['phoneNumber'];
      this.phoneNumberConfirmed = _data['phoneNumberConfirmed'];
    }
  }

  static fromJS(data: any): UserData {
    data = typeof data === 'object' ? data : {};
    let result = new UserData();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['id'] = this.id;
    data['tenantId'] = this.tenantId;
    data['userName'] = this.userName;
    data['name'] = this.name;
    data['surname'] = this.surname;
    data['email'] = this.email;
    data['emailConfirmed'] = this.emailConfirmed;
    data['phoneNumber'] = this.phoneNumber;
    data['phoneNumberConfirmed'] = this.phoneNumberConfirmed;
    return data;
  }
}

export interface IUserData {
  id?: string;
  tenantId?: string | undefined;
  userName?: string | undefined;
  name?: string | undefined;
  surname?: string | undefined;
  email?: string | undefined;
  emailConfirmed?: boolean;
  phoneNumber?: string | undefined;
  phoneNumberConfirmed?: boolean;
}

export class IStringValueType implements IIStringValueType {
  readonly name?: string | undefined;
  readonly properties?: { [key: string]: any } | undefined;
  validator?: IValueValidator;

  constructor(data?: IIStringValueType) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).name = _data['name'];
      if (_data['properties']) {
        (<any>this).properties = {} as any;
        for (let key in _data['properties']) {
          if (_data['properties'].hasOwnProperty(key))
            (<any>(<any>this).properties)![key] = _data['properties'][key];
        }
      }
      this.validator = _data['validator']
        ? IValueValidator.fromJS(_data['validator'])
        : <any>undefined;
    }
  }

  static fromJS(data: any): IStringValueType {
    data = typeof data === 'object' ? data : {};
    let result = new IStringValueType();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    if (this.properties) {
      data['properties'] = {};
      for (let key in this.properties) {
        if (this.properties.hasOwnProperty(key))
          (<any>data['properties'])[key] = this.properties[key];
      }
    }
    data['validator'] = this.validator ? this.validator.toJSON() : <any>undefined;
    return data;
  }
}

export interface IIStringValueType {
  name?: string | undefined;
  properties?: { [key: string]: any } | undefined;
  validator?: IValueValidator;
}

export class IValueValidator implements IIValueValidator {
  readonly name?: string | undefined;
  readonly properties?: { [key: string]: any } | undefined;

  constructor(data?: IIValueValidator) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      (<any>this).name = _data['name'];
      if (_data['properties']) {
        (<any>this).properties = {} as any;
        for (let key in _data['properties']) {
          if (_data['properties'].hasOwnProperty(key))
            (<any>(<any>this).properties)![key] = _data['properties'][key];
        }
      }
    }
  }

  static fromJS(data: any): IValueValidator {
    data = typeof data === 'object' ? data : {};
    let result = new IValueValidator();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data['name'] = this.name;
    if (this.properties) {
      data['properties'] = {};
      for (let key in this.properties) {
        if (this.properties.hasOwnProperty(key))
          (<any>data['properties'])[key] = this.properties[key];
      }
    }
    return data;
  }
}

export interface IIValueValidator {
  name?: string | undefined;
  properties?: { [key: string]: any } | undefined;
}

export interface FileParameter {
  data: any;
  fileName: string;
}

export class ApiException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (status === 401) {
    localStorage.clear();
    window.location.replace('/authorize/login');
    return;
  }
  if (result !== null && result !== undefined) return _observableThrow(result);
  else return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = event => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
